(function(){
const ASSETS=window.__HOOD_ASSETS__;
const HB_STAGE=`
<div class="stage">
<div class="veil" id="veil">Choose your vehicle to see the preview</div>
<div class="cap" id="cap" hidden>
</div>
</div>
`;
const HB_STEPS=`
<div class="hb-head">
<p class="hb-title">Build your hood decal</p>
<p class="hb-sub">Pick your hood, choose a design, and set your colours \u2014 the preview updates live.</p>
</div>
<div id="steps">
<section class="step" id="s1">
<h2>
<b>1</b> Choose your vehicle
    <button class="sum" type="button" id="s1sum" hidden>
<span id="s1txt">
</span>
<i>&#9662;</i>
</button>
</h2>
<div class="in" id="s1in">
<div class="grp">
<div class="lb">Year</div>
<select id="year">
</select>
</div>
<div class="grp" id="g-model" hidden>
<div class="lb">Model</div>
<select id="model">
</select>
</div>
<div class="grp" id="g-trim" hidden>
<div class="lb">Trim</div>
<select id="trim">
</select>
</div>
<div id="hoodwrap" hidden>
<div class="lb" style="margin-top:12px">Your hood</div>
<div id="hoodconfirm">
<p class="hint" style="margin-top:0">Based on your selection, this is your hood:</p>
<div class="lb" id="hoodguess">
</div>
<div class="row" style="margin-top:8px">
<button class="opt" type="button" id="hoodyes">Yes, that's my hood</button>
<button class="opt" type="button" id="hoodno">No \u2014 show other hoods</button>
</div>
</div>
<div id="hoodpick" hidden>
<div class="lb">Pick your hood shape</div>
<div class="hoodgrid" id="g-hood">
</div>
<p class="hint">Choose the shape that matches your vehicle, then confirm.</p>
<div class="row" style="margin-top:8px">
<button class="opt" type="button" id="hoodconfirm2">Confirm this hood</button>
</div>
</div>
<div id="hooddone" hidden>
<span class="pill" id="hoodlabel">
</span>
<button class="opt" type="button" id="hoodreset" style="margin-left:6px">Change</button>
</div>
</div>
<div id="vehcol" hidden>
<div class="lb" style="margin-top:14px">Your vehicle colour</div>
<div class="row" id="g-veh">
</div>
<p class="hint">Preview only \u2014 we do not colour match your paint.</p>
<button class="opt big" type="button" id="s1next" hidden style="margin-top:12px">Next step \u2014 choose your design</button>
</div>
</div>
</section>
<section class="step locked" id="s4">
<h2>
<b>2</b> Choose your decal design</h2>
<div class="in">
<div class="grp" id="modewrap">
<button class="opt big" type="button" data-k="mode" data-v="library">Ready Designs \u2014 Pick from CARCODE Designs Library <span class="from" id="from-lib">Starts from $99</span></button>
<button class="opt big" type="button" data-k="mode" data-v="custom">Build your own personalized design <span class="from" id="from-cus">Starts from $149</span></button>
</div>
<div class="grp" id="packwrap" hidden>
<div class="lb">What would you like?</div>
<div class="row" id="g-pack">
</div>
</div>
<div class="grp" id="g-lib" hidden>
<div class="lb">Hood decal design</div>
<p class="matchnote" id="sideoknote" hidden>With hood side decals, these are the hood designs made to go with them. For any other hood design, order the hood decal and the side decals separately.</p>
<div class="row" id="g-des">
</div>
<div class="setnote" id="setnote-h" hidden></div>
<div id="wrap-border2">
<div class="lb" style="margin-top:12px">Border</div>
<div class="row" id="g-border2">
</div>
</div>
</div>
<div class="grp" id="g-sidelib" hidden>
<div class="lb">Hood side decal design</div>
<p class="matchnote" id="matchnote" hidden><span class="match">\u2605 Matching set</span> These side decals were designed together with the hood decal you picked, for a complete look.</p>
<div class="row" id="g-side">
</div>
<div class="setnote" id="setnote-s" hidden></div>
</div>
<div class="grp" id="g-custom" hidden>
<div class="lb" style="font-size:14px">Hood decal \u2014 your artwork</div>
<div id="wrap-border">
<div class="lb">Outline border</div>
<div class="row" id="g-border">
</div>
</div>
<div class="lb" style="margin-top:12px">Upload your image or logo</div>
<input type="file" id="cfile" accept="image/*,.pdf,.ai,.eps,.svg">
<div id="imgctl" hidden>
<p class="dragnote">Drag your image on the preview to place it.</p>
<div class="lb" style="margin-top:8px">Image size <span class="num" id="isizen">100%</span>
</div>
<input type="range" id="isize" min="20" max="250" value="100" style="width:100%">
<div class="lb" style="margin-top:8px">Image rotation <span class="num" id="irotn">0\u00b0</span>
</div>
<input type="range" id="irot" min="-180" max="180" value="0" style="width:100%">
</div>
<p class="hint">Vector preferred (AI, EPS, SVG, PDF). High-resolution PNG or JPG also works.</p>
</div>
<div class="grp" id="g-scustom" hidden>
<div class="lb" style="font-size:14px" id="scus-title">Hood side decals \u2014 your artwork</div>
<p class="hint" id="scus-textonly" hidden>Personalized hood side decals are made with your own text: add it in step 4. It goes on both sides, mirrored.</p>
<div id="scus-upload">
<div class="lb" style="margin-top:8px">Upload your image or logo for the side decals</div>
<input type="file" id="sfile" accept="image/*,.pdf,.ai,.eps,.svg">
<p class="hint">It goes on both sides, mirrored.</p>
</div>
<div id="sictl" hidden>
<p class="dragnote">Drag it on either side panel; the other side follows, mirrored.</p>
<div class="lb" style="margin-top:8px">Image size <span class="num" id="sisizen">100%</span>
</div>
<input type="range" id="sisize" min="20" max="250" value="100" style="width:100%">
<div class="lb" style="margin-top:8px">Image rotation <span class="num" id="sirotn">0\u00b0</span>
</div>
<input type="range" id="sirot" min="-180" max="180" value="0" style="width:100%">
</div>
</div>
<div class="grp" id="g-cdesc" hidden>
<div class="promise">You will receive a full mockup designed for your approval
      before printing or production.</div>
<div class="lb" style="margin-top:12px">Describe what you want</div>
<textarea id="cdesc" rows="5" placeholder="Anything we should know that the options above don't cover. For example:&#10;- Match the style of the decals already on my truck (photo attached)&#10;- Keep my logo's original colours exactly as supplied&#10;- Give the artwork a worn, distressed finish&#10;- Mirror the logo so it reads correctly from the driver's seat&#10;- Use my brand font \u2014 file attached&#10;- Leave the area around the hood scoop uncovered">
</textarea>
</div>
</section>
<section class="step locked" id="s5">
<h2>
<b>3</b> Choose your decal colours</h2>
<div class="in">
<div class="grp" id="wrap-main">
<div class="lb" id="lb-main">Vinyl colour (main)</div>
<div class="row" id="g-main">
</div>
</div>
<div class="grp" id="wrap-acc">
<div class="lb"><span id="lb-acc">Graphics colour</span><span class="imgnote" id="accnote" hidden> \u2014 your uploaded artwork keeps its own colours in the preview; we apply this colour for you in the mockup.</span>
</div>
<div class="row" id="g-acc">
</div>
</div>
<div class="grp" id="wrap-acc2" hidden>
<div class="lb">2nd graphics colour</div>
<div class="row" id="g-acc2">
</div>
</div>
<div class="grp" id="wrap-bcol" hidden>
<div class="lb">Border colour</div>
<div class="row" id="g-bcol">
</div>
</div>
<div class="grp" id="wrap-scol" hidden>
<div class="lb">Hood side decals colour</div>
<div class="row" id="g-scol">
</div>
</div>
<p class="hint">Cut-out exposes your vehicle colour.</p>
</div>
</section>
<section class="step locked" id="s7">
<h2>
<b>4</b> Add your own text</h2>
<div class="in">
<div id="htextwrap">
<div class="lb" id="htextlb">Add text</div>
<div class="row" id="g-addtext">
</div>
<div class="grp" id="textblock" hidden>
<div class="lb">What would you like on the vinyl?</div>
<div class="row" id="g-txtsrc">
</div>
<div id="typewrap">
<div class="lb" style="margin-top:12px">Your text</div>
<input type="text" id="ctext" placeholder="e.g. 1941, your name, a slogan">
<p class="dragnote">Drag the text on the preview to place it anywhere on the vinyl.</p>
<div class="lb" style="margin-top:12px">Font</div>
<select id="cfont">
</select>
<input type="text" id="cfontother" placeholder="Font name, e.g. Bebas Neue, Anton, Oswald" hidden style="margin-top:6px">
<p class="hint" id="fonthint" hidden>Type any Google Font name and the preview updates. Other fonts are noted on your order.</p>
</div>
<div id="popwrap" hidden>
<div class="lb" style="margin-top:12px">Popular text for your Dodge / Ram</div>
<div class="badgerow" id="g-badge">
</div>
<p class="dragnote">Drag it on the preview, and use its handles to turn or resize it.</p>
</div>
<div class="lb" style="margin-top:14px">Colour style</div>
<div class="row" id="g-txtduo">
</div>
<div id="tcolwrap">
<div class="lb" style="margin-top:10px">Fill colour</div>
<div class="row" id="g-tcol2">
</div>
<div id="toutwrap" hidden>
<div class="lb" style="margin-top:8px">Outline colour</div>
<div class="row" id="g-tout">
</div>
</div>
</div>
<div class="lb" style="margin-top:12px">Size <span class="num" id="csizen">100%</span>
</div>
<input type="range" id="csize" min="40" max="220" value="100" style="width:100%">
<div class="lb" style="margin-top:8px">Rotation <span class="num" id="crotn">0\u00b0</span>
</div>
<input type="range" id="crot" min="-180" max="180" value="0" style="width:100%">
</div>
</div>
<div id="stextwrap" hidden style="margin-top:16px">
<div class="lb">Text on the hood side decals</div>
<div class="row" id="g-saddtext">
</div>
<div class="grp" id="stextblock" hidden>
<div class="lb" style="margin-top:10px">Your text</div>
<input type="text" id="stext" placeholder="e.g. RAM, your name, a slogan">
<p class="hint">It appears on both side decals, mirrored.</p>
<p class="dragnote">Drag the text on either side panel; the other side follows.</p>
<div class="lb" style="margin-top:12px">Font</div>
<select id="sfont">
</select>
<input type="text" id="sfontother" placeholder="Font name, e.g. Bebas Neue, Anton, Oswald" hidden style="margin-top:6px">
<p class="hint" id="sfonthint" hidden>Type any Google Font name and the preview updates. Other fonts are noted on your order.</p>
<div class="lb" style="margin-top:14px">Colour style</div>
<div class="row" id="g-sduo">
</div>
<div class="lb" style="margin-top:10px">Fill colour</div>
<div class="row" id="g-stcol">
</div>
<div id="stoutwrap" hidden>
<div class="lb" style="margin-top:8px">Outline colour</div>
<div class="row" id="g-stout">
</div>
</div>
<div class="lb" style="margin-top:12px">Size <span class="num" id="ssizen">100%</span>
</div>
<input type="range" id="ssize" min="40" max="220" value="100" style="width:100%">
<div class="lb" style="margin-top:8px">Rotation <span class="num" id="srotn">0\u00b0</span>
</div>
<input type="range" id="srot" min="-180" max="180" value="0" style="width:100%">
</div>
</div>
</section>
<div class="tot">
<div class="amt" id="price">$99.00</div>
<code id="spec">Complete the steps above.</code>
</div>
`;
(function place(){
  const root=document.getElementById('hood-builder-root');
  root.className='hood-builder';
  root.innerHTML='<div class="hb-grid"><div class="hb-col-preview">'+HB_STAGE+'</div>'+
                 '<div class="hb-col-steps">'+HB_STEPS+'</div></div>';
  function widen(){
    try{
      // hide a media column that has no photos
      document.querySelectorAll('[class*="media"]').forEach(el=>{
        if(el===root||el.contains(root)) return;
        const cls=el.className||'';
        if(typeof cls==='string' && /media-(wrapper|list|gallery)|product__media/.test(cls)
           && !el.querySelector('img,video,model-viewer,iframe')) el.style.display='none';
      });
      // walk up from the builder and let every wrapper span the full row
      let el=root, guard=0;
      while(el && el!==document.body && guard++<12){
        const cs=getComputedStyle(el);
        el.style.setProperty('max-width','100%','important');
        el.style.setProperty('width','100%','important');
        el.style.setProperty('flex','1 1 100%','important');
        el.style.setProperty('grid-column','1 / -1','important');
        if(cs.display==='grid'||cs.display==='flex'){
          el.style.setProperty('grid-template-columns','1fr','important');
        }
        if(/page-width|shopify-section/.test(el.className||'')) break;
        el=el.parentElement;
      }
    }catch(e){}
  }
  widen(); setTimeout(widen,300); window.addEventListener('load',widen);
})();

const D={
 "fit": {
  "models": {
   "ram1500": {
    "label": "Ram 1500"
   },
   "challenger": {
    "label": "Dodge Challenger"
   }
  },
  "years": {
   "2019": [
    "ram1500",
    "challenger"
   ],
   "2020": [
    "ram1500",
    "challenger"
   ],
   "2021": [
    "ram1500",
    "challenger"
   ],
   "2022": [
    "ram1500",
    "challenger"
   ],
   "2023": [
    "ram1500",
    "challenger"
   ],
   "2024": [
    "ram1500"
   ],
   "2025": [
    "ram1500"
   ],
   "2026": [
    "ram1500"
   ]
  },
  "trims": {
   "ram1500": [
    {
     "id": "tradesman",
     "label": "Tradesman",
     "r": [
      [
       2019,
       2026
      ]
     ],
     "hood": "ram19",
     "note": ""
    },
    {
     "id": "tradesmanhfe",
     "label": "Tradesman HFE",
     "r": [
      [
       2025,
       2026
      ]
     ],
     "hood": "ram19",
     "note": ""
    },
    {
     "id": "bighorn",
     "label": "Big Horn (Lone Star)",
     "r": [
      [
       2019,
       2026
      ]
     ],
     "hood": "ram19",
     "note": ""
    },
    {
     "id": "laramie",
     "label": "Laramie",
     "r": [
      [
       2019,
       2026
      ]
     ],
     "hood": "ram19",
     "note": ""
    },
    {
     "id": "laramielonghorn",
     "label": "Laramie Longhorn",
     "r": [
      [
       2019,
       2020
      ]
     ],
     "hood": "ram19",
     "note": ""
    },
    {
     "id": "limitedlonghorn",
     "label": "Limited Longhorn",
     "r": [
      [
       2021,
       2026
      ]
     ],
     "hood": "ram19",
     "note": ""
    },
    {
     "id": "limited",
     "label": "Limited",
     "r": [
      [
       2019,
       2026
      ]
     ],
     "hood": "ram19",
     "note": ""
    },
    {
     "id": "tungsten",
     "label": "Tungsten",
     "r": [
      [
       2025,
       2026
      ]
     ],
     "hood": "ram19",
     "note": ""
    },
    {
     "id": "rebel",
     "label": "Rebel",
     "r": [
      [
       2019,
       2026
      ]
     ],
     "hood": "ramtrx",
     "note": ""
    },
    {
     "id": "sportappearance",
     "label": "Sport Appearance Package (Big Horn / Laramie)",
     "r": [
      [
       2019,
       2024
      ]
     ],
     "hood": "ramtrx",
     "note": ""
    },
    {
     "id": "nightedition",
     "label": "Night Edition (Big Horn / Laramie / Limited)",
     "r": [
      [
       2019,
       2024
      ]
     ],
     "hood": "ramtrx",
     "note": ""
    },
    {
     "id": "warlock",
     "label": "Warlock",
     "r": [
      [
       2025,
       2026
      ]
     ],
     "hood": "ramtrx",
     "note": ""
    },
    {
     "id": "trx",
     "label": "TRX",
     "r": [
      [
       2021,
       2024
      ]
     ],
     "hood": "ram25",
     "note": ""
    },
    {
     "id": "trxfinal",
     "label": "TRX Final Edition",
     "r": [
      [
       2024,
       2024
      ]
     ],
     "hood": "ram25",
     "note": ""
    },
    {
     "id": "rho",
     "label": "RHO",
     "r": [
      [
       2025,
       2026
      ]
     ],
     "hood": "ram25",
     "note": ""
    }
   ],
   "challenger": [
    {
     "id": "srthellcat",
     "label": "SRT Hellcat",
     "r": [
      [
       2019,
       2023
      ]
     ],
     "hood": "chal",
     "note": ""
    },
    {
     "id": "srthellcatredeye",
     "label": "SRT Hellcat Redeye",
     "r": [
      [
       2019,
       2023
      ]
     ],
     "hood": "chal",
     "note": ""
    },
    {
     "id": "srtsuperstock",
     "label": "SRT Super Stock",
     "r": [
      [
       2020,
       2023
      ]
     ],
     "hood": "chal",
     "note": ""
    },
    {
     "id": "blackghost",
     "label": "Black Ghost",
     "r": [
      [
       2023,
       2023
      ]
     ],
     "hood": "chal",
     "note": ""
    }
   ]
  }
 },
 "hoods": {
  "ram1500": [
   [
    "ram19",
    "Ram 1500 Standard Hood (no vents)"
   ],
   [
    "ramtrx",
    "Ram 1500 Sport Performance Hood (2 small vents)"
   ],
   [
    "ram25",
    "Ram 1500 TRX / RHO Hood (center scoop + 2 extractors)"
   ]
  ],
  "challenger": [
   [
    "chal",
    "Challenger Dual-Snorkel Hood"
   ]
  ]
 },
 "thumbs": {}
};
const FAM={};
const LOADED={};
async function loadFam(f){
  if(LOADED[f]) return LOADED[f];
  LOADED[f]=(async()=>{
    let j;
    try{
      // the library can be handed over directly (no fetch - some sandboxes block data: URLs)
      // a hood with its own fitted library uses it; the rest share the plain one
      if(window.__HOOD_LIBS__ && window.__HOOD_LIBS__[f]) j=window.__HOOD_LIBS__[f];
      // a big fitted library can live in its own file next to the page, loaded when that hood is picked
      else if(ASSETS[f] && ASSETS[f].lib){ const r=await fetch(ASSETS[f].lib,{cache:"force-cache"}); if(!r.ok) throw new Error("library "+r.status); j=await r.json(); }
      else if(window.__HOOD_LIB__) j=window.__HOOD_LIB__;
      else { const r=await fetch(ASSETS[f].json,{cache:"force-cache"}); j=await r.json(); }
    }
    catch(e){
      console.error("hood assets failed for "+f,e);
      const v=$("veil"); if(v){ v.hidden=false; v.textContent="Could not load the design library."; }
      LOADED[f]=null; throw e;
    }
    FAM[f]=j.meta;
    const div=document.createElement("div"); div.className="veh"; div.dataset.fam=f; div.hidden=true;
    const A=ASSETS[f]||{};
    // one shared design library serves every hood: re-prefix its ids for this family,
    // and apply this hood's own placement rectangle
    let layers=String(j.layers).split("_f150_").join("_"+f+"_")
                               .split('data-fam="f150"').join('data-fam="'+f+'"');
    // the hood decals and the hood-side decals land on different parts of the hood, so
    // each group has its own rectangle. A hood without its own side numbers reuses the
    // hood one rather than rendering nothing.
    if(A.place)     layers=layers.split("__PL_HOOD__").join(A.place);
    if(A.placeSide||A.place) layers=layers.split("__PL_SIDE__").join(A.placeSide||A.place);
    j=Object.assign({}, j, {layers:layers});
    div.innerHTML = (A.base
      ? `<img src="${A.base}" alt="Hood"><div class="paint" style="-webkit-mask-image:url(${A.mask});mask-image:url(${A.mask})"><img class="sh" src="${A.shade}" alt=""><img class="sp" src="${A.spec}" alt=""></div>`
      : `<div class="paint nophoto"></div>`) +
      // decals sit under the cowl, wipers and windshield: only the painted body shows them
      (A.base ? `<div class="decals" style="-webkit-mask-image:url(${A.dmask||A.mask});mask-image:url(${A.dmask||A.mask})">${layers}</div>` : layers);
    const st=document.querySelector(".stage"); st.insertBefore(div,$("veil"));
    // light the vinyl with the hood's own light and shadow, so it reads as a decal on
    // the paint rather than a flat cut-out on top. The light is clipped to the pixels the
    // vinyl actually covers, so cut-outs and bare paint are untouched.
    if(A.light){
      const sv=div.querySelector("svg.decal");
      const vb=String(sv&&sv.getAttribute("viewBox")||"").split(/[\s,]+/).map(Number);
      const pl={}; String(A.place||"").replace(/(left|top|width|height):\s*(-?[\d.]+)%/g,(m,k,v)=>{pl[k]=+v/100;});
      if(vb.length===4 && pl.width && pl.height){
        const ix=vb[0]-pl.left/pl.width*vb[2], iw=vb[2]/pl.width;
        const iy=vb[1]-pl.top/pl.height*vb[3], ih=vb[3]/pl.height;
        const fs=document.createElementNS("http://www.w3.org/2000/svg","svg");
        fs.setAttribute("width","0"); fs.setAttribute("height","0"); fs.setAttribute("aria-hidden","true");
        fs.style.position="absolute";
        fs.innerHTML=`<filter id="lt_${f}" filterUnits="userSpaceOnUse" primitiveUnits="userSpaceOnUse" `+
          `x="${ix}" y="${iy}" width="${iw}" height="${ih}" color-interpolation-filters="sRGB">`+
          (A.vshade ? `<feImage href="${A.vshade}" xlink:href="${A.vshade}" x="${ix}" y="${iy}" width="${iw}" height="${ih}" preserveAspectRatio="none" result="V"/>`+
            `<feComposite in="V" in2="SourceAlpha" operator="in" result="Vm"/>`+
            `<feBlend in="SourceGraphic" in2="Vm" mode="multiply" result="SG0"/>`+
            `<feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0.3 0.59 0.11 0 0" result="W0"/>`+
            `<feComponentTransfer in="W0" result="W"><feFuncA type="gamma" amplitude="1" exponent="${A.vkeep||4}" offset="0"/></feComponentTransfer>`+
            `<feComposite in="SourceGraphic" in2="W" operator="in" result="SW"/>`+
            `<feComposite in="SW" in2="SG0" operator="over" result="SG"/>` : "")+
          `<feImage href="${A.light}" xlink:href="${A.light}" x="${ix}" y="${iy}" width="${iw}" height="${ih}" preserveAspectRatio="none" result="L"/>`+
          `<feComposite in="L" in2="SourceAlpha" operator="in" result="Lm"/>`+
          `<feBlend in="${A.vshade?"SG":"SourceGraphic"}" in2="Lm" mode="screen"/></filter>`;
        div.appendChild(fs);
        div.querySelectorAll("svg.decal .solid").forEach(g=>g.setAttribute("filter","url(#lt_"+f+")"));
      }
    }
    return j;
  })();
  return LOADED[f];
}
let fam="ram19";
const COL0=[{id:"black",label:"Black",hex:"#1C1C1C"},{id:"beige",label:"Beige",hex:"#EAE0C8"},{id:"blue",label:"Blue",hex:"#1C659D"},{id:"bronze",label:"Bronze",hex:"#825A3F"},{id:"brown",label:"Brown",hex:"#5E3A21"},{id:"dark_green",label:"Dark Green",hex:"#004726"},{id:"dark_grey",label:"Dark Grey",hex:"#555555"},{id:"dark_orange",label:"Dark Orange",hex:"#F26522"},{id:"dark_red",label:"Dark Red",hex:"#B21F29"},{id:"gold",label:"Gold",hex:"#9D814B"},{id:"green",label:"Green",hex:"#00945E"},{id:"grey",label:"Grey",hex:"#808080"},{id:"hot_pink",label:"Hot Pink",hex:"#EC008C"},{id:"intense_blue",label:"Intense Blue",hex:"#21409A"},{id:"light_blue",label:"Light Blue",hex:"#00AEEF"},{id:"light_grey",label:"Light Grey",hex:"#D3D3D3"},{id:"olive",label:"Olive",hex:"#999B50"},{id:"orange",label:"Orange",hex:"#F7941D"},{id:"pink",label:"Pink",hex:"#F49AC1"},{id:"red",label:"Red",hex:"#ED1C24"},{id:"teal",label:"Teal",hex:"#1A8CA1"},{id:"violet",label:"Violet",hex:"#4B3C76"},{id:"white",label:"White",hex:"#FFFFFF"},{id:"yellow",label:"Yellow",hex:"#FFDE00"}];
const PAINT={"bright_white": ["Bright White", "#F3F4F2"], "ivory": ["Ivory Tri-Coat", "#E9E5DA"], "billet_silver": ["Billet Silver", "#A9ACAF"], "granite": ["Granite Crystal", "#4B4E52"], "destroyer_grey": ["Destroyer Grey", "#6E7276"], "smoke_show": ["Smoke Show", "#9AA0A6"], "diamond_black": ["Diamond Black", "#111214"], "flame_red": ["Flame Red", "#C3141E"], "torred": ["TorRed", "#D42E1E"], "delmonico": ["Delmonico Red", "#7A1F22"], "go_mango": ["Go Mango", "#E8641B"], "patriot_blue": ["Patriot Blue", "#1F2F5A"], "hydro_blue": ["Hydro Blue", "#2C78C0"], "plum_crazy": ["Plum Crazy", "#4E2A63"], "f8_green": ["F8 Green", "#364B33"], "sublime": ["Sublime", "#86C440"]};
const DODGE_PAINT=["bright_white", "ivory", "billet_silver", "granite", "destroyer_grey", "smoke_show", "diamond_black", "flame_red", "torred", "delmonico", "go_mango", "patriot_blue", "hydro_blue", "plum_crazy", "f8_green", "sublime"];
const VEHSETS={ram19:DODGE_PAINT,ramtrx:DODGE_PAINT,ram25:DODGE_PAINT,chal:DODGE_PAINT};
const OTHER={id:"other",label:"Other \u2014 type a colour",other:true,hex:"#888888"};
function vehList(){return (VEHSETS[fam]||DODGE_PAINT).map(id=>({id,label:PAINT[id][0],hex:PAINT[id][1]})).concat([OTHER]);}
function cssColour(s){ if(!s) return null; let v=String(s).trim(); if(!v) return null;
  let h=v.replace(/^#/,""); if(/^[0-9a-f]{3}$/i.test(h)) h=h.split("").map(c=>c+c).join("");
  if(/^[0-9a-f]{6}$/i.test(h)) return "#"+h.toLowerCase();
  const t=document.createElement("span"); t.style.color=""; t.style.color=v;
  if(!t.style.color) return null;
  document.body.appendChild(t); const c=getComputedStyle(t).color||t.style.color; t.remove();
  const m=c&&c.match(/rgba?\((\d+)[,\s]+(\d+)[,\s]+(\d+)/);
  if(m) return "#"+[1,2,3].map(i=>(+m[i]).toString(16).padStart(2,"0")).join("");
  const hm=c&&c.match(/^#([0-9a-f]{3,6})$/i); if(hm) return c.toLowerCase();
  return null; }
function pick(list,key){ const o=list.find(c=>c.id===S[key]); if(!o) return null;
  if(o.other){ const hx=cssColour(S[key+"_txt"]); return {id:"other",label:(S[key+"_txt"]||"custom"),hex:hx||"#888888",unknown:!hx}; }
  return o; }
let VEH=vehList();
const COL=COL0.concat([OTHER]);
const SRCSEL=[{id:"type",label:"Type my own text"},{id:"popular",label:"Popular Dodge / Ram text"}];
const DUO=[{id:"one",label:"Single colour"},{id:"two",label:"Two colours (outline + fill)"}];
const CUT={id:"cutout",label:"Cut-out \u2014 no vinyl here, your paint shows through. Cut for you, ready to install.",cut:true};
const FONTS=[["Impact, sans-serif","Impact \u2014 bold condensed"],
 ["'Arial Black', Arial, sans-serif","Arial Black \u2014 heavy"],
 ["'Franklin Gothic Medium','Arial Narrow',sans-serif","Franklin Gothic"],
 ["'Arial Narrow', Arial, sans-serif","Arial Narrow"],
 ["Arial, Helvetica, sans-serif","Arial"],
 ["'Helvetica Neue', Helvetica, sans-serif","Helvetica"],
 ["Verdana, sans-serif","Verdana"],
 ["Tahoma, sans-serif","Tahoma"],
 ["'Trebuchet MS', sans-serif","Trebuchet"],
 ["'Century Gothic','Questrial',sans-serif","Century Gothic"],
 ["Georgia, serif","Georgia \u2014 serif"],
 ["'Times New Roman', Times, serif","Times New Roman"],
 ["Garamond, serif","Garamond"],
 ["'Palatino Linotype', Palatino, serif","Palatino"],
 ["'Courier New', monospace","Courier \u2014 stencil feel"],
 ["'Lucida Console', monospace","Lucida Console"],
 ["'Copperplate','Copperplate Gothic Light',serif","Copperplate"],
 ["'Brush Script MT', cursive","Brush Script"],
 ["'Segoe Script','Bradley Hand',cursive","Segoe Script"]];
const VIN=[CUT].concat(COL);
// outline colours: the paint colours plus cut-out (an outline of bare paint around coloured letters)
const TOUT=[CUT].concat(COL0);
const BORDER=[{id:"no",label:"No border"},{id:"yes",label:"Add border"}];
const ADDT=[{id:"no",label:"No text"},{id:"yes",label:"Add text  +$20"}];
const ADDT_FREE=[{id:"no",label:"No text"},{id:"yes",label:"Add text (included)"}];
let ORDERK=[];
let UIMG=null, UIW=0, UIH=0;
let SIMG=null, SIW=0, SIH=0;     // the side-decal artwork (personalised side decals)
const sideImgOK=()=>!(FAM[fam]&&FAM[fam].sideNoImage);   // 2021+ side decals: text only
const BADGES={"ram1500":{"label":"RAM 1500","vb":"2.6 2.6 546.4 72.8","outer":["M372.2 73.9C371.8 73.9 362.8 73.8 352.4 73.8C332.2 73.7 332.2 73.7 330.0 73.2C327.8 72.7 325.7 71.8 324.0 70.7C322.4 69.7 320.6 67.7 319.9 66.3L319.6 65.7L316.6 65.7L313.5 65.7L313.5 67.2C313.4 68.4 313.4 68.9 313.2 69.5C312.5 71.5 311.4 72.7 309.5 73.4L308.6 73.7L297.6 73.7C285.5 73.7 285.8 73.7 284.3 73.1C283.2 72.5 282.4 71.5 282.1 70.3C282.0 70.0 282.0 69.1 281.9 68.1C281.8 66.4 281.7 65.9 281.3 65.8C281.3 65.7 271.3 65.7 259.1 65.7L237.1 65.7L236.8 67.2C236.4 70.0 236.0 71.3 235.1 72.2C234.6 72.8 233.9 73.1 232.7 73.4L231.8 73.6L183.3 73.7L134.8 73.7L134.3 73.4C133.4 72.9 133.0 72.3 131.9 69.7C131.1 67.6 130.8 67.0 130.2 66.4C129.4 65.6 130.8 65.7 113.8 65.7C99.1 65.7 98.7 65.7 98.3 65.9C97.5 66.3 97.0 67.0 95.6 69.6C94.2 72.4 93.5 73.4 92.8 73.6C92.5 73.7 59.0 74.0 54.7 73.9L51.9 73.8L51.3 73.5C49.5 72.7 47.3 70.5 41.6 64.0C37.6 59.5 35.8 57.6 34.7 56.6C33.6 55.7 33.3 55.5 33.1 55.7C32.9 55.9 32.9 57.8 33.0 60.3C33.4 66.2 33.3 70.8 32.6 72.2C32.3 72.7 31.6 73.2 30.9 73.5C30.1 73.7 24.4 73.8 14.8 73.8L6.8 73.8L6.3 73.5C5.5 73.1 4.7 72.3 4.3 71.6L4.0 71.0L4.0 38.5L4.0 6.0L4.3 5.3C4.7 4.7 5.1 4.4 5.7 4.2C6.2 4.1 58.4 4.1 60.0 4.2C65.5 4.7 70.2 6.4 74.2 9.4C76.4 11.1 78.8 13.9 80.4 16.5C82.6 20.3 84.2 25.4 84.5 29.4C84.5 30.5 84.6 30.7 85.1 30.3C85.7 29.7 86.8 27.9 90.1 21.9C94.9 13.4 97.1 9.8 99.3 7.0C100.2 5.9 101.6 4.6 102.1 4.3L102.6 4.1L115.4 4.1L128.2 4.1L128.6 4.6C129.9 6.2 131.8 9.5 138.1 21.4C143.9 32.3 146.2 36.1 147.1 36.6C147.4 36.8 147.7 36.5 147.9 35.7C148.4 34.0 148.5 31.8 148.6 19.6C148.7 13.0 148.7 8.4 148.8 7.8C149.0 5.7 149.3 4.5 149.6 4.2C149.9 4.0 175.4 4.0 176.2 4.2C177.3 4.4 177.8 4.7 178.2 5.5C179.7 7.7 183.3 14.4 189.2 25.4C190.4 27.6 191.5 29.8 191.8 30.3L192.2 31.1L193.3 29.2C193.9 28.1 195.1 26.0 195.9 24.5C198.3 20.4 202.3 13.5 203.8 10.8C204.6 9.5 205.6 7.7 206.1 6.8C207.2 4.9 207.4 4.6 208.1 4.3L208.6 4.0L222.1 4.0C233.6 4.0 235.6 4.1 235.7 4.2C236.0 4.4 236.3 5.0 236.6 6.0L236.8 7.0L236.9 14.3L236.9 21.7L237.3 22.0L237.6 22.4L253.9 22.4L270.2 22.4L274.9 18.2C281.3 12.5 287.2 7.3 289.2 5.5L290.8 4.1L299.9 4.1C307.9 4.2 309.0 4.2 309.4 4.3C311.3 5.0 312.3 6.1 312.8 8.1C313.0 8.8 313.0 9.3 313.3 12.0C313.3 12.9 313.3 12.9 315.0 13.0C315.8 13.0 316.9 13.0 317.5 13.0L318.6 12.9L318.6 10.4C318.7 8.3 318.7 7.8 318.9 7.2C319.3 5.8 319.8 4.9 320.7 4.5L321.2 4.2L324.2 4.1C325.9 4.0 341.0 4.0 357.8 4.0C382.7 4.0 388.4 4.1 388.6 4.2C390.0 4.8 390.7 7.0 390.7 10.9L390.7 12.9L391.8 12.9C393.5 13.0 393.4 13.0 393.7 12.0C393.9 11.0 394.6 9.6 395.2 8.7C396.4 6.9 398.6 5.3 401.0 4.7C403.0 4.1 401.2 4.1 430.5 4.1C457.2 4.1 457.5 4.1 458.6 4.3C461.8 4.8 464.6 6.3 466.6 8.4C467.6 9.4 468.3 10.4 469.0 11.8L469.5 12.8L469.9 12.1C470.6 10.6 471.6 9.3 472.9 8.1C474.8 6.4 478.1 4.8 481.0 4.3C481.7 4.1 484.1 4.1 507.2 4.1L532.6 4.2L533.6 4.4C538.4 5.5 541.9 7.9 544.5 11.7C546.2 14.2 547.3 17.0 547.5 19.7C547.6 20.4 547.6 27.5 547.6 38.9C547.6 58.6 547.6 58.0 547.0 60.5C546.2 63.8 544.8 66.2 542.4 68.6C541.4 69.6 540.8 70.2 540.0 70.7C537.4 72.4 534.7 73.4 531.8 73.7C531.2 73.8 522.1 73.8 505.1 73.8C482.3 73.8 479.2 73.8 478.2 73.6C475.6 73.3 473.6 72.4 472.1 70.9C470.8 69.7 470.0 68.4 469.6 66.6L469.5 65.8L469.4 66.5C469.1 68.8 467.5 70.7 464.9 72.1C463.3 72.8 461.2 73.5 459.3 73.7C458.6 73.8 451.0 73.8 430.7 73.8L403.1 73.8L401.9 73.4C399.6 72.8 397.8 71.8 396.2 70.3C395.1 69.3 394.3 68.2 393.5 66.7C393.0 65.6 392.8 65.4 392.4 65.1C392.0 64.9 391.0 64.9 390.6 65.1C390.5 65.2 389.9 65.8 389.4 66.5C385.6 71.2 380.5 73.7 374.4 73.9C373.7 74.0 372.7 73.9 372.2 73.9ZM435.7 44.5C435.9 44.4 436.2 44.1 436.3 43.9L436.6 43.6L436.6 39.8L436.6 35.9L436.3 35.5C435.8 34.8 435.8 34.8 431.1 34.7C426.7 34.7 426.4 34.7 425.9 35.2C425.3 35.7 425.3 35.7 425.2 39.2C425.2 40.9 425.2 42.6 425.2 43.0C425.3 43.9 425.8 44.5 426.6 44.7C426.8 44.7 428.8 44.8 431.1 44.8C435.2 44.8 435.3 44.7 435.7 44.5ZM512.0 44.3C512.2 44.2 512.4 44.0 512.6 43.8L512.9 43.5L512.9 39.7C512.9 37.6 512.9 35.9 512.9 35.7C512.8 35.4 512.3 34.9 511.9 34.7C511.5 34.5 511.1 34.5 507.3 34.5C503.7 34.5 503.0 34.5 502.7 34.7C502.3 34.9 502.0 35.1 501.8 35.5C501.6 35.9 501.6 36.2 501.6 39.5C501.6 43.2 501.6 43.4 502.0 43.9C502.6 44.5 502.4 44.5 507.2 44.5C511.1 44.5 511.7 44.5 512.0 44.3ZM117.1 43.6C117.1 43.4 115.1 39.8 114.7 39.3C114.6 39.2 114.5 39.1 114.4 39.1C114.3 39.2 113.7 40.1 113.1 41.1C112.5 42.2 111.9 43.1 111.9 43.2C111.8 43.3 111.8 43.4 111.8 43.5C111.9 43.7 112.2 43.7 114.5 43.7C116.6 43.7 117.0 43.7 117.1 43.6Z"],"inner":["M13.1 64.6C12.9 64.4 12.7 64.2 12.6 64.0C12.4 63.7 12.4 62.7 12.4 49.0C12.4 32.8 12.4 33.9 13.0 33.5C13.3 33.3 13.7 33.3 19.6 33.3C25.6 33.3 26.0 33.3 26.3 33.5C26.9 33.9 26.9 32.8 26.9 49.0C26.9 62.8 26.9 63.7 26.7 64.0C26.6 64.2 26.4 64.4 26.3 64.5C26.0 64.7 25.9 64.8 19.7 64.8L13.4 64.8L13.1 64.6Z","M42.3 52.2L30.2 39.9L30.2 38.9L30.2 37.9L41.3 37.9C53.4 37.9 53.0 37.9 54.2 37.3C55.4 36.7 56.7 35.2 57.2 33.7C58.0 31.7 58.0 29.2 57.2 27.5C56.5 25.9 55.2 24.8 53.4 24.2C52.8 24.1 51.6 24.0 33.0 24.0L13.3 23.9L13.0 23.7C12.5 23.4 12.5 23.1 12.5 18.0C12.5 13.5 12.6 13.4 12.8 13.1C12.9 13.0 13.1 12.8 13.3 12.7C13.6 12.5 14.9 12.5 35.9 12.5C60.3 12.5 58.6 12.5 61.1 13.1C68.6 15.1 73.6 21.1 74.5 29.1C74.7 30.4 74.6 32.8 74.4 34.2C73.1 41.5 68.4 47.1 61.6 49.3C61.2 49.5 60.8 49.6 60.8 49.6C60.8 49.7 63.8 52.6 67.5 56.2C71.2 59.8 74.3 62.9 74.4 63.1C74.6 63.4 74.5 64.0 74.3 64.2C74.2 64.3 73.9 64.4 73.7 64.5C73.5 64.6 70.2 64.6 63.8 64.6L54.3 64.6L42.3 52.2Z","M77.2 64.8C76.4 64.6 76.2 64.1 76.4 63.3C76.5 63.1 83.3 51.9 91.5 38.4C99.7 24.8 106.5 13.5 106.6 13.3C107.2 12.3 106.6 12.4 114.4 12.4C122.2 12.4 121.6 12.3 122.2 13.2C122.3 13.5 129.2 25.0 137.4 38.7C151.8 62.9 152.2 63.7 152.2 64.1C152.2 64.6 152.2 64.7 152.0 64.8C151.8 64.9 150.2 64.9 144.0 64.9C136.8 64.9 136.2 64.8 136.0 64.7C135.8 64.6 135.1 63.3 134.0 61.3C132.5 58.6 132.2 58.1 131.9 57.9L131.5 57.6L114.2 57.6C104.7 57.6 96.8 57.6 96.6 57.7C96.5 57.7 96.2 57.8 96.0 58.0C95.8 58.1 95.0 59.5 94.0 61.2C93.0 62.9 92.1 64.4 92.0 64.5L91.7 64.8L84.6 64.9C80.7 64.9 77.4 64.8 77.2 64.8ZM125.1 48.5C125.8 48.1 126.0 47.6 125.6 46.8C125.4 46.2 115.6 29.2 115.2 28.7C114.4 27.7 113.6 27.8 112.9 28.9C112.7 29.2 112.2 30.2 111.7 31.1C111.1 31.9 108.9 35.9 106.6 39.8C104.3 43.7 102.4 47.1 102.3 47.3C102.2 47.8 102.3 48.2 102.8 48.4C103.1 48.6 103.9 48.6 114.0 48.6C121.9 48.6 125.0 48.6 125.1 48.5Z","M212.8 65.2C212.7 65.2 212.5 65.0 212.4 64.8C212.3 64.6 212.2 64.0 212.2 54.6C212.2 45.5 212.2 44.5 212.0 44.4C211.8 44.1 211.3 44.2 211.0 44.5C210.8 44.7 208.4 48.9 205.7 53.9C199.7 64.9 200.1 64.2 199.8 64.5L199.5 64.8L192.3 64.8L185.1 64.8L184.6 64.6C184.4 64.5 184.0 64.2 183.9 64.0C183.7 63.7 181.3 59.3 178.5 54.2C175.8 49.1 173.4 44.8 173.3 44.7C173.2 44.6 173.0 44.5 172.9 44.4C172.6 44.4 172.5 44.4 172.3 44.6L172.1 44.9L172.0 54.6L171.9 64.2L171.6 64.5L171.3 64.8L164.7 64.8C157.3 64.8 157.6 64.8 157.3 64.1C157.1 63.7 157.1 63.0 157.1 38.5C157.1 14.9 157.1 13.4 157.3 13.1C157.4 12.9 157.6 12.7 157.7 12.6C158.1 12.4 170.9 12.4 171.5 12.6C171.8 12.7 172.1 12.9 172.3 13.1C172.5 13.3 175.8 19.3 181.5 30.0C186.4 39.1 190.5 46.7 190.7 46.9C191.0 47.3 191.6 47.7 192.0 47.7C192.4 47.7 192.9 47.5 193.2 47.1C193.4 47.0 197.6 39.4 202.7 30.3C207.7 21.2 211.9 13.6 212.1 13.4C212.3 13.2 212.6 12.9 212.9 12.7L213.3 12.4L220.3 12.4C225.0 12.4 227.3 12.4 227.6 12.5C227.9 12.6 228.1 12.7 228.2 12.9C228.4 13.2 228.4 13.6 228.4 39.0L228.4 64.7L228.2 65.0L227.9 65.2L220.5 65.3C216.3 65.3 213.0 65.3 212.8 65.2Z","M291.8 65.6C291.3 65.4 291.0 65.0 290.9 64.6C290.8 64.4 290.8 57.7 290.8 46.2C290.8 30.0 290.8 28.2 290.6 28.1C290.4 27.8 290.2 27.9 289.7 28.4C288.8 29.3 288.1 29.6 287.5 29.3C287.1 29.1 281.2 23.4 281.0 23.1C280.9 22.8 280.9 22.5 281.0 22.2C281.2 21.8 290.8 13.2 291.4 12.9L291.9 12.7L298.3 12.6C302.5 12.6 304.9 12.6 305.1 12.7C305.3 12.7 305.6 12.9 305.8 13.1L306.1 13.4L306.1 39.1C306.1 67.6 306.2 65.3 305.4 65.6C305.0 65.8 292.2 65.8 291.8 65.6Z","M338.2 65.4C335.8 64.8 333.3 63.8 331.5 62.6C330.2 61.7 328.4 59.9 327.6 58.7C326.2 56.6 325.4 54.1 325.2 51.6C325.2 50.4 325.3 50.1 325.7 49.9C325.9 49.8 328.3 49.8 333.0 49.8C340.9 49.8 340.6 49.8 340.8 50.5C341.0 51.4 341.5 52.2 342.1 52.8C342.9 53.4 343.4 53.8 344.2 53.9C344.5 54.0 348.5 54.0 355.2 54.0C365.3 54.0 365.7 54.0 366.2 53.8C367.3 53.4 368.0 53.0 368.9 52.1C370.8 50.2 371.4 47.8 370.6 45.6C370.0 44.0 368.7 42.7 366.9 42.0L366.4 41.8L346.7 41.7C327.9 41.7 327.0 41.6 326.6 41.5C325.8 41.1 325.9 42.3 325.9 27.0C325.9 11.8 325.8 13.0 326.6 12.6C327.0 12.4 327.8 12.4 355.1 12.4C385.2 12.4 383.5 12.4 383.9 12.9C384.1 13.1 384.2 13.3 384.2 18.2C384.2 23.6 384.2 23.8 383.8 24.0C383.6 24.1 378.7 24.2 362.6 24.2L341.6 24.2L341.3 24.5L341.1 24.8L341.1 27.6C341.1 29.3 341.1 30.4 341.2 30.5C341.5 31.0 341.0 31.0 355.9 31.0L369.7 31.0L371.0 31.3C378.3 32.8 383.3 37.2 384.8 43.6C385.8 47.6 385.3 52.6 383.6 56.4C382.8 58.3 381.9 59.4 380.4 60.8C377.6 63.3 375.3 64.4 371.8 65.3L370.6 65.5L354.9 65.6L339.2 65.6L338.2 65.4Z","M407.6 64.6C404.9 64.0 402.7 62.2 401.5 59.9C401.3 59.4 401.0 58.7 400.9 58.2L400.6 57.5L400.6 38.5C400.6 17.3 400.6 19.2 401.4 17.4C402.4 15.2 404.2 13.6 406.6 12.8L407.6 12.4L430.6 12.4C447.9 12.4 453.7 12.4 454.2 12.5C457.0 13.0 459.4 14.8 460.6 17.4C461.4 19.2 461.3 17.2 461.4 38.1C461.4 51.9 461.4 56.8 461.3 57.4C460.9 60.2 459.1 62.6 456.6 63.8C454.6 64.7 457.4 64.6 431.2 64.7C412.3 64.7 408.0 64.7 407.6 64.6ZM443.5 53.7C444.9 53.2 446.2 52.2 446.7 51.0C447.3 49.8 447.3 49.9 447.3 39.1C447.3 28.3 447.3 28.4 446.7 27.2C446.3 26.4 445.3 25.4 444.5 25.0C443.2 24.3 444.1 24.4 430.6 24.4L418.2 24.4L417.5 24.6C415.8 25.1 414.4 26.6 414.0 28.3C413.9 28.9 413.9 49.3 414.0 49.9C414.5 51.9 416.3 53.5 418.4 53.8C418.7 53.8 424.4 53.9 430.9 53.9C442.3 53.8 443.0 53.8 443.5 53.7Z","M483.4 64.5C480.2 63.9 477.7 61.5 476.8 58.3L476.6 57.5L476.6 38.5L476.6 19.4L476.8 18.5C477.0 18.0 477.2 17.4 477.4 17.1C478.5 14.8 480.8 13.1 483.3 12.6C484.0 12.4 486.5 12.4 506.9 12.4L529.8 12.4L530.7 12.6C533.9 13.4 536.3 15.9 537.1 19.2C537.2 19.9 537.2 20.9 537.2 38.6L537.2 57.2L537.0 58.1C536.3 60.8 534.3 63.2 531.8 64.1C530.2 64.7 532.3 64.6 507.1 64.7C486.9 64.7 484.0 64.7 483.4 64.5ZM519.5 53.6C521.1 53.1 522.4 51.8 522.9 50.2C523.1 49.6 523.1 49.2 523.1 39.1C523.1 29.0 523.1 28.6 522.9 28.0C522.4 26.4 521.1 25.1 519.5 24.6L518.8 24.4L506.4 24.4C494.6 24.4 494.0 24.4 493.5 24.5C491.6 25.2 490.2 26.6 489.8 28.5C489.7 29.0 489.7 30.9 489.7 39.1C489.7 47.3 489.7 49.2 489.8 49.7C490.3 51.8 492.0 53.5 494.2 53.8C494.5 53.8 500.2 53.9 506.8 53.9L518.9 53.8L519.5 53.6Z"],"stroke":0,"ratio":0.13323572474377746,"one":"inner"},"trx":{"label":"TRX","vb":"2.3 2.3 503.4 88.4","outer":["M56.7 60.6C56.7 60.5 57.7 58.4 58.8 55.7C60.0 53.1 62.2 48.2 63.6 45.0C65.1 41.6 67.2 37.0 68.2 34.7C69.3 32.4 70.1 30.4 70.2 30.3C70.2 30.2 64.9 30.2 37.1 30.3L4.0 30.3L4.2 29.8C4.4 29.5 6.3 25.4 8.4 20.8C10.6 16.1 13.1 10.7 14.0 8.8C14.9 6.9 15.7 5.2 15.8 5.1C16.4 4.5 14.2 4.6 46.6 4.5C63.0 4.4 95.3 4.4 118.4 4.4C157.9 4.4 160.4 4.5 160.8 4.6C161.3 4.8 164.2 6.6 196.6 26.5C198.9 27.9 200.9 29.1 201.0 29.2C201.2 29.4 201.5 30.0 201.5 30.0C201.5 30.0 187.9 30.1 171.3 30.1L141.2 30.1L140.7 30.4C140.0 30.8 139.5 31.3 139.1 32.3C138.4 34.1 136.2 39.5 133.5 45.9C131.8 49.8 129.9 54.3 129.2 56.0C127.8 59.3 127.7 59.6 127.2 60.0C126.6 60.6 129.5 60.6 91.4 60.6C72.3 60.6 56.7 60.6 56.7 60.6Z","M246.3 88.9C242.1 88.8 241.6 88.8 239.8 88.3C238.7 88.0 237.8 87.6 236.7 87.1C235.5 86.5 236.5 87.2 225.9 80.1C221.0 76.9 215.4 73.2 213.6 72.0C206.5 67.3 202.2 64.4 201.3 63.7C200.2 62.9 198.3 61.9 197.0 61.5C195.8 61.1 194.0 60.7 192.5 60.6C190.9 60.4 191.5 60.4 160.6 60.5C146.3 60.5 134.6 60.5 134.5 60.5C134.4 60.3 134.8 59.0 136.2 55.9C142.1 42.5 145.4 35.1 145.6 34.8C145.7 34.7 146.1 34.5 146.4 34.3L146.9 34.1L181.2 34.0C202.7 33.9 215.9 33.9 216.6 33.8C218.5 33.6 219.3 33.4 224.1 31.7L225.7 31.1L225.9 30.7C226.0 30.4 226.1 30.2 226.1 30.1C226.0 30.1 223.2 30.1 219.7 30.1C213.0 30.0 213.1 30.0 211.9 29.5C211.2 29.2 209.0 27.8 196.4 19.7C191.3 16.4 184.4 11.9 181.2 9.8C174.8 5.8 173.3 4.7 173.1 4.5C172.9 4.3 179.5 4.3 227.2 4.3C262.8 4.3 274.0 4.3 274.9 4.4C281.2 5.1 285.7 6.8 297.2 13.1C300.0 14.6 300.6 15.1 301.0 16.2C301.3 17.1 301.1 18.1 300.4 20.2C299.0 24.1 296.2 31.3 294.5 35.6C293.8 37.1 293.1 39.0 292.8 39.9C290.8 45.6 288.0 48.4 282.0 50.4C279.6 51.3 276.0 52.8 275.3 53.4C274.9 53.6 274.7 53.9 274.8 53.9C274.8 53.9 280.5 57.7 287.4 62.2C294.3 66.7 301.2 71.3 302.8 72.3C304.4 73.3 308.8 76.2 312.6 78.7C316.3 81.2 320.8 84.1 322.5 85.3C324.2 86.4 326.0 87.5 326.5 87.9C327.2 88.3 327.4 88.5 327.3 88.7C327.3 88.8 327.3 88.9 327.2 88.9C327.2 89.0 250.4 89.0 246.3 88.9Z","M299.6 60.4C295.7 60.3 296.2 60.5 291.3 57.3C289.8 56.3 288.6 55.4 288.6 55.4C288.6 55.4 289.5 54.7 290.6 53.9C293.4 51.8 294.9 50.3 296.2 47.9C296.8 47.0 298.8 42.5 300.0 39.6C301.4 36.5 301.5 36.2 302.1 35.6C302.7 35.0 303.3 34.7 305.1 34.3C305.8 34.1 307.4 33.6 308.5 33.3C311.1 32.5 312.0 32.3 313.0 32.2C313.8 32.2 313.8 32.2 313.8 31.9C313.8 31.4 313.6 31.2 313.1 30.7C312.5 30.3 309.1 28.6 306.8 27.5C305.3 26.8 305.2 26.3 306.1 24.0C307.4 20.7 307.6 19.7 307.6 17.6C307.6 16.3 307.6 15.9 307.4 15.2C306.9 13.4 306.1 12.1 304.6 10.5C303.2 9.2 301.6 8.1 297.7 5.9L295.0 4.3L296.0 4.3C297.6 4.2 357.1 4.2 359.1 4.3C362.0 4.4 362.0 4.5 369.6 8.6C372.0 9.8 374.5 11.1 375.2 11.5L376.5 12.2L377.4 12.1C378.2 12.1 378.6 12.0 382.9 10.8C389.0 9.0 392.2 8.1 395.8 6.9C397.5 6.4 399.3 5.8 399.8 5.7C401.9 5.1 405.0 4.6 408.2 4.3C409.5 4.2 446.2 4.0 482.7 4.0C497.7 4.0 502.9 4.0 503.3 4.1C503.8 4.2 503.8 4.3 503.9 4.6C504.0 4.8 504.0 5.0 504.0 5.0C503.9 5.1 497.3 7.2 490.8 9.3C481.7 12.3 475.6 14.2 450.3 22.2C436.9 26.4 418.0 32.4 416.6 32.9C416.2 33.1 416.1 33.1 416.1 33.4C416.1 33.6 416.1 33.8 416.1 33.8C416.2 33.9 425.7 39.3 431.6 42.6C433.8 43.8 437.4 45.9 439.8 47.2C442.1 48.5 447.4 51.5 451.7 53.9C456.0 56.4 459.8 58.5 460.3 58.8C461.1 59.3 461.2 59.3 461.1 59.6C461.1 59.7 461.0 59.9 461.0 59.9C461.0 60.0 460.5 60.1 460.1 60.1C459.4 60.3 452.6 60.3 419.6 60.3C374.9 60.4 375.8 60.4 372.2 59.6C368.7 58.9 365.3 57.6 361.2 55.2C359.4 54.2 358.3 53.7 356.9 53.5C355.1 53.3 353.6 53.5 350.6 54.6C348.7 55.3 345.6 56.2 341.8 57.4C340.4 57.8 338.4 58.4 337.1 58.8C334.0 59.8 333.2 60.0 330.9 60.3C329.9 60.4 327.3 60.4 316.1 60.4C308.6 60.5 301.2 60.4 299.6 60.4Z"],"inner":["M93.6 52.5C81.1 52.5 73.2 52.5 73.2 52.4C73.2 52.4 74.1 50.4 75.1 48.0C76.2 45.6 78.4 40.7 80.0 37.1C81.6 33.5 83.8 28.7 84.8 26.4L86.6 22.4L53.7 22.3C35.7 22.3 20.9 22.3 20.9 22.3C20.9 21.9 21.7 20.0 22.6 18.2C23.1 17.0 24.0 15.3 24.4 14.3C25.3 12.4 25.6 12.1 26.3 11.9C26.8 11.7 36.1 11.7 90.9 11.7L154.9 11.7L155.7 11.9C156.4 12.2 158.7 13.6 165.9 18.1C168.5 19.7 170.7 21.2 170.9 21.4C171.2 21.7 171.3 21.8 171.3 22.0L171.2 22.2L151.4 22.2C133.1 22.2 131.5 22.3 131.2 22.4C130.6 22.8 130.4 23.1 128.6 27.3C127.6 29.5 125.6 34.3 124.0 37.8C122.5 41.3 120.6 45.7 119.8 47.5C119.0 49.4 118.3 51.1 118.1 51.3C117.5 52.2 116.9 52.5 115.2 52.5C114.5 52.6 104.8 52.5 93.6 52.5Z","M247.8 81.1C246.6 81.0 245.5 80.5 244.2 79.8C243.8 79.5 239.7 76.8 235.1 73.7C220.5 64.1 215.7 60.9 213.0 59.1C211.5 58.2 209.6 56.9 208.7 56.3C206.0 54.5 204.4 53.8 201.9 53.1C199.0 52.4 201.2 52.5 174.8 52.4C161.9 52.4 151.1 52.4 150.9 52.3L150.5 52.2L151.6 49.5C152.2 48.1 152.9 46.3 153.2 45.7C153.5 45.1 153.8 44.1 154.0 43.6C154.4 42.4 154.7 41.9 155.5 41.6C155.9 41.5 157.1 41.4 185.3 41.4C215.3 41.4 216.2 41.4 219.7 41.0C222.6 40.7 224.7 40.3 228.3 39.2C232.1 38.2 234.3 37.3 236.8 36.1C241.2 34.0 242.8 32.3 244.0 28.9C244.4 27.8 244.9 25.8 244.9 25.2C244.9 24.1 243.8 23.1 242.2 22.7C240.3 22.2 239.8 22.2 228.9 22.1C220.5 22.1 218.6 22.0 218.3 21.9C217.9 21.7 214.7 19.7 208.7 15.8C204.4 13.0 203.8 12.6 203.5 12.2L203.2 11.7L205.0 11.6C205.9 11.6 220.6 11.5 237.6 11.5C269.7 11.5 269.2 11.5 270.9 11.9C273.2 12.4 278.6 14.8 283.5 17.4C286.7 19.1 287.3 19.5 287.8 20.4C288.0 21.1 288.1 22.0 287.8 22.8C287.4 24.3 282.6 35.6 281.4 38.0C280.8 39.2 280.4 39.8 279.6 40.6C278.4 41.9 276.8 42.9 275.0 43.6C274.5 43.8 271.9 44.7 269.1 45.7C259.2 49.2 256.8 50.1 255.5 50.9C254.8 51.2 254.3 51.6 254.3 51.6C254.3 51.6 259.2 54.9 265.2 58.9C292.3 77.1 297.2 80.4 297.3 80.5C297.4 80.5 297.4 80.7 297.4 80.8C297.3 81.1 297.3 81.1 296.0 81.1C295.2 81.2 284.3 81.2 271.6 81.2C254.9 81.2 248.4 81.2 247.8 81.1Z","M307.6 52.2C306.9 52.2 306.2 52.1 306.2 52.1C306.2 52.1 308.7 46.6 309.6 44.9C310.3 43.4 310.6 42.9 311.0 42.6C311.7 41.9 312.1 41.8 317.6 40.1C329.5 36.4 336.3 34.4 337.6 34.1L338.8 33.8L338.8 33.4C338.8 33.2 338.8 33.0 338.7 33.0C338.5 32.8 325.7 26.1 321.1 23.8C318.1 22.3 317.9 22.0 318.5 19.4C318.7 18.6 318.7 18.1 318.7 16.7C318.8 14.7 318.6 14.0 318.1 12.6C317.9 12.1 317.7 11.7 317.7 11.7C317.8 11.7 318.1 11.6 318.6 11.6C319.2 11.4 322.3 11.4 335.8 11.4L352.2 11.4L353.1 11.6C355.1 12.1 356.1 12.6 362.8 16.3C371.5 21.1 373.3 22.0 374.2 22.2C375.5 22.5 374.9 22.6 388.4 18.5C401.6 14.4 408.9 12.3 410.7 11.9C412.1 11.6 413.3 11.5 415.8 11.4C418.3 11.3 452.5 11.3 453.1 11.4C453.4 11.4 453.4 11.5 453.4 11.6C453.4 11.9 455.6 11.2 424.4 21.0C415.9 23.7 407.5 26.3 405.9 26.8C404.3 27.4 400.3 28.6 397.0 29.7C393.7 30.7 391.0 31.6 390.9 31.6C390.8 31.6 392.2 32.4 394.4 33.6C428.2 52.3 426.7 51.5 426.8 51.7C426.8 52.0 426.8 52.0 426.4 52.1C426.2 52.1 415.0 52.1 401.4 52.1C374.1 52.1 376.5 52.2 374.4 51.5C373.0 51.1 366.0 47.5 360.7 44.5C358.1 43.0 357.6 42.8 356.0 42.9C355.1 42.9 354.7 42.9 354.1 43.1C353.6 43.3 350.3 44.3 346.7 45.5C337.0 48.7 330.4 50.8 328.1 51.4C326.9 51.7 325.4 52.0 323.6 52.1C322.1 52.2 309.6 52.3 307.6 52.2Z"],"stroke":0,"ratio":0.17560588001589195},"ram":{"label":"RAM","vb":"9.3 6.0 326.6 52.7","outer":["M11.8 32.4L11.8 8.6L44.3 8.6C80.2 8.7 76.9 8.6 79.3 9.0C83.6 9.8 87.4 11.3 90.2 13.3C90.9 13.9 92.2 15.1 92.8 15.8C95.1 18.6 96.3 22.3 96.2 26.4C96.1 27.5 96.0 28.1 95.8 29.1C94.8 32.8 91.6 36.0 86.9 38.1C85.9 38.5 84.1 39.2 83.3 39.3C83.1 39.4 82.8 39.5 82.8 39.5C82.8 39.5 86.6 43.2 91.4 47.7L100.0 55.8L81.7 55.9L63.4 55.9L63.3 55.7C63.2 55.7 60.6 52.2 57.4 48.0L51.6 40.5L49.0 40.5L46.3 40.5L46.3 48.3L46.3 56.2L29.1 56.2L11.8 56.2L11.8 32.4ZM55.4 29.3C59.1 28.7 61.1 26.8 60.8 24.0C60.6 22.9 60.3 22.0 59.7 21.1C59.4 20.6 58.6 19.7 58.1 19.4C57.6 19.1 56.8 18.7 56.2 18.5L55.7 18.3L50.8 18.3L46.0 18.3L46.0 23.8L46.0 29.4L50.4 29.4C54.0 29.4 54.9 29.4 55.4 29.3Z","M107.3 55.7C107.3 55.6 112.9 45.0 119.6 32.1L132.0 8.7L157.8 8.6L183.7 8.6L195.3 30.9C201.7 43.2 207.2 53.8 207.5 54.4L208.2 55.7L190.5 55.7L172.8 55.7L170.5 50.0L168.2 44.4L157.6 44.4L146.9 44.4L146.7 44.8C146.6 45.1 145.5 47.7 144.3 50.5L142.1 55.8L124.7 55.8C108.1 55.8 107.2 55.8 107.3 55.7ZM165.1 33.5C165.0 33.3 157.7 18.9 157.7 19.0C157.6 19.1 150.2 33.5 150.2 33.6C150.2 33.6 152.8 33.6 157.7 33.6C163.8 33.6 165.1 33.6 165.1 33.5Z","M217.0 32.1L217.0 8.5L242.0 8.5L267.1 8.5L271.5 15.8L275.9 23.2L276.3 22.5C276.6 22.1 278.7 18.8 281.0 15.2L285.3 8.5L309.3 8.5L333.4 8.5L333.4 32.1L333.4 55.7L317.6 55.7L301.8 55.7L301.8 42.5L301.8 29.3L301.0 29.3L300.1 29.3L293.0 42.5L285.9 55.7L275.2 55.7L264.5 55.7L257.4 42.5L250.3 29.3L249.7 29.3L249.0 29.3L249.0 42.5L249.0 55.7L233.0 55.7L217.0 55.7L217.0 32.1Z"],"inner":["M11.8 32.4L11.8 8.6L44.3 8.6C80.2 8.7 76.9 8.6 79.3 9.0C83.6 9.8 87.4 11.3 90.2 13.3C90.9 13.9 92.2 15.1 92.8 15.8C95.1 18.6 96.3 22.3 96.2 26.4C96.1 27.5 96.0 28.1 95.8 29.1C94.8 32.8 91.6 36.0 86.9 38.1C85.9 38.5 84.1 39.2 83.3 39.3C83.1 39.4 82.8 39.5 82.8 39.5C82.8 39.5 86.6 43.2 91.4 47.7L100.0 55.8L81.7 55.9L63.4 55.9L63.3 55.7C63.2 55.7 60.6 52.2 57.4 48.0L51.6 40.5L49.0 40.5L46.3 40.5L46.3 48.3L46.3 56.2L29.1 56.2L11.8 56.2L11.8 32.4ZM55.4 29.3C59.1 28.7 61.1 26.8 60.8 24.0C60.6 22.9 60.3 22.0 59.7 21.1C59.4 20.6 58.6 19.7 58.1 19.4C57.6 19.1 56.8 18.7 56.2 18.5L55.7 18.3L50.8 18.3L46.0 18.3L46.0 23.8L46.0 29.4L50.4 29.4C54.0 29.4 54.9 29.4 55.4 29.3Z","M107.3 55.7C107.3 55.6 112.9 45.0 119.6 32.1L132.0 8.7L157.8 8.6L183.7 8.6L195.3 30.9C201.7 43.2 207.2 53.8 207.5 54.4L208.2 55.7L190.5 55.7L172.8 55.7L170.5 50.0L168.2 44.4L157.6 44.4L146.9 44.4L146.7 44.8C146.6 45.1 145.5 47.7 144.3 50.5L142.1 55.8L124.7 55.8C108.1 55.8 107.2 55.8 107.3 55.7ZM165.1 33.5C165.0 33.3 157.7 18.9 157.7 19.0C157.6 19.1 150.2 33.5 150.2 33.6C150.2 33.6 152.8 33.6 157.7 33.6C163.8 33.6 165.1 33.6 165.1 33.5Z","M217.0 32.1L217.0 8.5L242.0 8.5L267.1 8.5L271.5 15.8L275.9 23.2L276.3 22.5C276.6 22.1 278.7 18.8 281.0 15.2L285.3 8.5L309.3 8.5L333.4 8.5L333.4 32.1L333.4 55.7L317.6 55.7L301.8 55.7L301.8 42.5L301.8 29.3L301.0 29.3L300.1 29.3L293.0 42.5L285.9 55.7L275.2 55.7L264.5 55.7L257.4 42.5L250.3 29.3L249.7 29.3L249.0 29.3L249.0 42.5L249.0 55.7L233.0 55.7L217.0 55.7L217.0 32.1Z"],"stroke":3.1,"ratio":0.16135897357381265},"dodge":{"label":"DODGE","vb":"24.0 24.0 1080.7 126.0","outer":["M30.4 142.0C30.1 141.5 30.2 75.2 30.5 74.8C30.8 74.6 34.5 74.5 50.5 74.6C67.8 74.6 70.3 74.7 70.5 75.0C70.6 75.2 70.7 83.5 70.7 96.3C70.7 113.9 70.8 117.2 71.1 117.5C71.4 117.7 79.6 117.7 104.0 117.7C135.9 117.6 140.6 117.5 144.4 116.7C145.1 116.6 146.6 116.3 147.8 116.1C148.9 115.9 150.3 115.6 150.9 115.4C151.4 115.2 152.1 115.0 152.4 115.0C152.7 115.0 153.4 114.8 153.8 114.6C154.3 114.5 155.6 113.9 156.8 113.5C164.9 110.4 170.9 104.7 173.4 97.6C174.8 93.8 175.1 91.6 175.1 86.8C175.1 81.9 174.8 80.2 173.4 76.4C171.2 70.2 166.4 65.0 159.6 61.7C153.9 58.8 148.2 57.4 139.3 56.5C134.4 56.0 132.4 56.0 82.4 56.0C41.2 56.0 30.5 55.9 30.3 55.7C30.2 55.5 30.2 50.1 30.2 43.5L30.4 31.6L87.0 31.6C129.4 31.6 144.9 31.7 148.5 31.9C153.4 32.2 162.1 33.2 164.3 33.7C165.6 34.0 169.2 34.7 170.8 35.0C171.9 35.2 172.8 35.4 176.9 36.6C181.7 38.1 183.0 38.6 185.7 39.8C186.3 40.0 186.8 40.2 186.9 40.2C187.2 40.2 191.4 42.3 192.7 43.2C193.4 43.6 194.1 44.0 194.1 44.0C194.2 44.0 194.9 44.5 195.8 45.0C202.0 49.2 206.7 54.0 210.3 59.9C211.5 61.9 212.0 62.8 213.4 65.9C213.6 66.3 214.0 67.6 214.4 68.8C214.7 69.9 215.2 71.4 215.4 72.0C215.6 72.6 215.8 73.6 215.9 74.2C216.0 74.9 216.2 76.2 216.5 77.2C217.1 80.1 217.1 93.4 216.4 96.8C214.4 107.4 211.0 114.5 204.3 121.8C202.6 123.6 198.7 126.8 195.5 128.9C188.2 133.7 178.7 137.3 167.5 139.5C163.1 140.3 160.5 140.8 157.9 141.0C156.5 141.1 154.6 141.3 153.6 141.5C152.5 141.6 149.2 141.9 146.1 142.0C138.5 142.3 30.6 142.3 30.4 142.0Z","M330.6 143.8C327.0 143.7 314.3 142.5 314.0 142.4C313.9 142.3 312.8 142.1 311.5 142.0C307.2 141.5 299.1 139.9 293.8 138.4C277.1 133.9 264.8 126.3 257.4 116.0C254.5 112.0 251.9 106.1 250.5 100.9C249.3 96.0 249.1 94.3 249.1 86.8C249.1 79.5 249.1 79.6 250.3 74.2C252.5 63.8 259.6 53.3 268.8 46.9C272.2 44.5 275.5 42.6 278.7 41.1C280.0 40.5 281.1 40.0 281.2 40.0C281.2 40.0 281.7 39.8 282.1 39.6C283.4 39.0 285.8 38.1 287.5 37.5C288.4 37.2 289.5 36.9 289.9 36.7C290.3 36.6 291.2 36.3 291.9 36.1C292.6 35.9 294.2 35.5 295.5 35.1C299.7 34.0 305.9 32.7 310.6 32.1C312.1 31.9 313.9 31.6 314.6 31.5C315.3 31.4 316.9 31.2 318.1 31.1C319.4 31.0 322.0 30.8 324.0 30.5C329.4 29.9 358.8 29.9 364.5 30.5C366.6 30.8 369.4 31.0 370.6 31.1C371.9 31.2 373.3 31.4 373.9 31.5C374.4 31.6 375.9 31.8 377.1 32.0C380.6 32.4 386.4 33.5 390.1 34.4C390.9 34.6 392.2 35.0 393.0 35.1C394.8 35.6 397.6 36.4 398.8 36.8C409.0 40.3 414.6 43.1 420.9 47.9C430.5 55.2 436.0 63.9 438.5 75.8C439.8 82.2 439.8 92.7 438.4 98.9C437.8 101.5 436.8 104.8 436.4 105.6C436.2 106.0 436.0 106.4 436.0 106.6C436.0 107.0 435.2 108.8 433.6 111.7C430.7 117.2 424.9 123.3 418.6 127.8C414.0 131.0 404.9 135.4 399.4 136.9C398.8 137.1 398.1 137.3 398.0 137.4C397.3 137.8 387.4 140.3 384.2 140.8C383.4 140.9 381.9 141.2 381.0 141.4C380.1 141.6 378.6 141.8 377.8 141.9C376.9 142.0 375.2 142.2 374.1 142.4C373.0 142.6 371.1 142.8 369.8 142.9C368.4 143.0 365.9 143.2 364.0 143.4C361.5 143.7 357.0 143.8 346.5 143.9C338.7 143.9 331.6 143.9 330.6 143.8ZM352.4 119.2C366.2 118.5 377.9 115.0 385.5 109.6C389.3 106.9 393.1 102.7 394.8 99.2C395.1 98.6 395.4 97.9 395.5 97.7C396.2 96.4 397.1 93.0 397.4 90.0C397.8 87.0 397.8 86.5 397.4 83.7C396.5 77.4 394.3 72.8 389.8 68.2C387.0 65.3 382.3 62.1 378.5 60.5C377.5 60.1 376.3 59.6 375.9 59.4C375.5 59.2 374.8 58.9 374.4 58.8C374.0 58.8 373.4 58.5 373.0 58.3C372.7 58.2 372.3 58.0 372.1 58.0C372.0 58.0 371.1 57.8 370.2 57.5C366.0 56.2 359.7 55.1 354.1 54.7C339.0 53.6 324.1 55.1 314.1 58.8C313.0 59.2 311.7 59.7 311.2 59.9C310.3 60.2 307.0 61.9 305.5 62.8C304.3 63.4 300.4 66.4 299.2 67.5C296.6 69.9 293.9 73.9 292.7 77.0C292.4 77.6 291.9 79.2 291.6 80.5C291.0 82.6 290.9 83.3 290.9 86.9C290.9 90.4 291.0 91.2 291.6 93.5C292.0 94.9 292.4 96.2 292.5 96.5C292.6 96.7 293.1 97.6 293.5 98.6C297.1 106.5 305.9 112.9 318.1 116.4C326.7 118.9 339.7 120.0 352.4 119.2Z","M474.3 141.8C473.8 141.0 473.9 75.5 474.3 74.9C474.6 74.5 475.9 74.5 494.4 74.6C505.2 74.6 514.3 74.7 514.4 74.8C514.7 75.0 514.8 79.5 514.8 96.1C514.8 112.1 514.8 117.2 515.0 117.4C515.5 117.9 575.1 117.9 581.9 117.4C586.5 117.0 590.6 116.5 593.6 115.7C594.2 115.6 595.2 115.3 596.0 115.1C601.8 113.7 607.8 110.5 611.7 106.7C613.5 104.9 615.7 101.8 616.9 99.2C620.4 91.4 620.0 79.8 615.8 72.7C613.8 69.3 610.5 65.8 607.4 63.7C604.6 61.9 600.1 59.8 597.0 59.0C596.0 58.8 595.2 58.5 595.1 58.4C594.6 58.1 588.4 57.0 585.8 56.7C584.2 56.6 582.7 56.4 582.5 56.3C582.3 56.2 557.8 56.1 528.1 56.0L474.1 55.9L474.1 44.2C474.0 36.3 474.1 32.3 474.3 32.0C474.5 31.5 474.9 31.5 532.0 31.6C589.9 31.7 595.0 31.7 600.2 32.6C601.4 32.8 603.2 33.0 604.2 33.1C605.3 33.2 606.6 33.4 607.2 33.5C607.9 33.7 609.3 33.9 610.5 34.1C612.7 34.5 613.6 34.7 616.7 35.5C617.7 35.8 618.6 36.0 618.8 36.0C619.2 36.0 625.9 38.2 627.9 38.9C633.3 41.0 638.4 43.9 642.6 47.0C651.1 53.3 656.4 61.2 659.5 72.0C659.8 73.0 660.0 74.1 660.0 74.5C660.0 74.8 660.2 75.7 660.4 76.5C661.3 79.9 661.3 92.9 660.5 96.8C660.4 97.4 660.1 98.5 660.0 99.3C659.9 100.0 659.6 101.2 659.4 101.9C659.2 102.6 658.7 104.1 658.3 105.2C655.9 113.0 650.2 121.0 643.0 126.5C634.7 132.8 621.6 138.0 609.4 139.9C608.1 140.0 606.7 140.3 606.1 140.5C605.6 140.6 604.2 140.8 603.1 140.9C602.0 141.0 600.0 141.2 598.6 141.4C593.3 142.1 583.7 142.2 529.3 142.2C475.4 142.2 474.5 142.2 474.3 141.8Z","M763.9 142.0C759.5 141.8 753.6 141.2 749.5 140.6C748.2 140.4 746.4 140.1 745.5 140.0C743.7 139.7 741.3 139.2 738.6 138.5C737.6 138.2 736.6 138.0 736.4 138.0C735.7 138.0 727.1 135.2 725.1 134.3C724.6 134.0 723.7 133.6 723.1 133.4C713.7 129.2 706.3 123.2 701.0 115.4C700.1 114.1 697.0 108.1 697.0 107.7C697.0 107.5 696.9 107.1 696.7 106.8C695.7 104.8 694.2 98.5 693.6 93.7C693.0 87.8 693.1 82.9 694.3 75.6C694.6 73.4 695.7 69.6 696.9 66.3C698.9 60.7 703.9 53.8 708.9 49.4C711.0 47.6 714.8 44.9 716.6 43.9C720.8 41.5 727.1 38.7 731.0 37.5C732.0 37.2 733.5 36.7 734.3 36.5C735.1 36.2 735.9 36.0 736.1 36.0C736.3 36.0 737.3 35.8 738.3 35.5C741.5 34.7 742.3 34.5 744.6 34.1C745.9 34.0 747.3 33.7 747.9 33.5C748.4 33.4 749.7 33.2 750.6 33.1C751.6 33.0 753.5 32.8 754.9 32.6C761.8 31.6 769.2 31.5 825.7 31.5C867.5 31.5 880.0 31.6 880.2 31.8C880.4 32.0 880.5 35.1 880.5 43.9L880.5 55.7L879.9 55.9C879.6 55.9 855.4 56.0 826.0 56.1C772.7 56.1 772.6 56.1 768.5 56.7C766.2 57.0 764.0 57.3 763.7 57.5C763.4 57.6 762.5 57.8 761.8 57.9C761.0 58.0 759.8 58.3 759.2 58.5C758.5 58.8 757.8 59.0 757.5 59.0C757.2 59.0 756.5 59.2 755.9 59.5C755.4 59.8 754.2 60.2 753.4 60.6C749.7 62.0 745.6 64.7 742.7 67.6C737.7 72.7 735.2 79.0 735.2 86.7C735.2 95.0 737.8 101.7 743.0 106.7C749.0 112.5 757.4 115.8 769.9 117.2C772.8 117.5 778.6 117.6 806.3 117.7C825.3 117.7 839.4 117.7 839.5 117.6C839.7 117.4 839.8 113.3 839.8 108.4C839.8 101.0 839.8 99.4 839.5 99.2C839.3 99.1 826.6 99.0 810.2 99.0C794.3 99.0 781.1 98.9 780.9 98.8C780.5 98.7 780.5 97.5 780.5 87.0C780.5 78.3 780.6 75.2 780.8 74.9C781.1 74.5 785.2 74.5 830.5 74.5C876.7 74.5 879.9 74.5 880.2 74.9C880.6 75.5 880.6 141.5 880.2 142.0C880.0 142.2 867.2 142.2 824.0 142.2C793.3 142.2 766.2 142.1 763.9 142.0Z","M927.3 141.8C926.9 141.1 926.9 32.7 927.3 32.0C927.5 31.5 928.7 31.5 1012.4 31.5C1096.0 31.5 1097.2 31.5 1097.5 32.0C1097.9 32.7 1097.8 55.3 1097.5 55.7C1097.2 55.9 1082.8 56.0 1034.1 56.0C999.4 56.0 970.9 56.1 970.6 56.2C970.3 56.3 970.2 57.3 970.2 65.0C970.2 71.5 970.3 73.8 970.6 74.1C970.9 74.5 974.7 74.5 1030.7 74.5L1090.5 74.5L1090.8 75.1C1091.0 75.8 1091.1 97.9 1090.8 98.6C1090.7 99.0 1085.2 99.0 1031.1 99.0C993.0 99.0 971.3 99.1 970.9 99.2L970.2 99.5L970.2 108.1C970.2 113.6 970.3 117.0 970.5 117.3C970.8 117.7 971.7 117.8 1034.5 117.8C1088.0 117.8 1098.2 117.8 1098.5 118.1C1098.7 118.3 1098.7 121.7 1098.7 130.3L1098.6 142.1L1013.1 142.2C928.7 142.2 927.5 142.2 927.3 141.8Z"],"inner":["M30.4 142.0C30.1 141.5 30.2 75.2 30.5 74.8C30.8 74.6 34.5 74.5 50.5 74.6C67.8 74.6 70.3 74.7 70.5 75.0C70.6 75.2 70.7 83.5 70.7 96.3C70.7 113.9 70.8 117.2 71.1 117.5C71.4 117.7 79.6 117.7 104.0 117.7C135.9 117.6 140.6 117.5 144.4 116.7C145.1 116.6 146.6 116.3 147.8 116.1C148.9 115.9 150.3 115.6 150.9 115.4C151.4 115.2 152.1 115.0 152.4 115.0C152.7 115.0 153.4 114.8 153.8 114.6C154.3 114.5 155.6 113.9 156.8 113.5C164.9 110.4 170.9 104.7 173.4 97.6C174.8 93.8 175.1 91.6 175.1 86.8C175.1 81.9 174.8 80.2 173.4 76.4C171.2 70.2 166.4 65.0 159.6 61.7C153.9 58.8 148.2 57.4 139.3 56.5C134.4 56.0 132.4 56.0 82.4 56.0C41.2 56.0 30.5 55.9 30.3 55.7C30.2 55.5 30.2 50.1 30.2 43.5L30.4 31.6L87.0 31.6C129.4 31.6 144.9 31.7 148.5 31.9C153.4 32.2 162.1 33.2 164.3 33.7C165.6 34.0 169.2 34.7 170.8 35.0C171.9 35.2 172.8 35.4 176.9 36.6C181.7 38.1 183.0 38.6 185.7 39.8C186.3 40.0 186.8 40.2 186.9 40.2C187.2 40.2 191.4 42.3 192.7 43.2C193.4 43.6 194.1 44.0 194.1 44.0C194.2 44.0 194.9 44.5 195.8 45.0C202.0 49.2 206.7 54.0 210.3 59.9C211.5 61.9 212.0 62.8 213.4 65.9C213.6 66.3 214.0 67.6 214.4 68.8C214.7 69.9 215.2 71.4 215.4 72.0C215.6 72.6 215.8 73.6 215.9 74.2C216.0 74.9 216.2 76.2 216.5 77.2C217.1 80.1 217.1 93.4 216.4 96.8C214.4 107.4 211.0 114.5 204.3 121.8C202.6 123.6 198.7 126.8 195.5 128.9C188.2 133.7 178.7 137.3 167.5 139.5C163.1 140.3 160.5 140.8 157.9 141.0C156.5 141.1 154.6 141.3 153.6 141.5C152.5 141.6 149.2 141.9 146.1 142.0C138.5 142.3 30.6 142.3 30.4 142.0Z","M330.6 143.8C327.0 143.7 314.3 142.5 314.0 142.4C313.9 142.3 312.8 142.1 311.5 142.0C307.2 141.5 299.1 139.9 293.8 138.4C277.1 133.9 264.8 126.3 257.4 116.0C254.5 112.0 251.9 106.1 250.5 100.9C249.3 96.0 249.1 94.3 249.1 86.8C249.1 79.5 249.1 79.6 250.3 74.2C252.5 63.8 259.6 53.3 268.8 46.9C272.2 44.5 275.5 42.6 278.7 41.1C280.0 40.5 281.1 40.0 281.2 40.0C281.2 40.0 281.7 39.8 282.1 39.6C283.4 39.0 285.8 38.1 287.5 37.5C288.4 37.2 289.5 36.9 289.9 36.7C290.3 36.6 291.2 36.3 291.9 36.1C292.6 35.9 294.2 35.5 295.5 35.1C299.7 34.0 305.9 32.7 310.6 32.1C312.1 31.9 313.9 31.6 314.6 31.5C315.3 31.4 316.9 31.2 318.1 31.1C319.4 31.0 322.0 30.8 324.0 30.5C329.4 29.9 358.8 29.9 364.5 30.5C366.6 30.8 369.4 31.0 370.6 31.1C371.9 31.2 373.3 31.4 373.9 31.5C374.4 31.6 375.9 31.8 377.1 32.0C380.6 32.4 386.4 33.5 390.1 34.4C390.9 34.6 392.2 35.0 393.0 35.1C394.8 35.6 397.6 36.4 398.8 36.8C409.0 40.3 414.6 43.1 420.9 47.9C430.5 55.2 436.0 63.9 438.5 75.8C439.8 82.2 439.8 92.7 438.4 98.9C437.8 101.5 436.8 104.8 436.4 105.6C436.2 106.0 436.0 106.4 436.0 106.6C436.0 107.0 435.2 108.8 433.6 111.7C430.7 117.2 424.9 123.3 418.6 127.8C414.0 131.0 404.9 135.4 399.4 136.9C398.8 137.1 398.1 137.3 398.0 137.4C397.3 137.8 387.4 140.3 384.2 140.8C383.4 140.9 381.9 141.2 381.0 141.4C380.1 141.6 378.6 141.8 377.8 141.9C376.9 142.0 375.2 142.2 374.1 142.4C373.0 142.6 371.1 142.8 369.8 142.9C368.4 143.0 365.9 143.2 364.0 143.4C361.5 143.7 357.0 143.8 346.5 143.9C338.7 143.9 331.6 143.9 330.6 143.8ZM352.4 119.2C366.2 118.5 377.9 115.0 385.5 109.6C389.3 106.9 393.1 102.7 394.8 99.2C395.1 98.6 395.4 97.9 395.5 97.7C396.2 96.4 397.1 93.0 397.4 90.0C397.8 87.0 397.8 86.5 397.4 83.7C396.5 77.4 394.3 72.8 389.8 68.2C387.0 65.3 382.3 62.1 378.5 60.5C377.5 60.1 376.3 59.6 375.9 59.4C375.5 59.2 374.8 58.9 374.4 58.8C374.0 58.8 373.4 58.5 373.0 58.3C372.7 58.2 372.3 58.0 372.1 58.0C372.0 58.0 371.1 57.8 370.2 57.5C366.0 56.2 359.7 55.1 354.1 54.7C339.0 53.6 324.1 55.1 314.1 58.8C313.0 59.2 311.7 59.7 311.2 59.9C310.3 60.2 307.0 61.9 305.5 62.8C304.3 63.4 300.4 66.4 299.2 67.5C296.6 69.9 293.9 73.9 292.7 77.0C292.4 77.6 291.9 79.2 291.6 80.5C291.0 82.6 290.9 83.3 290.9 86.9C290.9 90.4 291.0 91.2 291.6 93.5C292.0 94.9 292.4 96.2 292.5 96.5C292.6 96.7 293.1 97.6 293.5 98.6C297.1 106.5 305.9 112.9 318.1 116.4C326.7 118.9 339.7 120.0 352.4 119.2Z","M474.3 141.8C473.8 141.0 473.9 75.5 474.3 74.9C474.6 74.5 475.9 74.5 494.4 74.6C505.2 74.6 514.3 74.7 514.4 74.8C514.7 75.0 514.8 79.5 514.8 96.1C514.8 112.1 514.8 117.2 515.0 117.4C515.5 117.9 575.1 117.9 581.9 117.4C586.5 117.0 590.6 116.5 593.6 115.7C594.2 115.6 595.2 115.3 596.0 115.1C601.8 113.7 607.8 110.5 611.7 106.7C613.5 104.9 615.7 101.8 616.9 99.2C620.4 91.4 620.0 79.8 615.8 72.7C613.8 69.3 610.5 65.8 607.4 63.7C604.6 61.9 600.1 59.8 597.0 59.0C596.0 58.8 595.2 58.5 595.1 58.4C594.6 58.1 588.4 57.0 585.8 56.7C584.2 56.6 582.7 56.4 582.5 56.3C582.3 56.2 557.8 56.1 528.1 56.0L474.1 55.9L474.1 44.2C474.0 36.3 474.1 32.3 474.3 32.0C474.5 31.5 474.9 31.5 532.0 31.6C589.9 31.7 595.0 31.7 600.2 32.6C601.4 32.8 603.2 33.0 604.2 33.1C605.3 33.2 606.6 33.4 607.2 33.5C607.9 33.7 609.3 33.9 610.5 34.1C612.7 34.5 613.6 34.7 616.7 35.5C617.7 35.8 618.6 36.0 618.8 36.0C619.2 36.0 625.9 38.2 627.9 38.9C633.3 41.0 638.4 43.9 642.6 47.0C651.1 53.3 656.4 61.2 659.5 72.0C659.8 73.0 660.0 74.1 660.0 74.5C660.0 74.8 660.2 75.7 660.4 76.5C661.3 79.9 661.3 92.9 660.5 96.8C660.4 97.4 660.1 98.5 660.0 99.3C659.9 100.0 659.6 101.2 659.4 101.9C659.2 102.6 658.7 104.1 658.3 105.2C655.9 113.0 650.2 121.0 643.0 126.5C634.7 132.8 621.6 138.0 609.4 139.9C608.1 140.0 606.7 140.3 606.1 140.5C605.6 140.6 604.2 140.8 603.1 140.9C602.0 141.0 600.0 141.2 598.6 141.4C593.3 142.1 583.7 142.2 529.3 142.2C475.4 142.2 474.5 142.2 474.3 141.8Z","M763.9 142.0C759.5 141.8 753.6 141.2 749.5 140.6C748.2 140.4 746.4 140.1 745.5 140.0C743.7 139.7 741.3 139.2 738.6 138.5C737.6 138.2 736.6 138.0 736.4 138.0C735.7 138.0 727.1 135.2 725.1 134.3C724.6 134.0 723.7 133.6 723.1 133.4C713.7 129.2 706.3 123.2 701.0 115.4C700.1 114.1 697.0 108.1 697.0 107.7C697.0 107.5 696.9 107.1 696.7 106.8C695.7 104.8 694.2 98.5 693.6 93.7C693.0 87.8 693.1 82.9 694.3 75.6C694.6 73.4 695.7 69.6 696.9 66.3C698.9 60.7 703.9 53.8 708.9 49.4C711.0 47.6 714.8 44.9 716.6 43.9C720.8 41.5 727.1 38.7 731.0 37.5C732.0 37.2 733.5 36.7 734.3 36.5C735.1 36.2 735.9 36.0 736.1 36.0C736.3 36.0 737.3 35.8 738.3 35.5C741.5 34.7 742.3 34.5 744.6 34.1C745.9 34.0 747.3 33.7 747.9 33.5C748.4 33.4 749.7 33.2 750.6 33.1C751.6 33.0 753.5 32.8 754.9 32.6C761.8 31.6 769.2 31.5 825.7 31.5C867.5 31.5 880.0 31.6 880.2 31.8C880.4 32.0 880.5 35.1 880.5 43.9L880.5 55.7L879.9 55.9C879.6 55.9 855.4 56.0 826.0 56.1C772.7 56.1 772.6 56.1 768.5 56.7C766.2 57.0 764.0 57.3 763.7 57.5C763.4 57.6 762.5 57.8 761.8 57.9C761.0 58.0 759.8 58.3 759.2 58.5C758.5 58.8 757.8 59.0 757.5 59.0C757.2 59.0 756.5 59.2 755.9 59.5C755.4 59.8 754.2 60.2 753.4 60.6C749.7 62.0 745.6 64.7 742.7 67.6C737.7 72.7 735.2 79.0 735.2 86.7C735.2 95.0 737.8 101.7 743.0 106.7C749.0 112.5 757.4 115.8 769.9 117.2C772.8 117.5 778.6 117.6 806.3 117.7C825.3 117.7 839.4 117.7 839.5 117.6C839.7 117.4 839.8 113.3 839.8 108.4C839.8 101.0 839.8 99.4 839.5 99.2C839.3 99.1 826.6 99.0 810.2 99.0C794.3 99.0 781.1 98.9 780.9 98.8C780.5 98.7 780.5 97.5 780.5 87.0C780.5 78.3 780.6 75.2 780.8 74.9C781.1 74.5 785.2 74.5 830.5 74.5C876.7 74.5 879.9 74.5 880.2 74.9C880.6 75.5 880.6 141.5 880.2 142.0C880.0 142.2 867.2 142.2 824.0 142.2C793.3 142.2 766.2 142.1 763.9 142.0Z","M927.3 141.8C926.9 141.1 926.9 32.7 927.3 32.0C927.5 31.5 928.7 31.5 1012.4 31.5C1096.0 31.5 1097.2 31.5 1097.5 32.0C1097.9 32.7 1097.8 55.3 1097.5 55.7C1097.2 55.9 1082.8 56.0 1034.1 56.0C999.4 56.0 970.9 56.1 970.6 56.2C970.3 56.3 970.2 57.3 970.2 65.0C970.2 71.5 970.3 73.8 970.6 74.1C970.9 74.5 974.7 74.5 1030.7 74.5L1090.5 74.5L1090.8 75.1C1091.0 75.8 1091.1 97.9 1090.8 98.6C1090.7 99.0 1085.2 99.0 1031.1 99.0C993.0 99.0 971.3 99.1 970.9 99.2L970.2 99.5L970.2 108.1C970.2 113.6 970.3 117.0 970.5 117.3C970.8 117.7 971.7 117.8 1034.5 117.8C1088.0 117.8 1098.2 117.8 1098.5 118.1C1098.7 118.3 1098.7 121.7 1098.7 130.3L1098.6 142.1L1013.1 142.2C928.7 142.2 927.5 142.2 927.3 141.8Z"],"stroke":7.41,"ratio":0.11656118143459915}};
const BADGE_FIT={ram:1,dodge:1,ram1500:1,trx:1};
const BADGE_ORDER=["ram","dodge","ram1500","trx"];
const S={scol:"red",pack:"hood",side:"",saddtext:"no",stcol:"red",sduo:"one",stout:"black",ssc:1,sro:0,sx:0,sy:0,six:0,siy:0,sirot:0,siscale:1,year:"",model:"",trim:"",hood:"",hoodname:"",hoodOK:false,veh:"",mode:"",des:"",s1open:true,ix:0,iy:0,irot:0,iscale:1,focus:"text",badge:"",bx:0,by:0,brot:0,bscale:1,bout:"red",bin:"black",txtsrc:"type",txtduo:"one",tout:"black",
          border:"no",addtext:"no",bcol:"red",tcol:"red",tx:0,ty:0,rot:0,scale:1,
          main:"black",acc:"red",acc2:"white",touched:false};
const $=i=>document.getElementById(i);
const S0=JSON.parse(JSON.stringify(S));
// Ready designs <-> personalized: nothing carries over from one to the other. Only the vehicle
// (step 1) and what the customer is buying (hood / side / both) are kept.
function resetDesign(){
  const KEEP=["year","model","trim","hood","hoodname","hoodOK","veh","s1open","pack","mode"];
  Object.keys(S).forEach(k=>{ if(!KEEP.includes(k)&&!(k in S0)) delete S[k]; });
  Object.keys(S0).forEach(k=>{ if(!KEEP.includes(k)) S[k]=S0[k]; });
  ["ctext","cdesc","cfontother","stext","sfontother"].forEach(id=>{ const e=$(id); if(e) e.value=""; });
  ["cfont","sfont"].forEach(id=>{ const e=$(id); if(e) e.selectedIndex=0; });
  ["cfile","sfile"].forEach(id=>{ const e=$(id); if(e) try{ e.value=""; }catch(_){} });
  UIMG=null; SIMG=null;
  ["imgctl","sictl"].forEach(id=>{ const e=$(id); if(e) e.hidden=true; });
  [["csize",100],["crot",0],["isize",100],["irot",0],["sisize",100],["sirot",0],["ssize",100],["srot",0]]
    .forEach(([id,v])=>{ const e=$(id); if(e) e.value=v; });
  SEL=null;
  if(S.veh) applyDefaults();
}

function opts(host,items,key,sw,dis){
 if(sw && items.length>10){
   const cur=items.find(o=>o.id===S[key]);
   $(host).className="sw-grid";
   $(host).innerHTML=items.map(o=>{
     const bgv=o.cut?"repeating-linear-gradient(45deg,#bbb 0 4px,#fff 4px 8px)":o.hex;
     const d=dis&&dis(o)?" disabled":"";
     return `<button class="opt sw-btn" type="button"${d} title="${o.label}" data-k="${key}" `+
            `data-v="${o.id}" aria-pressed="${S[key]===o.id}"><span style="background:${bgv}"></span></button>`;
   }).join("")+`<div class="sw-name" style="width:100%">${cur?cur.label:""}</div>`+
     (S[key]==="other"?`<input type="text" class="othbox" data-ok="${key}" placeholder="Colour name or code, e.g. Nardo Grey or #6E7273" value="${(S[key+"_txt"]||"").replace(/"/g,"&quot;")}">`:"");
   return;
 }
 $(host).className="row";
 $(host).innerHTML=items.map(o=>{
  const inner = sw&&o.hex ? `<span class="sw"><span class="chip" style="background:${o.hex}"></span>${o.label}</span>`
    : o.cut ? `<span class="sw"><span class="chip cut"></span>${o.label}</span>` : o.label;
  const d = dis&&dis(o) ? " disabled" : "";
  return `<button class="opt" type="button"${d} data-k="${key}" data-v="${o.id}" aria-pressed="${S[key]===o.id}">${inner}</button>`;
 }).join("");
}
function fillSel(el,items,ph){
 el.innerHTML=`<option value="">${ph}</option>`+items.map(o=>
  `<option value="${o.id}">${o.label}</option>`).join("");
}

$("cfont").innerHTML=FONTS.map((f,i)=>`<option value="${f[0]}">${f[1]}</option>`).join("")+`<option value="__other">Other \u2014 type a font name</option>`;
$("cfile").addEventListener("change",e=>{
  const f=e.target.files&&e.target.files[0]; if(!f){UIMG=null;render();return;}
  if(!/^image\//.test(f.type)){UIMG=null;$("imgctl").hidden=true;render();return;}
  const rd=new FileReader(); rd.onload=()=>{const im=new Image(); im.onload=()=>{
    const c=document.createElement("canvas"); const k=Math.min(1,1200/Math.max(im.width,im.height));
    c.width=Math.round(im.width*k); c.height=Math.round(im.height*k); c.getContext("2d").drawImage(im,0,0,c.width,c.height);
    UIMG=c.toDataURL("image/png"); UIW=c.width; UIH=c.height; S.ix=0;S.iy=0;S.irot=0;S.iscale=1; render(); }; im.src=rd.result; }; rd.readAsDataURL(f);
});
$("isize").oninput=e=>{S.iscale=+e.target.value/100;S.focus="img";S.gfocus="hood";SEL="img";render();};
// ---- side decals: text and artwork, mirrored onto both panels ----
$("sfont").innerHTML=FONTS.map(f=>`<option value="${f[0]}">${f[1]}</option>`).join("")+`<option value="__other">Other \u2014 type a font name</option>`;
$("sfont").onchange=()=>{const o=$("sfont").value!=="__other";$("sfontother").hidden=o;$("sfonthint").hidden=o;render();};
$("sfontother").oninput=()=>render();
$("sfontother").onchange=()=>{loadWebFont($("sfontother").value);render();};
function sideFontValue(){
  if($("sfont").value!=="__other") return $("sfont").value;
  const f=($("sfontother").value||"").trim();
  if(!f) return "Impact, sans-serif";
  clearTimeout(_sfontTimer); _sfontTimer=setTimeout(()=>loadWebFont(f),450);
  return '"'+f.replace(/"/g,"")+'", Impact, sans-serif';
}
var _sfontTimer=null;
const sideFontName=()=>$("sfont").value==="__other"?(($("sfontother").value||"").trim()||"?"):$("sfont").selectedOptions[0].textContent.split(" \u2014")[0];
// ---- text colours, shared by the hood text and the side text ----
// fill and outline can each be a vinyl colour or a cut-out (bare paint), but not both cut out
function textLook(fillKey,outKey,duoKey){
  const f=pick(VIN,fillKey), o=pick(TOUT,outKey), two=S[duoKey]==="two";
  return {two, fillCut:!!(f&&f.cut), outCut:two&&!!(o&&o.cut),
          fill:(f&&!f.cut&&f.hex)||"#C8102E", out:(o&&!o.cut&&o.hex)||"#1C1C1C"};
}
const SVGNS="http://www.w3.org/2000/svg";
// The rotate / resize handles are drawn in viewBox units. A fingertip is a far
// blunter pointer than a mouse, so on touch screens they are drawn 25% larger,
// which grows the tap target as well as the icon.
const COARSE=!!(window.matchMedia&&window.matchMedia("(pointer:coarse)").matches);
// The Jeep builder's 248-unit viewBox covers ~57% of its preview; the Ford layers span
// 113% of theirs. HSPAN rescales so the handles come out the same on-screen size as the
// Jeep's (about 26 px with a mouse, 25 px on a phone), and the gaps around the art with them.
function HSPAN(){ const l=$("d_"+fam+"_text"); const m=l&&(l.getAttribute("style")||"").match(/width:\s*(-?[\d.]+)%/);
  const f=m?parseFloat(m[1])/100:0.573; return 0.573/(f||0.573); }
function gapK(vbw){ return ((vbw||248)/248)*HSPAN(); }
function handleK(vbw){ return gapK(vbw)*(COARSE?1.25:1); }
// Each handle carries an invisible circle that is what you actually grab. On a
// touch screen it is widened well past the icon, so the handle is easy to catch
// without the icon having to look oversized.
const HITR=COARSE?11:6.5;
function grabArea(g){ if(!g)return g; const c=g.querySelector("circle");
 if(c&&c.getAttribute("r")!=HITR) c.setAttribute("r",HITR); return g; }
// paint one visible text node. Modes: fill / both (outline + fill) / ring (coloured outline
// around cut-out letters) / none (letters cut out, nothing printed)
function paintText(t,L){
  const fs=+t.getAttribute("font-size")||10, sw=fs*0.16;
  ["mask","stroke","stroke-width","paint-order","fill-opacity"].forEach(a=>t.removeAttribute(a));
  t.setAttribute("stroke-linejoin","round");
  const mode=!L.two?(L.fillCut?"none":"fill"):(L.outCut?"fill":(L.fillCut?"ring":"both"));
  t.dataset.look=mode; t.dataset.fill=L.fill; t.dataset.out=L.out; t.dataset.sw=sw;
  if(mode==="fill") t.setAttribute("fill",L.fill);
  else if(mode==="both"){ t.setAttribute("fill",L.fill); t.setAttribute("stroke",L.out); t.setAttribute("stroke-width",sw); t.setAttribute("paint-order","stroke"); }
  else { t.setAttribute("fill","#fff"); t.setAttribute("fill-opacity","0"); }
  if(mode==="ring"){
    t.setAttribute("stroke",L.out); t.setAttribute("stroke-width",sw);
    // the half of the outline that falls on the letters is hidden: the letters are cut out
    const svg=t.ownerSVGElement, id="rm_"+svg.id+"_"+(t.getAttribute("class")||"t").split(" ").pop();
    let mk=svg.querySelector("mask#"+id);
    if(!mk){ mk=document.createElementNS(SVGNS,"mask"); mk.id=id; mk.setAttribute("maskUnits","userSpaceOnUse");
      ["x","y"].forEach(a=>mk.setAttribute(a,"-100000")); ["width","height"].forEach(a=>mk.setAttribute(a,"200000"));
      const r=document.createElementNS(SVGNS,"rect"); ["x","y"].forEach(a=>r.setAttribute(a,"-100000")); ["width","height"].forEach(a=>r.setAttribute(a,"200000")); r.setAttribute("fill","#fff");
      mk.appendChild(r); mk.appendChild(document.createElementNS(SVGNS,"text"));
      let d=svg.querySelector("defs"); if(!d){ d=document.createElementNS(SVGNS,"defs"); svg.insertBefore(d,svg.firstChild); }
      d.appendChild(mk); }
    const c=mk.querySelector("text");
    ["x","y","font-size","font-family","font-weight","text-anchor","dominant-baseline"].forEach(a=>{const v=t.getAttribute(a); if(v!==null) c.setAttribute(a,v); else c.removeAttribute(a);});
    c.setAttribute("fill","#000"); c.textContent=t.textContent;
    t.setAttribute("mask","url(#"+id+")");
  }
  t.style.pointerEvents=(mode==="none"||mode==="ring")?"bounding-box":"all";
  return mode;
}
// the knockout copy that cuts the letters (or their outline) out of the vinyl
function knockText(k,L,sw){
  k.removeAttribute("stroke"); k.removeAttribute("stroke-width");
  k.setAttribute("fill","#000");
  if(L.outCut){ k.setAttribute("stroke","#000"); k.setAttribute("stroke-width",sw); k.setAttribute("stroke-linejoin","round"); }
}
$("stext").oninput=()=>render();
$("ssize").oninput=e=>{S.ssc=+e.target.value/100;S.sfocus="t";S.gfocus="side";if(!SEL||SEL.indexOf("stext")) SEL="stext:L";render();};
$("srot").oninput=e=>{S.sro=+e.target.value;S.sfocus="t";S.gfocus="side";if(!SEL||SEL.indexOf("stext")) SEL="stext:L";render();};
$("stext").addEventListener("focus",()=>{S.sfocus="t";render();});
$("sisize").oninput=e=>{S.siscale=+e.target.value/100;S.sfocus="i";S.gfocus="side";if(!SEL||SEL.indexOf("simg")) SEL="simg:L";render();};
$("sirot").oninput=e=>{S.sirot=+e.target.value;S.sfocus="i";S.gfocus="side";if(!SEL||SEL.indexOf("simg")) SEL="simg:L";render();};
$("sfile").addEventListener("change",e=>{
  const f=e.target.files&&e.target.files[0]; if(!f||!/^image\//.test(f.type)){SIMG=null;render();return;}
  const rd=new FileReader(); rd.onload=()=>{const im=new Image(); im.onload=()=>{
    const c=document.createElement("canvas"); const k=Math.min(1,1200/Math.max(im.width,im.height));
    c.width=Math.round(im.width*k); c.height=Math.round(im.height*k); c.getContext("2d").drawImage(im,0,0,c.width,c.height);
    SIMG=c.toDataURL("image/png"); SIW=c.width; SIH=c.height; S.six=0;S.siy=0;S.sirot=0;S.siscale=1; S.sfocus="i"; render(); }; im.src=rd.result; }; rd.readAsDataURL(f);
});
// left panel = the customer's placement; right panel = its mirror image about the hood's
// centre line, turned the opposite way so it still reads correctly
function drawSideArt(){
  const sv=$("d_"+fam+"_sidetext"); if(!sv) return;
  const g=(FAM[fam]||{}).geoside||{x:96,y:180,cx:180,rot:-100,fs:11};
  const show=hasSide();
  const txt=show&&S.saddtext==="yes" ? ($("stext").value||"").trim() : "";
  const img=show&&S.mode==="custom"&&sideImgOK()&&SIMG;
  const SL=textLook("stcol","stout","sduo"), sfam=sideFontValue();
  // 0\u00b0 = the text reads along the panel, top to bottom (the way Sarya wants it placed first)
  const base=g.rot+180;
  const lx=g.x+S.sx, ly=g.y+S.sy, rx=2*g.cx-lx, rot=base+S.sro;
  [["stL",lx,rot],["stR",rx,-rot]].forEach(([c,x,r])=>{
    const t=sv.querySelector("."+c);
    t.textContent=txt; t.setAttribute("x",x); t.setAttribute("y",ly);
    t.setAttribute("font-size",g.fs*S.ssc); t.setAttribute("font-family",sfam); t.setAttribute("font-weight","700");
    t.setAttribute("transform",`rotate(${r} ${x} ${ly})`);
    paintText(t,SL);
  });
  // cut-outs on the side panels: the same two words, knocked out of every side design
  const cut=!!txt&&(SL.fillCut||SL.outCut);
  ORDERK.forEach(k=>{
    const el=$("d_"+fam+"_"+k); if(!el) return;
    const mk=el.querySelector('mask[id^="tk_"]'); if(!mk) return;
    let kg=mk.querySelector(".kside");
    if(!cut||(desOf(k)||{}).sec!=="side"){ if(kg) kg.textContent=""; return; }
    if(!kg){ kg=document.createElementNS(SVGNS,"g"); kg.setAttribute("class","kside"); mk.appendChild(kg); }
    if(kg.childNodes.length!==2){ kg.textContent=""; kg.appendChild(document.createElementNS(SVGNS,"text")); kg.appendChild(document.createElementNS(SVGNS,"text")); }
    [".stL",".stR"].forEach((c,i)=>{ const src=sv.querySelector(c), k2=kg.childNodes[i];
      ["x","y","font-size","font-family","font-weight","text-anchor","dominant-baseline","transform"].forEach(a=>{const v=src.getAttribute(a); if(v!==null) k2.setAttribute(a,v);});
      k2.textContent=txt; knockText(k2,SL,g.fs*S.ssc*0.16); });
  });
  // the artwork starts a little further down the panel than the text, so the two don't sit on top of each other
  const rr=g.rot*Math.PI/180, off=52;
  const ix=g.x-Math.cos(rr)*off+S.six, iy=g.y-Math.sin(rr)*off+S.siy, irx=2*g.cx-ix, w=30*S.siscale, h=SIW?w*SIH/SIW:0;
  [["siL",ix,base+S.sirot],["siR",irx,-(base+S.sirot)]].forEach(([c,x,r])=>{
    const im=sv.querySelector("."+c);
    if(img){ im.setAttribute("href",SIMG); im.setAttribute("width",w); im.setAttribute("height",h);
      im.setAttribute("x",x-w/2); im.setAttribute("y",iy-h/2); // the right-hand copy is a true reflection of the left one (flipped, not just turned)
      im.setAttribute("transform", c==="siR" ? `rotate(${r} ${x} ${iy}) translate(${2*x} 0) scale(-1 1)` : `rotate(${r} ${x} ${iy})`); im.removeAttribute("hidden"); }
    else { im.setAttribute("hidden",""); im.setAttribute("href",""); }
  });
  if(txt||img) sv.removeAttribute("hidden"); else sv.setAttribute("hidden","");
  $("stextblock").hidden=S.saddtext!=="yes";
  $("sictl").hidden=!img;
  $("ssizen").textContent=Math.round(S.ssc*100)+"%"; $("srotn").textContent=Math.round(S.sro)+"\u00b0";
  $("ssize").value=Math.round(S.ssc*100); $("srot").value=Math.round(S.sro);
  $("sisizen").textContent=Math.round(S.siscale*100)+"%"; $("sirotn").textContent=Math.round(S.sirot)+"\u00b0";
  $("sisize").value=Math.round(S.siscale*100); $("sirot").value=Math.round(S.sirot);
  // rotate / resize handles on the side text and the side picture (both panels, mirrored)
  const H=sideHandles(sv); if(!H) return;
  const vb=sv.getAttribute("viewBox").split(" ").map(Number), kk=handleK(vb[2]), gap=13*gapK(vb[2]);
  const rp=(cx,cy,dx,dy,deg)=>{const a=deg*Math.PI/180,c=Math.cos(a),s2=Math.sin(a); return [cx+dx*c-dy*s2, cy+dx*s2+dy*c];};
  const place=(w,show,cx,cy,bw,bh,deg)=>{
    H.querySelectorAll('.shg[data-w="'+w+'"]').forEach(gp=>{
      if(!show||SEL!==(w==="t"?"stext:":"simg:")+gp.dataset.sd){ gp.setAttribute("hidden",""); return; } gp.removeAttribute("hidden");
      let pr=rp(cx,cy,0,-(bh/2+gap),deg), ps=rp(cx,cy,bw/2+gap*9/13,bh/2,deg);
      if(gp.dataset.sd==="R"){ pr=[2*g.cx-pr[0],pr[1]]; ps=[2*g.cx-ps[0],ps[1]]; }
      grabArea(gp.querySelector(".shrot")).setAttribute("transform","translate("+pr[0]+","+pr[1]+") scale("+kk+")");
      grabArea(gp.querySelector(".shsize")).setAttribute("transform","translate("+ps[0]+","+ps[1]+") scale("+kk+")");
    });
  };
  let tb={width:0,height:0}; try{ if(txt) tb=sv.querySelector(".stL").getBBox(); }catch(e){}
  // like the hood: handles show on whichever one the customer is working on (text or picture)
  place("t",!!txt,lx,ly,tb.width,tb.height,rot);
  place("i",!!img,ix,iy,w,h,base+S.sirot);
}
// every rotate / resize handle lives in one overlay layer above all the artwork, so a picture
// can never sit on top of a handle. All these layers share the same viewBox and placement.
function hndLayer(){
  const id="d_"+fam+"_handles"; let ov=$(id); if(ov) return ov;
  const ref=$("d_"+fam+"_text"); if(!ref) return null;
  ov=document.createElementNS(SVGNS,"svg"); ov.id=id; ov.setAttribute("class","decal hndlayer");
  ["viewBox","preserveAspectRatio","style"].forEach(a=>{const v=ref.getAttribute(a); if(v!==null) ov.setAttribute(a,v);});
  ref.parentNode.appendChild(ov);
  [["text",".thandles"],["img",".ihandles"],["badge",".bhandles"]].forEach(([k,c])=>{
    const l=$("d_"+fam+"_"+k), h=l&&l.querySelector(c); if(h){ h.dataset.layer=k; ov.appendChild(h); } });
  return ov;
}
const HND=c=>{const ov=hndLayer(); return ov?ov.querySelector(c):null;};
function syncHandles(){
  const ov=hndLayer(); if(!ov) return;
  ov.removeAttribute("hidden");
  if(ov.parentNode.lastElementChild!==ov) ov.parentNode.appendChild(ov);
  ov.querySelectorAll("[data-layer]").forEach(h=>{ const l=$("d_"+fam+"_"+h.dataset.layer);
    h.style.display=(!l||l.hasAttribute("hidden"))?"none":""; });
}
// the four handle pairs (text left/right, picture left/right), copied from the hood text's handles
function sideHandles(sv){
  const ov=hndLayer(); if(!ov) return null;
  let H=ov.querySelector(".shandles"); if(H){ H.dataset.layer="sidetext"; return H; }
  const src=ov.querySelector(".thandles"); if(!src) return null;
  H=document.createElementNS(SVGNS,"g"); H.setAttribute("class","shandles");
  [["t","L"],["t","R"],["i","L"],["i","R"]].forEach(([w,sd])=>{
    const gp=document.createElementNS(SVGNS,"g"); gp.setAttribute("class","shg"); gp.dataset.w=w; gp.dataset.sd=sd;
    gp.innerHTML=src.innerHTML.replace('class="hrot"','class="shrot"').replace('class="hsize"','class="shsize"');
    gp.setAttribute("hidden",""); H.appendChild(gp);
  });
  H.dataset.layer="sidetext"; ov.appendChild(H);
  return H;
}
// ---- two fingers anywhere on the preview: pinch to resize, twist to rotate ----
// Works on the hood text, the popular-text badge, the hood artwork, and the side text /
// side artwork. The fingers can land anywhere on the preview: they act on whatever is
// selected, which is far easier to hit on a phone than the handles. Registered first and
// in the capture phase, so a pinch always wins over the one-finger drags below.
const DRAGCANCEL=[];
let GESTURING=false, GEST_N=0;
// The one item whose rotate / resize handles are showing. Nothing is selected until the
// customer touches an item; touching another moves the handles there; tapping an empty
// part of the preview hides them. Values: "text" | "badge" | "img" (hood) and
// "stext:L" | "stext:R" | "simg:L" | "simg:R" (the side copy that was touched).
let SEL=null;
(function(){
 const pts=new Map();            // touch / pen pointers currently down on the preview
 let gest=null, gestLock=false;
 const GKEY={text :{s:"scale"  ,r:"rot"  ,lo:0.4 ,hi:2.2},
             img  :{s:"iscale" ,r:"irot" ,lo:0.2 ,hi:2.5},
             badge:{s:"bscale" ,r:"brot" ,lo:0.25,hi:2.2},
             stext:{s:"ssc"    ,r:"sro"  ,lo:0.4 ,hi:2.2},
             simg :{s:"siscale",r:"sirot",lo:0.2 ,hi:2.5}};
 function gestTarget(){
   const vis=id=>{const n=$(id);return !!n&&!n.hasAttribute("hidden");};
   const pop=(S.txtsrc==="popular"&&S.badge);
   const hood=[], side=[];
   if(vis("d_"+fam+"_img"))            hood.push("img");
   if(pop&&vis("d_"+fam+"_badge"))     hood.push("badge");
   if(!pop&&vis("d_"+fam+"_text"))     hood.push("text");
   const sv=$("d_"+fam+"_sidetext");
   if(sv&&!sv.hasAttribute("hidden")){
     const tl=sv.querySelector(".stL"), il=sv.querySelector(".siL");
     if(tl&&tl.textContent) side.push("stext");
     if(il&&!il.hasAttribute("hidden")) side.push("simg"); }
   const sidePick=()=>{const w=S.sfocus==="i"?"simg":"stext"; return side.indexOf(w)>=0?w:side[0];};
   if(SEL){ const k=SEL.split(":")[0]; if(hood.indexOf(k)>=0||side.indexOf(k)>=0) return k; }
   if(S.gfocus==="side"&&side.length) return sidePick();
   if(hood.length) return hood.indexOf(S.focus)>=0?S.focus:hood[0];   // honour the selection on the hood
   return side.length?sidePick():null;
 }
 function gestStart(){
   const ids=Array.from(pts.keys()).slice(-2);
   if(ids.length<2) return;
   const k=gestTarget(); if(!k) return;
   const A=pts.get(ids[0]), B=pts.get(ids[1]), g=GKEY[k];
   DRAGCANCEL.forEach(f=>{try{f();}catch(e){}});   // a one-finger drag must not fight the pinch
   if(k==="stext"||k==="simg"){ S.gfocus="side"; S.sfocus=(k==="simg"?"i":"t");
     if(!SEL||SEL.split(":")[0]!==k) SEL=k+":L"; }
   else { S.gfocus="hood"; S.focus=k; SEL=k; }
   GEST_N++;
   gest={ids:ids,key:g,
         d0:Math.max(24,Math.hypot(B.x-A.x,B.y-A.y)),
         a0:Math.atan2(B.y-A.y,B.x-A.x)*180/Math.PI,
         sc0:S[g.s],rot0:S[g.r]};
   gestLock=true; GESTURING=true;   // no drag until every finger is lifted
   render();
 }
 function gestMove(){
   if(!gest) return false;
   const A=pts.get(gest.ids[0]), B=pts.get(gest.ids[1]);
   if(!A||!B) return false;
   const g=gest.key;
   const d=Math.hypot(B.x-A.x,B.y-A.y);
   S[g.s]=Math.min(g.hi,Math.max(g.lo,gest.sc0*d/gest.d0));
   const a=Math.atan2(B.y-A.y,B.x-A.x)*180/Math.PI;
   const turn=gest.rot0+(a-gest.a0);
   S[g.r]=Math.round(((turn+180)%360+360)%360-180);
   render();                        // also refreshes the size / rotation readouts and sliders
   return true;
 }
 document.addEventListener("pointerdown",ev=>{
   // only fingers and pens are tracked: a mouse can never make two points,
   // so tracking it could only ever leave a stale one behind
   if(ev.pointerType==="mouse") return;
   const T=ev.target; if(!(T&&T.closest&&T.closest(".hood-builder .stage"))) return;
   pts.set(ev.pointerId,{x:ev.clientX,y:ev.clientY});
   if(pts.size>=2){ gestStart(); if(gest){ ev.preventDefault(); ev.stopImmediatePropagation(); return; } }
   if(gestLock){ ev.preventDefault(); ev.stopImmediatePropagation(); }
 },true);
 document.addEventListener("pointermove",ev=>{
   if(pts.has(ev.pointerId)) pts.set(ev.pointerId,{x:ev.clientX,y:ev.clientY});
   if(gest&&gestMove()){ ev.preventDefault(); ev.stopImmediatePropagation(); return; }
   if(gestLock) ev.stopImmediatePropagation();
 },true);
 function liftPointer(ev){
   if(ev&&ev.pointerId!=null) pts.delete(ev.pointerId);
   if(gest&&pts.size<2) gest=null;                     // second finger gone: gesture is over
   if(pts.size===0){ gestLock=false; GESTURING=false; } // all fingers up: dragging allowed again
 }
 document.addEventListener("pointerup",liftPointer,true);
 // a tap on an empty part of the preview hides the handles
 let blank=null;
 const ITEM=".ctxt,.uimg,.bwrap,.stxt,.simg,.hrot,.hsize,.ihrot,.ihsize,.bhrot,.bhsize,.shrot,.shsize";
 document.addEventListener("pointerdown",ev=>{
   const T=ev.target; if(!(T&&T.closest&&T.closest(".hood-builder .stage"))||T.closest(ITEM)){ blank=null; return; }
   blank={id:ev.pointerId,x:ev.clientX,y:ev.clientY,n:GEST_N};
 },true);
 document.addEventListener("pointerup",ev=>{
   const b=blank; blank=null;
   if(!b||b.id!==ev.pointerId||b.n!==GEST_N||Math.hypot(ev.clientX-b.x,ev.clientY-b.y)>8) return;
   if(SEL!==null){ SEL=null; render(); }
 },true);
 document.addEventListener("pointercancel",liftPointer,true);
 window.addEventListener("blur",()=>{ pts.clear(); gest=null; gestLock=false; GESTURING=false; });
})();

// drag either copy; the other follows mirrored
(function(){
  let d=null;
  DRAGCANCEL.push(()=>{ d=null; });
  window.addEventListener("blur",()=>{ d=null; });
  ["pointerup","pointercancel"].forEach(t=>document.addEventListener(t,()=>{ d=null; }));
  document.addEventListener("pointerdown",ev=>{
    // the rotate / resize handles
    const hd=ev.target&&ev.target.closest&&ev.target.closest(".shrot,.shsize");
    if(hd){
      S.gfocus="side";
      const gp=hd.closest(".shg"), sv=$("d_"+fam+"_sidetext");
      SEL=(gp.dataset.w==="t"?"stext:":"simg:")+gp.dataset.sd;
      const tgt=sv.querySelector(gp.dataset.w==="t"?(gp.dataset.sd==="L"?".stL":".stR"):(gp.dataset.sd==="L"?".siL":".siR"));
      const b=tgt.getBoundingClientRect(), cx=b.left+b.width/2, cy=b.top+b.height/2;
      d={hand:hd.classList.contains("shrot")?"rot":"size", what:gp.dataset.w, right:gp.dataset.sd==="R", cx, cy,
         sc0:gp.dataset.w==="t"?S.ssc:S.siscale, d0:Math.max(1,Math.hypot(ev.clientX-cx,ev.clientY-cy))};
      try{ hd.setPointerCapture&&hd.setPointerCapture(ev.pointerId);}catch(e){}
      ev.preventDefault(); ev.stopPropagation(); return;
    }
    const el=ev.target&&ev.target.closest&&ev.target.closest(".stxt,.simg"); if(!el) return;
    S.gfocus="side";
    {const f=el.classList.contains("simg")?"i":"t";
     const ns=(f==="i"?"simg:":"stext:")+((el.classList.contains("stR")||el.classList.contains("siR"))?"R":"L");
     if(S.sfocus!==f||SEL!==ns){ S.sfocus=f; SEL=ns; render(); }}
    const sv=$("d_"+fam+"_sidetext"); const vb=sv.getAttribute("viewBox").split(" ").map(Number), r=sv.getBoundingClientRect();
    const right=el.classList.contains("stR")||el.classList.contains("siR"), isImg=el.classList.contains("simg");
    d={x:ev.clientX,y:ev.clientY,kx:vb[2]/r.width,ky:vb[3]/r.height,right,isImg,
       ox:isImg?S.six:S.sx, oy:isImg?S.siy:S.sy};
    try{ el.setPointerCapture&&el.setPointerCapture(ev.pointerId);}catch(e){}
    ev.preventDefault(); ev.stopPropagation();
  },true);
  document.addEventListener("pointermove",ev=>{
    if(!d) return; if(ev.buttons===0){d=null;return;}
    if(d.hand){
      const g=(FAM[fam]||{}).geoside||{rot:-100}, base=g.rot+180;
      if(d.hand==="rot"){
        const a=Math.atan2(ev.clientX-d.cx,-(ev.clientY-d.cy))*180/Math.PI;
        let off=(d.right?-a:a)-base; off=((off+540)%360)-180; off=Math.round(off);
        if(d.what==="t") S.sro=off; else S.sirot=off;
      } else {
        const k=d.sc0*Math.hypot(ev.clientX-d.cx,ev.clientY-d.cy)/d.d0;
        if(d.what==="t") S.ssc=Math.min(2.2,Math.max(0.4,k)); else S.siscale=Math.min(2.5,Math.max(0.2,k));
      }
      render(); return;
    }
    const dx=(ev.clientX-d.x)*d.kx*(d.right?-1:1), dy=(ev.clientY-d.y)*d.ky;
    if(d.isImg){S.six=d.ox+dx;S.siy=d.oy+dy;} else {S.sx=d.ox+dx;S.sy=d.oy+dy;}
    render();
  });
  ["pointerup","pointercancel"].forEach(t=>document.addEventListener(t,()=>{d=null;}));
})();
$("irot").oninput=e=>{S.irot=+e.target.value;S.focus="img";S.gfocus="hood";SEL="img";render();};
$("cfont").addEventListener("change",()=>{const o=$("cfont").value!=="__other";$("cfontother").hidden=o;$("fonthint").hidden=o;});
$("cfontother").oninput=()=>render();
$("cfontother").onchange=()=>{loadWebFont($("cfontother").value);render();};
let _fontTimer=null, _fontLoaded={};
function loadWebFont(name){
  const fam=String(name||"").trim(); if(!fam||_fontLoaded[fam]) return;
  _fontLoaded[fam]=1;
  const l=document.createElement("link"); l.rel="stylesheet";
  l.href="https://fonts.googleapis.com/css2?family="+encodeURIComponent(fam).replace(/%20/g,"+")+
         ":ital,wght@0,400;0,700;1,400&display=swap";
  l.onload=()=>render(); document.head.appendChild(l);
}
function fontValue(){
  if($("cfont").value!=="__other") return $("cfont").value;
  const fam=($("cfontother").value||"").trim();
  if(!fam) return "Impact, sans-serif";
  clearTimeout(_fontTimer); _fontTimer=setTimeout(()=>loadWebFont(fam),450);
  return '"'+fam.replace(/"/g,"")+'", Impact, sans-serif';
}
$("cfont").onchange=()=>render();
$("ctext").oninput=()=>render();
$("csize").oninput=e=>{S.gfocus="hood";SEL=(S.txtsrc==="popular"&&S.badge)?"badge":"text";const v=+e.target.value/100; if(S.txtsrc==="popular"&&S.badge)S.bscale=v; else S.scale=v; render();};
$("crot").oninput=e=>{S.gfocus="hood";SEL=(S.txtsrc==="popular"&&S.badge)?"badge":"text";const v=+e.target.value; if(S.txtsrc==="popular"&&S.badge)S.brot=v; else S.rot=v; render();};

// drag the text inside the preview
(function(){
 let drag=null, svg=null, t=null;
 let hdrag=null, _cap=null;
 function grab(ev){
   try{
     _cap=ev.currentTarget&&ev.currentTarget.setPointerCapture?ev.currentTarget:null;
     if(_cap&&ev.pointerId!=null) _cap.setPointerCapture(ev.pointerId);
   }catch(e){}
   ev.preventDefault();
 }
 function endDrag(){
   drag=null; hdrag=null;
   try{ if(_cap&&_cap.releasePointerCapture) _cap.releasePointerCapture(); }catch(e){}
   _cap=null;
 }
 DRAGCANCEL.push(endDrag);
 document.addEventListener("pointerdown",ev=>{
   const T=ev.target;
   const hit=sel=>(T&&T.closest)?T.closest(sel):null;
   if(hit(".hrot,.hsize,.ihrot,.ihsize,.bhrot,.bhsize,.uimg,.ctxt,.bwrap")){ S.gfocus="hood";
     const ns=hit(".ihrot,.ihsize,.uimg")?"img":hit(".bhrot,.bhsize,.bwrap")?"badge":"text";
     if(SEL!==ns){ SEL=ns; render(); } }
   // rotate / resize handles on the text
   if(hit(".hrot")||hit(".hsize")){
     const sv=$("d_"+fam+"_text"); const vbv=sv.getAttribute("viewBox").split(" ").map(Number); const r=sv.getBoundingClientRect();
     const tt=sv.querySelector(".ctxt");
     // measure from the same visual centre the rotate handle orbits, so grabbing it never jumps
     let dc=0; try{ dc=tt.getBBox().height*0.35*S.scale; }catch(e){}
     const a0=S.rot*Math.PI/180;
     const cx0=r.left+((+tt.getAttribute("x")+S.tx+Math.sin(a0)*dc)-vbv[0])/vbv[2]*r.width;
     const cy0=r.top +((+tt.getAttribute("y")+S.ty-Math.cos(a0)*dc)-vbv[1])/vbv[3]*r.height;
     hdrag={kind:hit(".hrot")?"rot":"size",cx:cx0,cy:cy0,rot0:S.rot,sc0:S.scale,
            d0:Math.hypot(ev.clientX-cx0,ev.clientY-cy0)};
     S.focus="text"; grab(ev); return;
   }
   // rotate / resize handles on the uploaded image
   if(hit(".bhrot")||hit(".bhsize")){
     const sv=$("d_"+fam+"_badge"); const vbv=sv.getAttribute("viewBox").split(" ").map(Number); const r=sv.getBoundingClientRect();
     const g=FAM[fam].geo;
     const cx0=r.left+((g.x+S.bx)-vbv[0])/vbv[2]*r.width;
     // the same centre the badge is drawn around (render: fullStage), or grabbing the turn handle flips it
     const cy0=r.top +((g.y-(vbv[2]>=1000?0:vbv[3]*0.24)+S.by)-vbv[1])/vbv[3]*r.height;
     hdrag={kind:hit(".bhrot")?"brot":"bsize",cx:cx0,cy:cy0,rot0:S.brot,sc0:S.bscale,
            d0:Math.hypot(ev.clientX-cx0,ev.clientY-cy0)};
     S.focus="badge"; grab(ev); return;
   }
   if(hit(".bwrap")){
     if(S.focus!=="badge"){ S.focus="badge"; render(); }
     const sv=$("d_"+fam+"_badge"); const vbv=sv.getAttribute("viewBox").split(" ").map(Number); const r=sv.getBoundingClientRect();
     hdrag={kind:"badge",x:ev.clientX,y:ev.clientY,ix:S.bx,iy:S.by,kx:vbv[2]/r.width,ky:vbv[3]/r.height};
     grab(ev); return;
   }
   if(hit(".ihrot")||hit(".ihsize")){
     const sv=$("d_"+fam+"_img"); const vbv=sv.getAttribute("viewBox").split(" ").map(Number); const r=sv.getBoundingClientRect();
     const g=FAM[fam].geo;
     const cx0=r.left+((g.x+S.ix)-vbv[0])/vbv[2]*r.width;
     const cy0=r.top +((g.y-vbv[3]*0.12+S.iy)-vbv[1])/vbv[3]*r.height;
     hdrag={kind:hit(".ihrot")?"irot":"isize",cx:cx0,cy:cy0,rot0:S.irot,sc0:S.iscale,
            d0:Math.hypot(ev.clientX-cx0,ev.clientY-cy0)};
     S.focus="img"; grab(ev); return;
   }
   // dragging the artwork itself
   if(hit(".uimg")){
     if(S.focus!=="img"){ S.focus="img"; render(); }
     const sv=$("d_"+fam+"_img"); const vbv=sv.getAttribute("viewBox").split(" ").map(Number); const r=sv.getBoundingClientRect();
     hdrag={kind:"img",x:ev.clientX,y:ev.clientY,ix:S.ix,iy:S.iy,kx:vbv[2]/r.width,ky:vbv[3]/r.height};
     grab(ev); return;
   }
   // dragging the text
   if(!hit(".ctxt")) return;
   if(S.focus!=="text"){ S.focus="text"; render(); }
   svg=$("d_"+fam+"_text"); t=svg.querySelector(".ctxt");
   const vb=svg.getAttribute("viewBox").split(" ").map(Number), r=svg.getBoundingClientRect();
   drag={x:ev.clientX,y:ev.clientY,tx:S.tx,ty:S.ty,kx:vb[2]/r.width,ky:vb[3]/r.height};
   grab(ev);
 });
 document.addEventListener("pointermove",ev=>{
   if((drag||hdrag) && ev.buttons===0){ endDrag(); return; }
   if(hdrag){
     if(hdrag.kind==="badge"){ S.bx=hdrag.ix+(ev.clientX-hdrag.x)*hdrag.kx; S.by=hdrag.iy+(ev.clientY-hdrag.y)*hdrag.ky; render(); return; }
     if(hdrag.kind==="brot"){ S.brot=Math.round(Math.atan2(ev.clientX-hdrag.cx,-(ev.clientY-hdrag.cy))*180/Math.PI); render(); return; }
     if(hdrag.kind==="bsize"){ const dd=Math.hypot(ev.clientX-hdrag.cx,ev.clientY-hdrag.cy);
       S.bscale=Math.min(2.2,Math.max(0.25,hdrag.sc0*dd/Math.max(hdrag.d0,1))); render(); return; }
     if(hdrag.kind==="irot"){ S.irot=Math.round(Math.atan2(ev.clientX-hdrag.cx,-(ev.clientY-hdrag.cy))*180/Math.PI); render(); return; }
     if(hdrag.kind==="isize"){ const dd=Math.hypot(ev.clientX-hdrag.cx,ev.clientY-hdrag.cy);
       S.iscale=Math.min(2.5,Math.max(0.2,hdrag.sc0*dd/Math.max(hdrag.d0,1))); render(); return; }
     if(hdrag.kind==="img"){ S.ix=hdrag.ix+(ev.clientX-hdrag.x)*hdrag.kx; S.iy=hdrag.iy+(ev.clientY-hdrag.y)*hdrag.ky; render(); return; }
     if(hdrag.kind==="rot"){ S.rot=Math.round(Math.atan2(ev.clientX-hdrag.cx, -(ev.clientY-hdrag.cy))*180/Math.PI); }
     else { const d=Math.hypot(ev.clientX-hdrag.cx,ev.clientY-hdrag.cy); S.scale=Math.min(2.2,Math.max(0.4,hdrag.sc0*d/Math.max(hdrag.d0,1))); }
     render(); return;
   }
   if(!drag)return;
   S.tx=drag.tx+(ev.clientX-drag.x)*drag.kx;
   S.ty=drag.ty+(ev.clientY-drag.y)*drag.ky;
   render();
 });
 const stop=endDrag;
 document.addEventListener("pointerup",stop);
 document.addEventListener("pointercancel",stop);
 // only ends a one-finger drag: must not disturb a running pinch
 document.addEventListener("lostpointercapture",()=>{ if(!GESTURING) endDrag(); });
 window.addEventListener("blur",stop);
 // a native image drag would swallow pointerup and leave the page stuck
 document.addEventListener("dragstart",e=>{ if(e.target.closest&&e.target.closest(".hood-builder")) e.preventDefault(); });
})();

// ---- step 1 ----
const years=Object.keys(D.fit.years).sort();
fillSel($("year"),years.map(y=>({id:y,label:y})),"Select year");
$("year").onchange=e=>{S.year=e.target.value;S.model="";S.trim="";resetHood();
 if(S.year){const ms=D.fit.years[S.year].map(m=>({id:m,label:D.fit.models[m].label}));
  fillSel($("model"),ms,"Select model");$("g-model").hidden=false;}
 else $("g-model").hidden=true;
 $("g-trim").hidden=true;render();};
function pickFam(){
 const nf=famFor(S.model,S.hood)||"ram19";
 if(nf!==fam){fam=nf;S.des="";S.side="";S.tx=0;S.ty=0; if(!(VEHSETS[fam]||[]).includes(S.veh)) S.veh="";}
 loadFam(fam).then(()=>{ORDERK=(FAM[fam]||{}).order||[]; document.querySelectorAll(".veh").forEach(v=>v.hidden=(v.dataset.fam!==fam)); render();});
}
$("model").onchange=e=>{S.model=e.target.value;S.trim="";resetHood();pickFam();
 if(S.model){const y=+S.year;
  const inYear=t=>t.r ? t.r.some(([a,b])=>y>=a&&y<=b) : (t.from<=y);
  const ts=D.fit.trims[S.model].filter(inYear).map(t=>({id:t.id,label:t.label}))
            .concat([{id:"__other",label:"Other / not listed"}]);
  fillSel($("trim"),ts,"Select trim");$("g-trim").hidden=false;}
 else $("g-trim").hidden=true;
 render();};
$("s1sum").onclick=()=>{S.s1open=!S.s1open;render();};
$("s1next").onclick=()=>{S.s1open=false;render();const el=$("s4")||$("steps");if(el&&el.scrollIntoView)el.scrollIntoView({behavior:"smooth",block:"start"});};
$("trim").onchange=e=>{S.trim=e.target.value;resetHood();S.s1open=true;
 if(S.trim==="__other"){ $("hoodwrap").hidden=false; S.hood=""; S.hoodname=""; drawHoods();
   $("hoodconfirm").hidden=true; $("hoodpick").hidden=false; }
 if(S.trim){const g=guessHood();S.hood=g.id;$("hoodguess").textContent=g.label;}
 pickFam(); render();};

// ---- step 2 ----
function guessHood(){
 const hs=D.hoods[S.model]||[];
 const rec=(D.fit.trims[S.model]||[]).find(t=>t.id===S.trim);
 let id=rec&&rec.hood ? rec.hood : "std";
 if(!hs.find(h=>h[0]===id)) id="std";
 const h=hs.find(x=>x[0]===id)||hs[0]||["std","Standard Hood"];
 return {id:h[0],label:h[1]};
}
function resetHood(){S.hoodOK=false;S.hoodname="";$("hoodconfirm").hidden=false;
 $("hoodpick").hidden=true;$("hooddone").hidden=true;}
$("hoodyes").onclick=()=>{S.hoodOK=true;$("hoodconfirm").hidden=true;$("hooddone").hidden=false;
 S.hoodname=guessHood().label;$("hoodlabel").textContent=S.hoodname;render();};
const HOODFAM={ram1500:{ram19:"ram19",ramtrx:"ramtrx",ram25:"ram25"},challenger:{chal:"chal"}};
const HOODTHUMB={};["ram19","ramtrx","ram25","chal"].forEach(k=>{HOODTHUMB[k]=(ASSETS[k]&&ASSETS[k].thumb)||"";});
function famFor(model,hood){return (HOODFAM[model]||{})[hood]||"ram19";}
function showFam(f){loadFam(f).then(()=>{document.querySelectorAll(".veh").forEach(v=>v.hidden=(v.dataset.fam!==f));});}
function drawHoods(){
 $("g-hood").innerHTML=(D.hoods[S.model]||[]).map(h=>
  `<button class="hood" type="button" data-k="hood" data-v="${h[0]}" aria-pressed="${S.hood===h[0]}">`+
  `<img src="${HOODTHUMB[famFor(S.model,h[0])]}" alt=""><span>${h[1]}</span></button>`).join("");
}
document.addEventListener("mouseover",e=>{const b=e.target.closest("button.hood"); if(!b||S.hoodOK) return; showFam(famFor(S.model,b.dataset.v));});
document.addEventListener("mouseout",e=>{const b=e.target.closest("button.hood"); if(!b||S.hoodOK) return; showFam(famFor(S.model,S.hood));});
$("hoodno").onclick=()=>{$("hoodconfirm").hidden=true;$("hoodpick").hidden=false;
 drawHoods();render();};
$("hoodconfirm2").onclick=()=>{if(!S.hood)return;S.hoodOK=true;$("hoodpick").hidden=true;
 $("hooddone").hidden=false;
 const h=(D.hoods[S.model]||[]).find(x=>x[0]===S.hood);
 S.hoodname=h?h[1]:S.hood;$("hoodlabel").textContent=S.hoodname;render();};
$("hoodreset").onclick=()=>{resetHood();S.s1open=true;
 if(S.trim){const g=guessHood();S.hood=g.id;$("hoodguess").textContent=g.label;}
 pickFam(); render();};

// ---- defaults driven by vehicle colour ----
function applyDefaults(){
 if(S.veh==="black"){S.main="red";S.acc="white";S.bcol="red";S.tcol="white";S.acc2="black";}
 else {S.main="black";S.acc="red";S.bcol="red";S.tcol="red";S.acc2="white";}
}

// ---------------------------------------------------------------
// snapshot: redraw what the customer sees onto a canvas, so the
// finished preview can travel with the order as a real image
// ---------------------------------------------------------------
function loadImg(src){
  return new Promise((res,rej)=>{
    const i=new Image(); i.crossOrigin="anonymous";
    i.onload=()=>res(i); i.onerror=rej; i.src=src;
  });
}
function svgToImg(el,w,h){
  const c=el.cloneNode(true);
  c.removeAttribute("hidden"); c.removeAttribute("style");
  c.setAttribute("width",w); c.setAttribute("height",h);
  c.querySelectorAll(".thandles,.ihandles,.bhandles,.shandles").forEach(n=>n.remove());
  // the lighting filter lives outside this svg; drop it so the order image renders flat
  c.querySelectorAll("[filter]").forEach(n=>n.removeAttribute("filter"));
  // css variables do not survive serialisation, so bake the colours in
  const cs=getComputedStyle(document.documentElement);
  const V=k=>(cs.getPropertyValue(k).trim()||"#000");
  const main=V("--main"), acc=V("--acc"), bcol=V("--bcol"), tcol=V("--tcol"), scol=V("--scol");
  const st=document.createElementNS("http://www.w3.org/2000/svg","style");
  st.textContent=
    ".outer{fill:"+main+";stroke:"+main+";stroke-width:.9;stroke-linejoin:round}"+
    ".decal.b-on .outer,svg.b-on .outer{fill:"+bcol+";stroke:"+bcol+";stroke-width:.8;stroke-linejoin:round}"+
    ".decal.b-acc .outer,svg.b-acc .outer{fill:"+acc+";stroke:"+acc+";stroke-width:.8;stroke-linejoin:round}"+
    ".pn{fill:"+main+";stroke:"+main+";stroke-width:.15;stroke-linejoin:round}"+
    ".gf{fill:"+acc+"}.gs{fill:none;stroke:"+acc+"}.cutp{fill:"+main+"}"+
    ".gf2{fill:"+V("--acc2")+"}.gs2{fill:none;stroke:"+V("--acc2")+"}svg.g2 .gf{fill:"+V("--acc2")+"}svg.g2 .gs{stroke:"+V("--acc2")+"}"+
    ".bk{fill:"+acc+"}.sd{fill:"+scol+"}.sds{fill:none;stroke:"+scol+"}"+
    // on these the artwork is the second colour and the panel behind it is the main one
    "svg.inv .pn{fill:"+acc+";stroke:"+acc+"}svg.inv .gf{fill:"+main+"}"+
    "svg.inv .gs{stroke:"+main+"}svg.inv .bk{fill:"+main+"}svg.inv .cutp{fill:"+acc+"}"+
    "svg.inv.acc-cut .pn{fill:"+main+";stroke:"+main+"}svg.inv.acc-cut .gf{fill:"+acc+"}"+
    "svg.inv.acc-cut .gs{stroke:"+acc+"}svg.inv.acc-cut .bk{fill:"+acc+"}svg.inv.acc-cut .cutp{fill:"+main+"}"+
    "svg.edgefill:not(.b-on):not(.b-acc) .outer{display:none}svg.edgefill.b-on .ef,svg.edgefill.b-acc .ef{display:none}.ef{stroke:none}"+
    ".solid{display:inline}.cutp{display:none}.rim{display:none}";
  c.insertBefore(st,c.firstChild);
  let s=new XMLSerializer().serializeToString(c);
  ["--main","--acc","--acc2","--bcol","--tcol","--veh","--scol"].forEach(v=>{ s=s.split("var("+v+")").join(V(v)); });
  if(!/xmlns=/.test(s)) s=s.replace("<svg",'<svg xmlns="http://www.w3.org/2000/svg"');
  return loadImg("data:image/svg+xml;charset=utf-8,"+encodeURIComponent(s));
}
function boxOf(el,N){
  const st=el.getAttribute("style")||"";
  const n=k=>{const m=st.match(new RegExp(k+":(-?[\\d.]+)%")); return m?parseFloat(m[1])/100*N:0;};
  return {x:n("left"),y:n("top"),w:n("width"),h:n("height")};
}
async function drawHood(ctx,N){
  const A=ASSETS[fam]||{};
  const cs0=getComputedStyle(document.documentElement);
  if(!A.base){ ctx.fillStyle=(cs0.getPropertyValue("--veh").trim()||"#f2f2f2"); ctx.fillRect(0,0,N,N); }
  else{
  const [base,shade,spec,mask]=await Promise.all([A.base,A.shade,A.spec,A.mask].map(loadImg));
  ctx.drawImage(base,0,0,N,N);
  // paint = colour x shade, lifted by spec, limited to the mask
  const p=document.createElement("canvas"); p.width=p.height=N;
  const pc=p.getContext("2d");
  const cs=getComputedStyle(document.documentElement);
  pc.fillStyle=(cs.getPropertyValue("--veh").trim()||"#f2f2f2"); pc.fillRect(0,0,N,N);
  pc.globalCompositeOperation="multiply"; pc.drawImage(shade,0,0,N,N);
  pc.globalCompositeOperation="screen";   pc.drawImage(spec,0,0,N,N);
  pc.globalCompositeOperation="destination-in"; pc.drawImage(mask,0,0,N,N);
  ctx.drawImage(p,0,0); }
  // every visible decal layer, in the order the page stacks them
  const veh=document.querySelector('.veh[data-fam="'+fam+'"]');
  if(!veh) return;
  const layers=[...veh.querySelectorAll("svg.decal")].filter(e=>!e.hasAttribute("hidden"));
  // decals go on their own sheet first, so the body mask can trim them off the cowl
  const ctxMain=ctx;
  const dcv=document.createElement("canvas"); dcv.width=dcv.height=N;
  ctx=dcv.getContext("2d");
  for(const el of layers){
    const b=boxOf(el,N);
    if(!b.w||!b.h) continue;
    if(/_text$/.test(el.id)) continue;           // drawn below, so the real font is used
    try{ const im=await svgToImg(el,Math.round(b.w),Math.round(b.h));
         ctx.drawImage(im,b.x,b.y,b.w,b.h); }catch(e){}
  }
  const tl=veh.querySelector('svg[id$="_text"]:not([hidden])');
  if(tl){
    const t=tl.querySelector(".ctxt");
    const txt=t&&t.textContent;
    if(txt){
      const b=boxOf(tl,N);
      const vb=tl.getAttribute("viewBox").split(" ").map(Number);
      const kx=b.w/vb[2], ky=b.h/vb[3];
      const bx=+t.getAttribute("x"), by=+t.getAttribute("y");
      const fs=+t.getAttribute("font-size");
      const fam2=t.getAttribute("font-family")||"Impact, sans-serif";
      const cstt=getComputedStyle(t);
      ctx.save();
      ctx.translate(b.x,b.y); ctx.scale(kx,ky);
      ctx.translate(-vb[0],-vb[1]);      // the viewBox origin is not 0,0
      ctx.translate(S.tx,S.ty);
      ctx.translate(bx,by); ctx.rotate(S.rot*Math.PI/180); ctx.scale(S.scale,S.scale);
      ctx.textAlign="center"; ctx.textBaseline="alphabetic";
      const fw=(cstt.fontWeight||t.getAttribute("font-weight")||"400");
      ctx.font=fw+" "+fs+"px "+fam2;
      // same looks as the preview: fill / outline+fill / outline around cut letters / cut only
      const look=t.dataset.look||"fill", sw=+(t.dataset.sw||0);
      ctx.lineJoin="round";
      if(look==="both"||look==="ring"){ ctx.strokeStyle=t.dataset.out; ctx.lineWidth=sw; ctx.strokeText(txt,0,0); }
      if(look==="both"||look==="fill"){ ctx.fillStyle=t.dataset.fill; ctx.fillText(txt,0,0); }
      if(look==="ring"){ ctx.globalCompositeOperation="destination-out"; ctx.fillStyle="#000"; ctx.fillText(txt,0,0); ctx.globalCompositeOperation="source-over"; }
      ctx.restore();
    }
  }
  if(A.mask){ try{ const mk=await loadImg(A.mask); ctx.globalCompositeOperation="destination-in"; ctx.drawImage(mk,0,0,N,N); }catch(e){} }
  ctxMain.drawImage(dcv,0,0);
}
async function snapshot(){
  const N=1000;
  const cv=document.createElement("canvas");
  cv.width=N; cv.height=N;
  const ctx=cv.getContext("2d");
  ctx.fillStyle="#0d0f11"; ctx.fillRect(0,0,cv.width,cv.height);
  await drawHood(ctx,N);
  return new Promise(res=>cv.toBlob(b=>res(b),"image/png"));
}

// what the customer is buying: the hood decal, the pair of hood-side decals, or both
// ready designs: hood $100, sides $100, both $180. Personalised: $150, $150, $250.
const PRICE0={library:{hood:99,side:99,both:149},custom:{hood:149,side:149,both:199}};
// a truck can carry its own prices (2021+ F-150: side decals $75, added to any hood decal at $75, no discount);
// those orders use their own Shopify variants, named with the truck's prefix
const prices=()=>((FAM[fam]||{}).price)||PRICE0;
// 2021+ F-150: no personalised side decals. A personalised hood can take ready side decals
// from the library (+$75), and their text is charged like on ready designs
const libSides=()=>!!((FAM[fam]||{}).customSideLib);
function packs(){
  const cus=S.mode==="custom", P=prices()[cus?"custom":"library"];
  const L=prices().library, add=P.both-P.hood, save=P.hood+((cus&&libSides())?L.side:P.side)-P.both;
  const all=[{id:"hood",label:"Hood decal \u2014 $"+P.hood},
          {id:"side",label:"Hood side decals \u2014 $"+P.side},
          {id:"both",label:"Hood + side decals \u2014 $"+P.both+(save>0?" (save $"+save+")":" (side decals +$"+add+")")}];
  if((FAM[fam]||{}).noSide) return all.filter(o=>o.id==="hood");
  return (cus&&libSides()) ? all.filter(o=>o.id!=="side") : all;
}
const PACKS=[{id:"hood",label:"Hood decal"},{id:"side",label:"Hood side decals"},{id:"both",label:"Hood + side decals"}];
const hasHood=()=>S.pack==="hood"||S.pack==="both";
// designs drawn in two graphic colours (Bronco Raptor: red + white) get a second colour choice
// Bronco: a front decal and a lower part drawn in different graphic colours (white front, red flames)
// keep their own colours: the lower part's graphics take the 2nd graphics colour
const pairTwo=()=>{ const F=FAM[fam]||{}, t=F.two||{}, gc=F.gcol||{};
  return !!F.splitGfx && S.mode==="library" && hasHood() && hasSide() && !!S.des && !!S.side &&
    !t[S.des] && !t[S.side] && !!gc[S.des] && !!gc[S.side] && gc[S.des]!==gc[S.side]; };
const hasTwo=()=>{ const t=((FAM[fam]||{}).two||{});
  return S.mode==="library" && ((hasHood()&&!!S.des&&!!t[S.des]) || (hasSide()&&!!S.side&&!!t[S.side]) || pairTwo()); };
// a ready design with no graphics at all (Bronco Raptor #01 plain, #61) has no graphics colour to pick
function noGfx(){
  if(!(hasHood()&&S.mode==="library"&&S.des)) return false;
  if(hasSide()&&((FAM[fam]||{}).sideAcc||S.side)){
    // side layers drawn like hood layers (main vinyl + graphics): look at both
    const sl=S.side&&document.getElementById("d_"+fam+"_"+S.side);
    if(!sl||!sl.querySelector(".pn")||sl.querySelector(".gf,.gs,.gf2,.gs2,.bk")||(FAM[fam]||{}).sideAcc) return false;
  }
  const F=FAM[fam]||{}; if((F.lock&&F.lock[S.des])||(F.inv&&F.inv[S.des])) return false;
  if((F.plain||[]).includes(S.des)) return true;
  const lay=document.getElementById("d_"+fam+"_"+S.des); if(!lay) return false;
  return !lay.querySelector(".gf,.gs,.gf2,.gs2,.bk");
}
const hasSide=()=>S.pack==="side"||S.pack==="both";
// Dodge: designs that are graphics only (no main vinyl) and designs that offer no Cut-out
const noMainNow=()=>S.mode==="library"&&!!S.des&&((FAM[fam]||{}).noMain||[]).includes(S.des);
const nocutNow=()=>S.mode==="library"&&!!S.des&&((FAM[fam]||{}).nocut||[]).includes(S.des);
// a design starts in its own colours (Sarya's starting colours); the customer can change them after
function applyStart(v){ const F=FAM[fam]||{}, st=(F.start||{})[v], nm=(F.noMain||[]).includes(v);
  if(nm){ if(S.main!=="cutout") S._mp=S.main; S.main="cutout"; }
  else if(S.main==="cutout"&&S._mp!==undefined){ S.main=S._mp; delete S._mp; }
  if(st&&!S.touched){ if(st.main&&!nm) S.main=st.main; if(st.acc) S.acc=st.acc; if(st.acc2) S.acc2=st.acc2; }
  if((F.nocut||[]).includes(v)){ if(S.main==="cutout"&&!nm) S.main=(st&&st.main)||"black"; if(S.acc==="cutout") S.acc=(st&&st.acc)||"white"; if(S.acc2==="cutout") S.acc2=(st&&st.acc2)||"white"; }
}
// complete sets: a hood design and the side / lower design drawn with it on the same sheet
const setSides=id=>(((FAM[fam]||{}).match||{})[id])||[];
function setFront(sid){ const m=(FAM[fam]||{}).match||{}; let best=null;
  for(const h in m){ const i=m[h].indexOf(sid); if(i===0) return h; if(i>0&&!best) best=h; } return best; }
const nounSide=()=>((FAM[fam]||{}).sideNoun)||"hood side decals";
const nounHood=()=>((FAM[fam]||{}).hoodNoun)||"hood decal";
const STAR='<span class="setstar" title="Comes as a complete set">\u2605</span>';
const desList=sec=>((FAM[fam]||{}).designs||[]).filter(d=>(d.sec||"hood")===sec);
const desOf=id=>((FAM[fam]||{}).designs||[]).find(d=>d.id===id);
// text: one part $20, both parts $30 (included on personalised designs)
const hText=()=>hasHood()&&S.mode==="library"&&S.addtext==="yes";
const sText=()=>hasSide()&&(S.mode==="library"||libSides())&&S.saddtext==="yes";
function quote(){
  const pk=S.pack||"hood";
  if(S.mode==="custom") return prices().custom[pk]+(sText()?20:0);
  const t=(hText()?1:0)+(sText()?1:0);
  return prices().library[pk]+(t===2?30:t===1?20:0);
}
function cfgKey(){
  const k=cfgKey0(), pre=((FAM[fam]||{}).vprefix)||"";
  // hood-only orders cost the same on every truck and share the same variants
  return (pre && !/^hood/.test(k)) ? pre+k : k;
}
function cfgKey0(){
  const pk=S.pack||"hood";
  if(S.mode==="custom") return pk+"_custom"+(sText()?"_stext":"");
  const h=hText(), sd=sText();
  if(pk==="hood") return h?"hood_text":"hood";
  if(pk==="side") return sd?"side_text":"side";
  return h&&sd?"both_text2":h?"both_htext":sd?"both_stext":"both";
}
function syncCart(price){
  try{
    const V=window.__HOOD_VARIANTS__||{};
    const vid=V[cfgKey()];
    // the theme renders more than one /cart/add form (payment terms, dynamic checkout).
    // the real one is the form that owns the "Add to cart" submit button.
    const forms=[...document.querySelectorAll('form[action*="/cart/add"]')];
    const form=forms.find(f=>f.querySelector('[name="add"]'))||forms[forms.length-1];
    if(!form) return;
    if(vid){
      let idIn=form.querySelector('input[name="id"], select[name="id"]');
      // Dawn disables this input when the default variant looks unavailable
      if(idIn) idIn.removeAttribute("disabled");
      if(!idIn){ idIn=document.createElement("input"); idIn.type="hidden"; idIn.name="id"; form.appendChild(idIn); }
      idIn.value=vid;
    }
    // the customer's choices travel with the line item
    const props={
      "Vehicle": [S.year,(D.fit.models[S.model]||{}).label,trimLabel()].filter(Boolean).join(" \u00b7 "),
      "Hood": S.hoodname||"",
      "Vehicle colour": colName("veh"),
      "Order": (PACKS.find(p=>p.id===S.pack)||{label:""}).label.split(" \u2014")[0],
      "Hood decal design": !hasHood()?"":(S.mode==="custom"?"Personalized design":(S.des?((desOf(S.des)||{}).label||""):"")),
      "Hood side decal design": hasSide()&&S.side?((desOf(S.side)||{}).label||""):"",
      "Vinyl colour": (FAM[fam]&&FAM[fam].sideMono&&!hasHood())?"":colName("main"),
      [hasTwo()?"1st graphics colour":"Graphics colour"]: ((FAM[fam]&&FAM[fam].sideMono&&!hasHood()&&!FAM[fam].sideAcc)||noGfx())?"":colName("acc"),
      "2nd graphics colour": hasTwo()?colName("acc2"):"",
      "Side decal colour": (FAM[fam]&&FAM[fam].sideMono&&hasSide())?colName("scol"):"",
      "Border": !hasHood()?"":((S.mode!=="custom"&&FAM[fam]&&FAM[fam].lock&&FAM[fam].lock[S.des])?"Built into design (graphics colour)":(S.border==="yes"?("Yes \u2014 "+colName("bcol")):"No")),
      "Text": !hasHood()?"":(S.addtext==="yes"||S.mode==="custom")?(S.txtsrc==="popular"?(S.badge?("Popular: "+((BADGES[S.badge]||{}).label||S.badge)):""):($("ctext")?$("ctext").value:"")):"",
      "Your description": ($("cdesc")&&$("cdesc").value.trim())||"",
      "Side decal text": (hasSide()&&S.saddtext==="yes")?(($("stext").value||"").trim()):"",
      "Side text style": (hasSide()&&S.saddtext==="yes"&&($("stext").value||"").trim())
          ? (sideFontName()+" \u00b7 "+(S.sduo==="two"?(colName("stout")+" outline + "+colName("stcol")+" fill"):colName("stcol"))+" \u00b7 "+Math.round(S.ssc*100)+"% \u00b7 "+Math.round(S.sro)+"\u00b0 \u00b7 mirrored both sides") : "",
      "Side artwork": (S.mode==="custom"&&hasSide()&&sideImgOK()&&$("sfile").files&&$("sfile").files[0])
          ? ($("sfile").files[0].name+" \u2014 "+Math.round(S.siscale*100)+"%, "+Math.round(S.sirot)+"\u00b0, mirrored both sides") : "",
      "Text colours": hasHood()&&(S.addtext==="yes"||S.mode==="custom")
          ? (S.txtduo==="two" ? (colName("tout")+" outline + "+colName("tcol")+" fill") : colName("tcol")) : "",
      "Text font": hasHood()&&(S.addtext==="yes"||S.mode==="custom")&&S.txtsrc==="type"
          ? (($("cfont")&&$("cfont").value==="__other")?($("cfontother").value||""):($("cfont")?$("cfont").selectedOptions[0].textContent:"")) : "",
      "Text size / angle": hasHood()&&(S.addtext==="yes"||S.mode==="custom")
          ? (Math.round((S.txtsrc==="popular"&&S.badge?S.bscale:S.scale)*100)+"% \u00b7 "+Math.round(S.txtsrc==="popular"&&S.badge?S.brot:S.rot)+"\u00b0") : "",
      "Uploaded artwork": (S.mode==="custom"&&hasHood()&&$("cfile")&&$("cfile").files&&$("cfile").files[0])
          ? ($("cfile").files[0].name+" \u2014 placed at "+Math.round(S.iscale*100)+"%, "+Math.round(S.irot)+"\u00b0") : "",
      "Build code": $("spec")?$("spec").textContent:"",
      "Quoted price": "$"+price.toFixed(2)
    };
    if(((FAM[fam]||{}).words||[]).length) for(const k of Object.keys(props)){ const v=props[k]; delete props[k]; props[T(k)]=(k==="Order")?T(v):v; }
    // Shopify stores a file attached to the line item, but only on a real form post
    const src=$("cfile");
    if(src){
      let fileIn=form.querySelector('input[data-hb-file]');
      if(!fileIn){
        fileIn=document.createElement("input");
        fileIn.type="file"; fileIn.name="properties[Artwork file]";
        fileIn.setAttribute("data-hb-file","1");
        fileIn.style.display="none";
        form.appendChild(fileIn);
      }
      if(src.files&&src.files.length&&S.mode==="custom"&&hasHood()){
        try{ const dt=new DataTransfer(); dt.items.add(src.files[0]); fileIn.files=dt.files;
             form.setAttribute("enctype","multipart/form-data"); }catch(e){}
      } else {
        try{ fileIn.value=""; }catch(e){}
      }
    }
    // the side-decal artwork travels as its own file
    {const ss=$("sfile"); let fi=form.querySelector('input[data-hb-sfile]');
     if(!fi){ fi=document.createElement("input"); fi.type="file"; fi.name="properties[Side artwork file]";
       fi.setAttribute("data-hb-sfile","1"); fi.style.display="none"; form.appendChild(fi); }
     if(ss&&ss.files&&ss.files.length&&S.mode==="custom"&&hasSide()&&sideImgOK()){
       try{ const dt=new DataTransfer(); dt.items.add(ss.files[0]); fi.files=dt.files; form.setAttribute("enctype","multipart/form-data"); }catch(e){} }
     else { try{ fi.value=""; }catch(e){} }}
    form.querySelectorAll('input[data-hb-prop]').forEach(e=>e.remove());
    Object.keys(props).forEach(k=>{
      if(!props[k]) return;
      const i=document.createElement("input");
      i.type="hidden"; i.name="properties["+k+"]"; i.value=props[k]; i.setAttribute("data-hb-prop","1");
      form.appendChild(i);
    });
  }catch(e){ console.error('syncCart failed:', e && e.message); }
}
function trimLabel(){
  const ts=(D.fit.trims[S.model]||[]); const t=ts.find(x=>x.id===S.trim);
  return t?t.label:(S.trim==="__other"?"Other / not listed":"");
}
function colName(k){
  if(S[k]==="cutout") return "Cut-out (paint shows through)";
  if(S[k]==="other") return (S[k+"_txt"]||"custom colour");
  const all=[].concat(VIN,COL,VEH);
  const f=all.find(c=>c&&c.id===S[k]);
  return f?f.label:(S[k]||"");
}
// a truck can rename the add-on: on the Bronco it is the lower part of the hood, not hood side decals
const WORDS0=new WeakMap();
const T=t=>{ for(const [a,b] of (((FAM[fam]||{}).words)||[])) t=t.split(a).join(b); return t; };
function relabel(){
  const root=document.querySelector(".hood-builder #steps")||document.getElementById("steps"); if(!root) return;
  const tw=document.createTreeWalker(root,NodeFilter.SHOW_TEXT); let n;
  while((n=tw.nextNode())){ if(!WORDS0.has(n)) WORDS0.set(n,n.nodeValue);
    const t=T(WORDS0.get(n)); if(n.nodeValue!==t) n.nodeValue=t; }
}
function render(){ render0(); relabel(); }
function render0(){
 if(!FAM[fam]){ return; }
 VEH=vehList(); const veh=pick(VEH,"veh");
 // a truck whose photo runs taller than the screen (Bronco Raptor) is shown a little smaller
 {const stg=document.querySelector(".hood-builder .stage"); const k=(FAM[fam]||{}).stageScale;
  if(stg){ stg.style.width=k?(k*100)+"%":""; stg.style.marginInline=k?"auto":""; }}
 const m=pick(VIN,"main"), a=pick(VIN,"acc");
 const bc=pick(VIN,"bcol");
 const x=pick(VIN,"tcol");
 const r=document.documentElement.style;
 r.setProperty("--veh",veh?veh.hex:"#F2F2F2");
 r.setProperty("--main",m&&m.cut?"transparent":(m?m.hex:"#1C1C1C"));
 r.setProperty("--acc",a&&a.cut?"transparent":(a?a.hex:"#C8102E"));
 const a2=pick(VIN,"acc2"); r.setProperty("--acc2",a2&&a2.cut?"transparent":(a2?a2.hex:"#FFFFFF"));
 r.setProperty("--bcol",bc&&bc.cut?"transparent":(bc?bc.hex:"#C8102E"));
 r.setProperty("--tcol",x&&x.cut?"transparent":(x?x.hex:"#C8102E"));
 {const sc=pick(COL,"scol"); r.setProperty("--scol",sc?sc.hex:"#ED1C24");}

 const s1done=!!(S.year&&S.model&&S.trim&&S.hoodOK&&S.veh);
 $("s1sum").hidden=!s1done;
 if(s1done){
   const mdl=D.fit.models[S.model]?D.fit.models[S.model].label:S.model;
   const tr=(D.fit.trims[S.model]||[]).find(t=>t.id===S.trim);
   const pc=(PAINT[S.veh]||[""])[0];
   $("s1txt").textContent=S.year+" \u00b7 "+mdl+" \u00b7 "+(tr?tr.label:S.trim)+" \u00b7 "+S.hoodname+(pc?" \u00b7 "+pc:"");
 }
 $("s1in").hidden=s1done&&!S.s1open;
 $("hoodwrap").hidden=!S.trim;
 $("vehcol").hidden=!S.hoodOK;
 $("s1next").hidden=!(S.hoodOK&&S.veh);
 $("s4").classList.toggle("locked",!S.veh);
 $("s5").classList.toggle("locked",!S.veh);
 if(S.mode==="custom"&&libSides()&&S.pack==="side"){ S.pack="hood"; S.side=""; S.saddtext="no"; }
 const hoodDone=!hasHood()||(S.mode==="library"&&!!S.des)||S.mode==="custom";
 const sideDone=!hasSide()||(S.mode==="custom"&&!libSides())||!!S.side;
 const desDone=hoodDone&&sideDone;
 if(!hasHood()&&S.addtext!=="no"){ S.addtext="no"; }
 $("s7").classList.toggle("locked",!(S.mode&&desDone));
 [["s1",S.hoodOK],["s4",desDone],["s7",(S.addtext==="yes"||S.saddtext==="yes"||S.mode==="custom")],
  ["s5",desDone]]
   .forEach(([id,ok])=>$(id).classList.toggle("done",!!ok));

 $("veil").hidden=!!S.trim;
 $("cap").hidden=!S.hoodname; $("cap").textContent=S.hoodname||"";
 $("packwrap").hidden=!S.mode;
 {const P=prices(); $("from-lib").textContent="Starts from $"+Math.min(P.library.hood,P.library.side);
  $("from-cus").textContent="Starts from $"+Math.min(...["hood","side"].map(k=>P.custom[k]).filter(v=>v!=null));}
 $("g-lib").hidden=!(hasHood()&&S.mode==="library");
 $("g-custom").hidden=!(hasHood()&&S.mode==="custom");
 $("g-sidelib").hidden=!(hasSide()&&(S.mode==="library"||(S.mode==="custom"&&libSides())));
 $("g-scustom").hidden=!(hasSide()&&S.mode==="custom"&&!libSides());
 {const noimg=!!(FAM[fam]&&FAM[fam].sideNoImage);
  $("scus-upload").hidden=noimg; $("scus-textonly").hidden=!noimg;
  $("scus-title").textContent=noimg?"Hood side decals \u2014 your text":"Hood side decals \u2014 your artwork";}
 $("g-cdesc").hidden=S.mode!=="custom";
 $("htextwrap").hidden=!hasHood();
 $("stextwrap").hidden=!hasSide()||!!(FAM[fam]||{}).noSideText;
 if((FAM[fam]||{}).noSideText&&S.saddtext!=="no") S.saddtext="no";
 $("htextlb").textContent=hasSide()?"Text on the hood decal":"Add text";

 const useCut=a&&a.cut;
 const custom=S.mode==="custom";
 const active = !hasHood() ? null : (custom ? "blank" : (S.mode==="library"&&S.des ? S.des : null));
 // personalised side decals start from the plain side panels
 const activeSide = !hasSide() ? null : ((custom&&!libSides()) ? ((FAM[fam]||{}).plainSide||"style_39") : (S.side||null));
 const mainCut = !!(m && m.cut);
 if(mainCut) S.border="no";
 const lockNow = !!(FAM[fam].lock && FAM[fam].lock[S.des]);
 // a design whose edges must be the graphics colour forces the border on; when the
 // customer moves to another design, give them back the border choice they had
 // designs whose edge strips are part of the artwork (graphics colour) have no border
 // choice at all; the customer's own border setting is left untouched for the next design
 ORDERK.forEach(k=>{
   const el=$("d_"+fam+"_"+k); if(!el) return;
   const gko=el.querySelector(".gko");
   if(gko){ if(useCut) gko.setAttribute("mask","url(#gk_"+fam+"_"+k+")"); else gko.removeAttribute("mask"); }
   const lk = !!(FAM[fam].lock && FAM[fam].lock[k]);
   // the sheet trims the vinyl back from the edge strips; that trim only applies when the
   // strips are showing (border on, or strips built into the design)
   el.querySelectorAll(".gclip").forEach(g=>{ const c=g.getAttribute("data-clip"); if(!c) return;
     if(S.border==="yes"||lk) g.setAttribute("clip-path",c); else g.removeAttribute("clip-path"); });
   el.classList.toggle("b-on", S.border==="yes" && !lk);
   el.classList.toggle("b-acc", lk);
   // second colour cut out: the design is shown as drawn on the sheet - artwork in the
   // main colour, nothing behind it - including on the designs whose colours are swapped
   el.classList.toggle("acc-cut", !!useCut);
   // 2021+ designs carry their own cut-out masks: main vinyl cut keeps only the graphics,
   // graphics cut punches them through the main vinyl
   if(FAM[fam].dynMask){
     el.querySelectorAll("[data-mask]").forEach(g=>{ if(mainCut) g.setAttribute("mask",g.dataset.mask); else g.removeAttribute("mask"); });
     const g2el = k===activeSide && ((hasHood() && S.mode==="library" && !!((FAM[fam].two||{})[S.des]) && ((FAM[fam].gcol||{})[k]==="white")) || pairTwo());
     const gcut = g2el ? !!(a2&&a2.cut) : useCut;
     el.querySelectorAll("[data-gmask]").forEach(g=>{ if(gcut) g.setAttribute("mask",g.dataset.gmask); else g.removeAttribute("mask"); });
     el.querySelectorAll("[data-g2mask]").forEach(g=>{ if(a2&&a2.cut) g.setAttribute("mask",g.dataset.g2mask); else g.removeAttribute("mask"); });
   }
   // with a two-colour hood (red 1st, white 2nd), the white parts of a one-colour side decal
   // follow the 2nd colour, so white stays white on both
   {const t=(FAM[fam].two||{}), gc=(FAM[fam].gcol||{});
    el.classList.toggle("g2", k===activeSide && ((hasHood() && S.mode==="library" && !!t[S.des] && gc[k]==="white") || pairTwo()));}
   if(k===active||k===activeSide) el.removeAttribute("hidden"); else el.setAttribute("hidden","");
 });
 {const pop=(S.txtsrc==="popular"&&S.badge);
  const sc=pop?S.bscale:S.scale, ro=pop?S.brot:S.rot;
  $("csizen").textContent=Math.round(sc*100)+"%"; $("crotn").textContent=Math.round(ro)+"\u00b0";
  $("csize").value=Math.round(sc*100); $("crot").value=Math.round(ro);}
 // uploaded image on the vinyl (personalised path only)
 document.querySelectorAll("[id$=_img]").forEach(e=>e.setAttribute("hidden",""));
 $("imgctl").hidden=!(custom&&hasHood()&&UIMG);
 if(custom&&hasHood()&&UIMG){ const il=$("d_"+fam+"_img"); const ui=il.querySelector(".uimg"); const vbv=il.getAttribute("viewBox").split(" ").map(Number);
   const g=FAM[fam].geo; const w0=vbv[2]*0.45, h0=w0*UIH/UIW; const w=w0*S.iscale, h=h0*S.iscale;
   ui.setAttribute("href",UIMG); ui.setAttribute("width",w); ui.setAttribute("height",h);
   ui.setAttribute("x",g.x-w/2+S.ix); ui.setAttribute("y",g.y-h/2-vbv[3]*0.12+S.iy);
   ui.setAttribute("transform",`rotate(${S.irot} ${g.x+S.ix} ${g.y-vbv[3]*0.12+S.iy})`); ui.removeAttribute("hidden"); il.removeAttribute("hidden");
   $("isizen").textContent=Math.round(S.iscale*100)+"%"; $("irotn").textContent=Math.round(S.irot)+"\u00b0";
   // keep the sliders on the same value as the handles / pinch, or the next
   // slider touch would snap the image back to whatever the slider still held
   $("isize").value=Math.round(S.iscale*100); $("irot").value=Math.round(S.irot);
   const ih=HND(".ihandles");
   if(ih){ if(SEL==="img"){ ih.removeAttribute("hidden");
     const cx=g.x+S.ix, cy=g.y-vbv[3]*0.12+S.iy, ang=S.irot*Math.PI/180;
     const gk=gapK(vbv[2]), rr=h/2+13*gk, hw=w/2+9*gk, hh=h/2, kk=handleK(vbv[2]);
     grabArea(ih.querySelector(".ihrot")).setAttribute("transform",
       "translate("+(cx+Math.sin(ang)*rr)+","+(cy-Math.cos(ang)*rr)+") scale("+kk+")");
     grabArea(ih.querySelector(".ihsize")).setAttribute("transform",
       "translate("+(cx+Math.cos(ang)*hw-Math.sin(ang)*hh)+","+(cy+Math.sin(ang)*hw+Math.cos(ang)*hh)+") scale("+kk+")");
   } else ih.setAttribute("hidden",""); } }
 $("accnote").hidden=!(custom&&hasHood()&&UIMG);
 // explain cut-out wherever it is currently selected
 [["g-main","main"],["g-acc","acc"],["g-tcol2","tcol"]].forEach(([host,key])=>{
   const el=$(host); if(!el) return;
   let n=el.parentElement.querySelector(".cutnote");
   if(S[key]==="cutout"){
     if(!n){ n=document.createElement("p"); n.className="hint cutnote"; el.parentElement.appendChild(n); }
     n.textContent="Cut-out \u2014 there is no vinyl in this area, so your own paint shows through. "+
       "It arrives already cut and pre-masked; nothing for you to cut or trim.";
   } else if(n) n.remove();
 });
 // ---- popular text badges ----
 const showBadges = hasHood() && (custom || (S.mode==="library" && S.addtext==="yes")) && S.txtsrc==="popular";
 
 if(showBadges && !$("g-badge").dataset.built){
   $("g-badge").innerHTML=BADGE_ORDER.map(id=>{
     const b=BADGES[id];
     const out=b.outer.map(d=>b.stroke?`<path d="${d}" fill="none" stroke="#C8102E" stroke-width="${b.stroke}" stroke-linejoin="round"/>`
                                      :`<path d="${d}" fill="#C8102E"/>`).join("");
     const inn=b.inner.map(d=>`<path d="${d}" fill="#1C1C1C"/>`).join("");
     return `<button class="opt badgebtn" type="button" data-k="badge" data-v="${id}" aria-pressed="${S.badge===id}">`+
            `<svg viewBox="${b.vb}" preserveAspectRatio="xMidYMid meet">${out}${inn}</svg></button>`;
   }).join("");
   $("g-badge").dataset.built="1";
 }
 if(showBadges){
   [...$("g-badge").querySelectorAll("button")].forEach(b=>b.setAttribute("aria-pressed",String((b.dataset.v||"")===S.badge)));

 }
 document.querySelectorAll("[id$=_badge]").forEach(e=>e.setAttribute("hidden",""));
 if(showBadges && S.badge){
   const bl=$("d_"+fam+"_badge"), b=BADGES[S.badge];
   const vbb=bl.getAttribute("viewBox").split(" ").map(Number), g=FAM[fam].geo;
   const oc=pick(TOUT,"tout"), ic=pick(VIN,"tcol");
   // a Cut-out part has no colour of its own: draw it with no paint at all
   const ohex=oc?(oc.cut?"none":oc.hex):"#C8102E", ihex=ic?(ic.cut?"none":ic.hex):"#1C1C1C";
   const og=bl.querySelector(".bouter"), ig=bl.querySelector(".binner");
   if(og.dataset.b!==S.badge){
     og.innerHTML=b.outer.map(d=>b.stroke?`<path d="${d}" fill="none" stroke-width="${b.stroke}" stroke-linejoin="round"/>`
                                         :`<path d="${d}"/>`).join("");
     ig.innerHTML=b.inner.map(d=>`<path d="${d}"/>`).join("");
     og.dataset.b=S.badge;
   }
   const iCut=!!(ic&&ic.unknown===undefined&&S.tcol==="cutout");
   const two=S.txtduo==="two";
   og.querySelectorAll("path").forEach(p=>{ if(b.stroke) p.setAttribute("stroke",two?ohex:ihex); else p.setAttribute("fill",two?ohex:ihex); });
   ig.querySelectorAll("path").forEach(p=>p.setAttribute("fill",ihex));
   og.style.display=(b.one==="inner"&&!two)?"none":"";
   // fit the badge to a share of the vinyl width, then place / rotate / scale it
   // trucks drawn in their photo's own pixels (every hood but the 2015-2020 F-150): start the text
   // on the hood at the personalised-text spot, a bit narrower, instead of up under the cowl
   const fullStage=vbb[2]>=1000;
   // Sarya: 100% is the size that used to be 50%
   const bw=vbb[2]*(fullStage?0.2:0.275)*S.bscale, bh=bw*b.ratio;
   const sx=bw/(+b.vb.split(" ")[2]), sy=bh/(+b.vb.split(" ")[3]);
   const cx=g.x+S.bx, cy=g.y-(fullStage?0:vbb[3]*0.24)+S.by;
   const vx=+b.vb.split(" ")[0], vy=+b.vb.split(" ")[1];
   bl.querySelector(".bwrap").setAttribute("transform",
     `translate(${cx} ${cy}) rotate(${S.brot}) translate(${-bw/2} ${-bh/2}) scale(${sx} ${sy}) translate(${-vx} ${-vy})`);
   // cut-outs: single colour cut = whole badge cut; two colours = only that part is cut
   {const BL=textLook("tcol","tout","txtduo"), bw=bl.querySelector(".bwrap");
    bw.removeAttribute("opacity"); og.removeAttribute("mask"); og.removeAttribute("opacity"); ig.removeAttribute("opacity");
    if(BL.fillCut&&!BL.two) bw.setAttribute("opacity","0.001");
    else if(BL.outCut) og.setAttribute("opacity","0.001");
    else if(BL.fillCut){ ig.setAttribute("opacity","0.001");
      let mk=bl.querySelector("mask#bring_"+fam);
      if(!mk){ mk=document.createElementNS(SVGNS,"mask"); mk.id="bring_"+fam; mk.setAttribute("maskUnits","userSpaceOnUse");
        ["x","y"].forEach(a=>mk.setAttribute(a,"-100000")); ["width","height"].forEach(a=>mk.setAttribute(a,"200000"));
        let d=bl.querySelector("defs"); if(!d){ d=document.createElementNS(SVGNS,"defs"); bl.insertBefore(d,bl.firstChild); } d.appendChild(mk); }
      mk.innerHTML='<rect x="-100000" y="-100000" width="200000" height="200000" fill="#fff"/>'+
        b.inner.map(d=>`<path d="${d}" fill="#000" style="fill:#000!important;stroke:none!important"/>`).join("");
      og.setAttribute("mask","url(#bring_"+fam+")"); }}
   bl.removeAttribute("hidden");
   const bh2=HND(".bhandles");
   if(bh2&&SEL!=="badge") bh2.setAttribute("hidden","");
   else if(bh2){ bh2.removeAttribute("hidden");
     const gk=gapK(vbb[2]), ang=S.brot*Math.PI/180, rr=bh/2+13*gk, hw=bw/2+9*gk, hh=bh/2, kk=handleK(vbb[2]);
     grabArea(bh2.querySelector(".bhrot")).setAttribute("transform",
       "translate("+(cx+Math.sin(ang)*rr)+","+(cy-Math.cos(ang)*rr)+") scale("+kk+")");
     grabArea(bh2.querySelector(".bhsize")).setAttribute("transform",
       "translate("+(cx+Math.cos(ang)*hw-Math.sin(ang)*hh)+","+(cy+Math.sin(ang)*hw+Math.cos(ang)*hh)+") scale("+kk+")");
   }
 }
 // ---- text: type your own, or a popular one ----
 opts("g-txtsrc",SRCSEL,"txtsrc",false);
 const typing = S.txtsrc==="type";
 $("typewrap").hidden=!typing; $("popwrap").hidden=typing;
 if(typing && S.badge){ S.badge=""; S.bx=0; S.by=0; S.brot=0; S.bscale=1; }
 if(!typing && $("ctext") && $("ctext").value){ $("ctext").value=""; S.tx=0; S.ty=0; S.rot=0; S.scale=1; }
 opts("g-txtduo",DUO,"txtduo",false);
 if(S.txtduo==="two"&&S.tcol==="cutout"&&S.tout==="cutout") S.tout="black";
 opts("g-tcol2",VIN,"tcol",true,o=>o.cut&&S.txtduo==="two"&&S.tout==="cutout");
 $("toutwrap").hidden = S.txtduo!=="two";
 if(S.txtduo==="two") opts("g-tout",TOUT,"tout",true,o=>o.cut&&S.tcol==="cutout");
 const HL=textLook("tcol","tout","txtduo");

 const wantsText = hasHood() && (custom || (S.mode==="library" && S.addtext==="yes"));
 const txt = (wantsText && S.txtsrc!=="popular") ? ($("ctext").value||"").trim() : "";
 const font = fontValue();
 const t=$("d_"+fam+"_text").querySelector(".ctxt"), bx=+t.getAttribute("x"), by=+t.getAttribute("y");
 const tf = v => `translate(${S.tx*v[0]} ${S.ty*v[2]}) `;
 t.textContent = txt;
 t.setAttribute("font-family",font);
 paintText(t,HL);
 t.setAttribute("transform",
   `translate(${S.tx} ${S.ty}) rotate(${S.rot} ${bx} ${by}) `+
   `translate(${bx} ${by}) scale(${S.scale}) translate(${-bx} ${-by})`);
 document.querySelectorAll("[id$=_text]").forEach(e=>e.setAttribute("hidden",""));
 if(txt) $("d_"+fam+"_text").removeAttribute("hidden");
 // a cut-out shows through the mask, so the visible copy is invisible but still grabbable
 
 try{ const hl=HND(".thandles");
   const vbn2=$("d_"+fam+"_text").getAttribute("viewBox").split(" ").map(Number); if(hl){ if(txt){ hl.removeAttribute("hidden");
   if(SEL!=="text"){hl.setAttribute("hidden","");} else {
   const bb=t.getBBox();
   const gk=gapK(vbn2[2]);
   const ang=S.rot*Math.PI/180, dc=bb.height*0.35*S.scale, rr=bb.height*0.75*S.scale+13*gk;
   const kk=handleK(vbn2[2]);
   const rot=grabArea(hl.querySelector(".hrot")), sz=grabArea(hl.querySelector(".hsize"));
   // the visual centre of the text, turned with it (the text pivots on its baseline point)
   const cX=bx+S.tx+Math.sin(ang)*dc, cY=by+S.ty-Math.cos(ang)*dc;
   rot.setAttribute("transform","translate("+(cX+Math.sin(ang)*rr)+","+(cY-Math.cos(ang)*rr)+") scale("+kk+")");
   const hw=bb.width*0.5*S.scale+9*gk, hh=bb.height*0.4*S.scale;
   sz.setAttribute("transform","translate("+(bx+S.tx+Math.cos(ang)*hw-Math.sin(ang)*hh)+","+
     (by+S.ty+Math.sin(ang)*hw+Math.cos(ang)*hh)+") scale("+kk+")"); }
 } else hl.setAttribute("hidden",""); } }catch(e){}
 // knockout copy inside every design's mask
 ORDERK.forEach(k=>{
   const el=$("d_"+fam+"_"+k); if(!el) return;
   const kt=el.querySelector(".ktxt"); if(!kt) return;
   const c=[1,0,1,0], g=FAM[fam].geo;
   if((HL.fillCut||HL.outCut) && txt){
     const X=c[0]*bx+c[1], Y=c[2]*by+c[3];
     kt.textContent=txt; knockText(kt,HL,g.fs*0.16);
     kt.setAttribute("x",X); kt.setAttribute("y",Y);
     kt.setAttribute("font-size",g.fs);
     kt.setAttribute("font-family",font);
     kt.setAttribute("transform",
       `translate(${S.tx*c[0]} ${S.ty*c[2]}) rotate(${S.rot} ${X} ${Y}) `+
       `translate(${X} ${Y}) scale(${S.scale}) translate(${-X} ${-Y})`);
   } else kt.textContent="";
   // the badge, when its fill is set to cut-out
   const kb=el.querySelector(".kbadge");
   if(kb){
     const BL2=textLook("tcol","tout","txtduo");
     const bCut = (S.txtsrc==="popular" && S.badge && (BL2.fillCut||BL2.outCut));
     if(bCut){
       const bl=$("d_"+fam+"_badge"), bw=bl&&bl.querySelector(".bwrap");
       if(bw){
         const inner=bw.querySelector(".binner"), outer=bw.querySelector(".bouter");
         let d2="";
         // single-colour cut: the whole badge; two colours: just the part that is cut out
         const parts2 = !BL2.two ? (((BADGES[S.badge]||{}).one==="inner")?[inner]:[outer,inner]) : (BL2.outCut ? [outer] : [inner]);
         parts2.forEach(gp=>{ if(!gp) return;
           gp.querySelectorAll("path").forEach(pp=>{
             const sw=pp.getAttribute("stroke-width");
             d2+='<path d="'+pp.getAttribute("d")+'" fill="#000" style="fill:#000!important;'+(sw?'stroke:#000!important;stroke-width:'+sw+'px!important':'stroke:none!important')+'"'+
                 (sw?' stroke="#000" stroke-width="'+sw+'" stroke-linejoin="round"':'')+'/>';
           });
         });
         kb.innerHTML='<g transform="'+(bw.getAttribute("transform")||"")+'">'+d2+'</g>';
       }
     } else kb.innerHTML="";
   }
   // the cut changed: point the layer at the mask under a new name, so the browser redraws the hole
   { const tk=kt.parentNode; if(tk&&tk.id&&!el.hasAttribute("hidden")){ const sig=tk.innerHTML;
       if(tk.__sig!==sig){ tk.__sig=sig; const ref=el.querySelector('[mask="url(#'+tk.id+')"]');
         if(ref){ const base=tk.getAttribute("data-base")||tk.id; tk.setAttribute("data-base",base);
           tk.__n=(tk.__n||0)+1; tk.id=base+"_v"+tk.__n; ref.setAttribute("mask","url(#"+tk.id+")"); } } } }
 });



 if(!$("hoodpick").hidden) drawHoods();
 opts("g-border",BORDER,"border",false);
 opts("g-border2",BORDER,"border",false);
 opts("g-bcol",COL,"bcol",true);
 // 2021+ side decals are one colour, no cut-out, no border
 {const mono=!!(FAM[fam]&&FAM[fam].sideMono);
  $("wrap-scol").hidden=!(mono&&hasSide());
  if(mono&&hasSide()) opts("g-scol",COL0,"scol",true);
  $("wrap-main").hidden=mono&&!hasHood(); $("wrap-acc").hidden=(mono&&!hasHood()&&!((FAM[fam]||{}).sideAcc))||noGfx();
  // one graphics colour: "Graphics colour"; two: "1st" and "2nd graphics colour"
  $("lb-acc").textContent=hasTwo()?"1st graphics colour":"Graphics colour";
  $("lb-main").textContent=(mono&&hasSide())?"Hood vinyl colour (main)":"Vinyl colour (main)";}

 // a truck whose designs have no border (Bronco Raptor) never offers one
 const noBd=!!((FAM[fam]||{}).noBorder); if(noBd) S.border="no";
 $("wrap-bcol").hidden = S.border!=="yes" || lockNow || !hasHood() || noBd;
 $("wrap-border2").hidden = lockNow || mainCut || noBd;
 $("wrap-border").hidden = mainCut || noBd;
 $("wrap-acc2").hidden = !hasTwo();
 if(hasTwo()) opts("g-acc2",VIN,"acc2",true,o=>o.cut&&((S.main==="cutout"&&S.acc==="cutout")||nocutNow()));

 opts("g-addtext",(S.mode==="custom"?ADDT_FREE:ADDT),"addtext",false);
 $("textblock").hidden=!(S.addtext==="yes");
 opts("g-veh",VEH,"veh",true);
 opts("g-pack",packs(),"pack",false);
 opts("g-saddtext",(S.mode==="custom"&&!libSides()?ADDT_FREE:ADDT),"saddtext",false);
 opts("g-sduo",DUO,"sduo",false);
 if(S.sduo==="two"&&S.stcol==="cutout"&&S.stout==="cutout") S.stout="black";
 opts("g-stcol",VIN,"stcol",true,o=>o.cut&&S.sduo==="two"&&S.stout==="cutout");
 $("stoutwrap").hidden=S.sduo!=="two";
 if(S.sduo==="two") opts("g-stout",TOUT,"stout",true,o=>o.cut&&S.stcol==="cutout");
 drawSideArt();
 {// some trucks (F-150 Raptor) only pair side decals with the hood designs drawn for them
  const ok=(FAM[fam]||{}).sideOK, lim=!!(ok&&hasSide()&&hasHood()&&S.mode==="library");
  const hl=(lim?desList("hood").filter(d=>ok.includes(d.id)):desList("hood"))
    .map(d=>setSides(d.id).length?Object.assign({},d,{label:d.label+STAR}):d);
  opts("g-des",hl,"des",false);
  $("sideoknote").hidden=!lim;}
 {// side decals drawn on the same sheet as the chosen hood decal come first, marked as a matching set
  const mt=(hasHood()&&S.mode==="library"&&S.des&&((FAM[fam]||{}).match||{})[S.des])||[];
  const all=desList("side");
  const items=mt.length ? mt.map(id=>all.find(d=>d.id===id)).filter(Boolean).map(d=>Object.assign({},d,{label:d.label+'<span class="match">\u2605 Matching set</span>'}))
                           .concat(all.filter(d=>!mt.includes(d.id))) : all.map(d=>setFront(d.id)?Object.assign({},d,{label:d.label+STAR}):d);
  opts("g-side",items,"side",false);
  $("matchnote").hidden=!mt.length;}
 {// a design that comes as a complete set offers its other piece, one click away
  const P=prices().library, lib=S.mode==="library", sh=$("setnote-h"), ss=$("setnote-s");
  const mt=setSides(S.des), fr=S.side?setFront(S.side):null;
  const okF=id=>{const ok=(FAM[fam]||{}).sideOK; return !ok||ok.includes(id);};
  if(lib&&S.pack==="hood"&&S.des&&mt.length&&!(FAM[fam]||{}).noSide){
    sh.innerHTML='<p><b>\u2605 Best as a complete set.</b> This design is made to go with its matching '+nounSide()+'.</p>'+
      '<button class="opt setadd" type="button" data-k="setadd" data-v="side">Add the matching '+nounSide()+' (+$'+(P.both-P.hood)+')</button>';
    sh.hidden=false;
  } else sh.hidden=true;
  if(lib&&S.pack==="side"&&fr&&okF(fr)){
    const lab=((desOf(fr)||{}).label)||fr;
    ss.innerHTML='<p><b>\u2605 Best as a complete set.</b> This design is made to go with '+nounHood()+' '+lab+'.</p>'+
      '<button class="opt setadd" type="button" data-k="setadd" data-v="hood">Add '+nounHood()+' '+lab+' (+$'+(P.both-P.side)+')</button>';
    ss.hidden=false;
  } else ss.hidden=true;}
 if(lockNow){ if(S.main==="cutout")S.main="black"; if(S.acc==="cutout")S.acc="red"; }
 // a plain design is all main vinyl: cutting that out would leave nothing
 if(noGfx()&&S.main==="cutout") S.main="black";
 opts("g-main",VIN,"main",true,o=>o.cut&&(S.acc==="cutout"||lockNow||noGfx()||nocutNow()));
 opts("g-acc",VIN,"acc",true,o=>o.cut&&(S.main==="cutout"||lockNow||nocutNow()));
 $("wrap-main").hidden=$("wrap-main").hidden||noMainNow();
 document.querySelectorAll('[data-k="mode"]').forEach(b=>
   b.setAttribute("aria-pressed",S.mode===b.dataset.v));

 const price=quote();
 $("price").textContent="$"+price.toFixed(2);
 const cname=k=>S[k]==="other"?("OTHER("+((S[k+"_txt"]||"?").trim())+")"):String(S[k]||"").toUpperCase();
 const parts=[];
 if(S.year&&S.model)parts.push(S.year+"-"+S.model.toUpperCase());
 if(S.trim)parts.push(S.trim.toUpperCase());
 if(S.hoodOK)parts.push("HOOD-"+(S.hood||"std").toUpperCase());
 if(S.veh)parts.push("CAR-"+cname("veh"));
 parts.push("ORDER-"+(S.pack==="both"?"HOOD+SIDE":S.pack==="side"?"SIDE":"HOOD"));
 if(hText())parts.push("ADDED-TEXT");
 if(hasHood()&&(S.mode==="custom"||(S.mode==="library"&&S.addtext==="yes"))){
   if(S.badge)parts.push("BADGE-"+S.badge.toUpperCase()+"("+cname("bout")+"/"+cname("bin")+")-"+
     Math.round(S.bscale*100)+"%-"+Math.round(S.brot)+"deg");
   if(S.txtduo==="two")parts.push("TXT-OUTLINE-"+cname("tout"));
   if(S.mode==="custom")parts.push("HOOD-CUSTOM-DESIGN"); if(S.mode==="custom"&&UIMG)parts.push("IMG-"+Math.round(S.iscale*100)+"%-"+Math.round(S.irot)+"deg-"+Math.round(S.ix)+","+Math.round(S.iy));
   const tv=(S.txtsrc==="popular")?"":($("ctext").value||"").trim();
   if(tv)parts.push('TEXT-"'+tv+'"');
   if(tv){parts.push("FONT-"+($("cfont").value==="__other"?($("cfontother").value||"?"):$("cfont").selectedOptions[0].textContent.split(" \u2014")[0]).toUpperCase());
     parts.push("SIZE-"+Math.round(S.scale*100)+"%");
     if(S.rot)parts.push("ROT-"+S.rot+"deg");
     if(S.tx||S.ty)parts.push("POS-"+Math.round(S.tx)+","+Math.round(S.ty));}
   if(txt||S.badge)parts.push("TXTCOL-"+(x&&x.cut?"CUTOUT":cname("tcol")));}
 const lkB=S.mode!=="custom"&&FAM[fam]&&FAM[fam].lock&&FAM[fam].lock[S.des];
 if(hasHood()&&S.border==="yes"&&!lkB)parts.push("BORDERCOL-"+(bc&&bc.cut?"CUTOUT":cname("bcol")));
 if(hasHood()&&(S.des||S.mode==="custom"))parts.push("BORDER-"+(lkB?"INDESIGN":(S.border==="yes"?"YES":"NO")));
 // design numbers as the customer sees them, plus the page of the artwork sheet for production
 const dcode=(pre,id)=>{const d=desOf(id); if(!d) return "";
   return pre+"-STYLE"+String(d.num).padStart(2,"0")+(d.page?"(SHEET-P"+String(d.page).padStart(2,"0")+")":"(PLAIN)");};
 if(hasHood()&&S.mode==="library"&&S.des)parts.push(dcode("HOOD",S.des));
 if(hasSide()&&(S.mode==="library"||libSides())&&S.side)parts.push(dcode("SIDE",S.side));
 if(hasSide()&&S.mode==="custom"&&!libSides())parts.push("SIDE-CUSTOM-DESIGN"+(SIMG&&sideImgOK()?"(IMG-"+Math.round(S.siscale*100)+"%-"+Math.round(S.sirot)+"deg-"+Math.round(S.six)+","+Math.round(S.siy)+")":""));
 {const st=($("stext").value||"").trim();
  if(hasSide()&&S.saddtext==="yes"&&st){
   parts.push('SIDE-TEXT-"'+st+'"'); parts.push("SIDE-FONT-"+sideFontName().toUpperCase());
   if(S.sduo==="two")parts.push("SIDE-TXT-OUTLINE-"+cname("stout"));
   parts.push("SIDE-TXTCOL-"+cname("stcol")); parts.push("SIDE-TXT-"+Math.round(S.ssc*100)+"%-"+Math.round(S.sro)+"deg-"+Math.round(S.sx)+","+Math.round(S.sy)+"-MIRRORED");}}
 if(FAM[fam]&&FAM[fam].sideMono&&hasSide()&&(S.side||S.mode==="custom")) parts.push("SIDECOL-"+cname("scol"));
 // Lightning: the side strips' light-blue details are in the graphics colour
 if(FAM[fam]&&FAM[fam].sideAcc&&hasSide()&&S.side&&!hasHood()) parts.push("GFX-"+(a&&a.cut?"CUTOUT":cname("acc")));
 if((hasHood()&&(S.des||S.mode==="custom"))||(!(FAM[fam]&&FAM[fam].sideMono)&&hasSide()&&(S.side||S.mode==="custom"))){
   parts.push("MAIN-"+(noMainNow()?"NONE":(m&&m.cut?"CUTOUT":cname("main"))));
   if(!noGfx()) parts.push("GFX-"+(a&&a.cut?"CUTOUT":cname("acc")));
   if(hasTwo()) parts.push("GFX2-"+(a2&&a2.cut?"CUTOUT":cname("acc2")));}
 $("spec").textContent=parts.length?parts.join(" | "):"Complete the steps above.";
 syncHandles();
 // after #spec is written, so the Build code property matches what the customer sees
 syncCart(price);
}

document.addEventListener("input",e=>{
 const b=e.target.closest("input.othbox"); if(!b) return;
 S[b.dataset.ok+"_txt"]=b.value; const el=document.activeElement===b; render();
 if(el){const n=document.querySelector(`input.othbox[data-ok="${b.dataset.ok}"]`); if(n){n.focus();n.setSelectionRange(n.value.length,n.value.length);}}
});
document.addEventListener("click",e=>{
 const b=e.target.closest("button.opt,button.hood"); if(!b||b.disabled) return;
 const k=b.dataset.k,v=b.dataset.v; if(!k) return;
 if(k==="hood"){S.hood=v;const h=(D.hoods[S.model]||[]).find(x=>x[0]===v);
   S.hoodname=h?h[1]:v; pickFam();}
 else if(k==="veh"){S.veh=v; if(!S.touched) applyDefaults();}
 else if(k==="main"||k==="acc"||k==="acc2"){S[k]=v;S.touched=true;
   if(S.main==="cutout"&&S.acc==="cutout") S[k==="main"?"acc":"main"]="red";}
 else if(k==="setadd"){
   if(v==="side"){ const mt=setSides(S.des); S.pack="both"; if(mt.length) S.side=mt[0]; }
   else { const fr=setFront(S.side); S.pack="both"; if(fr) S.des=fr; }
 }
 else if(k==="des"&&S.mode==="library"&&S.pack==="both"){
   // picking a set design fills in its matching piece, unless the customer already chose a piece of their own
   const prev=setSides(S.des), mt=setSides(v);
   S.des=v; if(mt.length&&(!S.side||prev.includes(S.side))) S.side=mt[0];
 }
 else if(k==="side"&&S.mode==="library"&&S.pack==="both"){
   S.side=v; const fr=setFront(v), ok=(FAM[fam]||{}).sideOK;
   if(fr&&!S.des&&(!ok||ok.includes(fr))) S.des=fr;
 }
 else if(k==="pack"){
   const was=S.pack;
   S.pack=v;
   if(v==="both"&&S.mode==="library"){
     if(was==="hood"&&S.des&&!S.side&&setSides(S.des).length) S.side=setSides(S.des)[0];
     if(was==="side"&&S.side&&!S.des&&setFront(S.side)){ const ok=(FAM[fam]||{}).sideOK, fr=setFront(S.side); if(!ok||ok.includes(fr)) S.des=fr; }
   }
   {const ok=(FAM[fam]||{}).sideOK; if(ok&&v==="both"&&S.des&&!ok.includes(S.des)) S.des="";}
   if(!hasHood()){ S.des=""; S.addtext="no"; }
   if(!hasSide()){ S.side=""; S.saddtext="no"; }
 }
 else if(k==="saddtext"){ S.saddtext=v; if(v==="no"){ $("stext").value=""; S.sx=0;S.sy=0;S.sro=0;S.ssc=1; } }
 else if(k==="addtext"){S.addtext=v; if(v==="no"){S.badge="";S.txtsrc="type";if($("ctext"))$("ctext").value="";S.tx=0;S.ty=0;S.rot=0;S.scale=1;S.bx=0;S.by=0;S.brot=0;S.bscale=1;}}
 else if(k==="mode"){
   if(S.mode!==v) resetDesign();
   S.mode=v;
   // 2021+ F-150 has no personalised side decals on their own
   if(v==="custom"&&libSides()&&S.pack==="side") S.pack="hood";
 }
 else S[k]=v;
 // a design drawn in one graphic colour starts in its own colour (white or red, as on the sheet)
 // until the customer picks colours themselves
 if((k==="des"||k==="side")&&!S.touched){ const gc=((FAM[fam]||{}).gcol||{})[v];
   if(gc && !(k==="side"&&hasHood()&&S.des)) S.acc=gc;
   if(k==="des"&&((FAM[fam]||{}).two||{})[v]){ S.acc="red"; S.acc2="white"; }
   if(pairTwo()){ const g=(FAM[fam]||{}).gcol||{}; S.acc=g[S.des]; S.acc2=g[S.side]; } }
 if(k==="des"&&S.mode==="library") applyStart(v);
 render();
});
document.addEventListener("click",ev=>{
  const btn=ev.target.closest&&ev.target.closest('[name="add"]');
  if(!btn) return;
  const form=btn.closest('form[action*="/cart/add"]');
  if(!form) return;
  if(btn.dataset.hbGo==="1"){ delete btn.dataset.hbGo; return; }
  ev.preventDefault(); ev.stopImmediatePropagation();
  const old=btn.textContent;
  btn.textContent="Preparing your preview\u2026"; btn.disabled=true;
  (async()=>{
    try{
      const blob=await snapshot();
      if(blob){
        let pv=form.querySelector('input[data-hb-preview]');
        if(!pv){
          pv=document.createElement("input"); pv.type="file";
          pv.name="properties[Preview image]";
          pv.setAttribute("data-hb-preview","1"); pv.style.display="none";
          form.appendChild(pv);
        }
        const dt=new DataTransfer();
        dt.items.add(new File([blob],"hood-preview.png",{type:"image/png"}));
        pv.files=dt.files;
      }
    }catch(e){ console.warn("preview snapshot failed",e); }
    btn.textContent=old; btn.disabled=false;
    const hasFile=[...form.querySelectorAll('input[type=file]')].some(x=>x.files&&x.files.length);
    if(hasFile){
      form.setAttribute("enctype","multipart/form-data");
      form.submit();
    } else {
      btn.dataset.hbGo="1"; btn.click();
    }
  })();
},true);
loadFam("ram19").then(()=>{ORDERK=(FAM.ram19||{}).order||[]; document.querySelectorAll(".veh").forEach(v=>v.hidden=(v.dataset.fam!==fam)); render();});

})();
